@if (bontonPanel.isB2B()) {
<div class="flex flex-col flex-auto min-w-0 min-h-[calc(100vh-16rem)]">
    <form [formGroup]="formGroup" class="flex flex-col px-4 pt-5 white-bg rounded-lg -mt-20 shadow pb-5">
        <div class="flex flex-row">
            <mat-radio-group formControlName="type" (change)="optionChange($event.value)">
                <div class="flex flex-row space-x-8">
                    @for (ft of flightType; track ft) {
                    <mat-radio-button [value]="ft.id">
                        <span [ngClass]=" ft.id === selectedFlightType
                                ? 'primary-text font-semibold' : 'text-gray'
                                ">{{ ft.name }}</span></mat-radio-button>
                    }
                </div>
            </mat-radio-group>
        </div>
        <div class="flex flex-row space-x-3 mt-3 mb-5">
            @if (formGroup.get('type').value != 'mc') {
            <div class="flex flex-row items-center w-1/2"
                [ngClass]="(formGroup.get('fromCity')?.value === 'All Cities' ||  formGroup.get('toCity')?.value === 'All Cities') ? 'w-full' : ''">
                <div class="flex flex-col min-w-[49%] max-w-[49%] p-3 field-blue-bg rounded-lg -mr-3 cursor-pointer"
                    (click)="openFromCityDropdown()">
                    <span class="text-gray text-md">From</span>
                    <mat-select #fromCitySelect class="font-semibold"
                        (selectionChange)="onFromCitySelectionChange($event.value)" [matTooltip]="
                                        formGroup.get('fromCity')?.value === 'All Cities' ? '' : formGroup.get('fromCity').value.display_name +
                                        ', ' +
                                        formGroup.get('fromCity').value.country +
                                        ', ' +
                                        formGroup.get('fromCity').value.airport_name
                                    " [compareWith]="compareWith" formControlName="fromCity">
                        <mat-option>
                            <ngx-mat-select-search placeholderLabel="Search City"
                                noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                            </ngx-mat-select-search>
                        </mat-option>
                        @if (formGroup.get('type')?.value === 'ab') {
                        <mat-option [value]="'All Cities'">
                            <div class="flex flex-col h-15 justify-center w-[380px]">
                                <span class="font-medium">All Cities</span>
                                <span class="text-sm text-gray -mt-1"></span>
                            </div>
                        </mat-option>
                        }
                        @for (ct of fromCityList | async; track ct) {
                        <mat-option [ngClass]="{ hidden: ct?.id === formGroup?.get('toCity')?.value?.id }" [value]="ct">
                            <div class="flex flex-col h-15 justify-center">
                                <span class="font-medium">{{ ct.display_name }},
                                    {{ ct.country }}</span>
                                <span class="text-sm text-gray -mt-1">{{
                                    ct.airport_name
                                    }}</span>
                            </div>
                        </mat-option>
                        }
                    </mat-select>
                </div>
                <div (click)="switch()"
                    class="flex flex-row justify-center items-center w-9 h-9 white-bg rounded-full z-20 cursor-pointer"
                    [matTooltip]="'Switch'">
                    <mat-icon svgIcon="heroicons_outline:arrows-right-left" class="primary-text icon-size-4"></mat-icon>
                </div>
                <div class="flex flex-col min-w-[49%] max-w-[49%] p-3 pl-4 items-start field-blue-bg rounded-lg -ml-3 cursor-pointer"
                    (click)="openToCityDropdown()">
                    <span class="text-gray text-md">To</span>
                    <mat-select #toCitySelect class="font-semibold right-mat-select"
                        (selectionChange)="onToCitySelectionChange($event.value)" [matTooltip]="
                                        formGroup.get('toCity')?.value === 'All Cities' ? '' :  formGroup.get('toCity').value.display_name +
                                        ', ' +
                                        formGroup.get('toCity').value.country +
                                        ', ' +
                                        formGroup.get('toCity').value.airport_name
                                    " [compareWith]="compareWith" formControlName="toCity">
                        <mat-option>
                            <ngx-mat-select-search placeholderLabel="Search City"
                                noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                            </ngx-mat-select-search>
                        </mat-option>
                        @if (formGroup.get('type')?.value === 'ab') {
                        <mat-option [value]="'All Cities'">
                            <div class="flex flex-col h-15 justify-center w-[380px]">
                                <span class="font-medium">All Cities</span>
                                <span class="text-sm text-gray -mt-1"></span>
                            </div>
                        </mat-option>
                        }
                        @for (ct of toCityList | async; track ct) {
                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                            <div class="flex flex-col h-15 justify-center">
                                <span class="font-medium">{{ ct.display_name }},
                                    {{ ct.country }}</span>
                                <span class="text-sm text-gray -mt-1">{{
                                    ct.airport_name
                                    }}</span>
                            </div>
                        </mat-option>
                        }
                    </mat-select>
                </div>
            </div>
            }
            @if (formGroup.get('type').value != 'mc') {
            <div class="flex flex-row items-center w-90 space-x-3"
                [ngClass]="(formGroup.get('type').value == 'gi' || formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                <div class="flex flex-col w-[48%] field-blue-bg h-full rounded-lg p-3"
                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                    <div class="flex flex-row justify-between">
                        <span class="text-gray text-md">Departure</span>
                        @if (formGroup.get('type').value === 'ab') {
                        <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                        }
                    </div>
                    <div class="flex flex-row">
                        <input class="font-semibold"
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                            [min]="minDate" (click)="picker.open()"
                            [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''" [readonly]="true"
                            [matDatepicker]="picker" formControlName="departureDate" />
                    </div>
                    <mat-datepicker #picker></mat-datepicker>
                </div>
                }
                @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                <div class="w-[48%] field-blue-bg rounded-lg p-[10px]">
                    <span class="text-gray text-md">Departure</span>
                    <p-calendar class="fare_cal" [readonlyInput]="true" formControlName="departureDate"
                        [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                        [dateFormat]="'dd M yy'">
                        <ng-template pTemplate="date" let-date>
                            <span>
                                {{ date.day }}
                            </span>
                            @if (fareMap[getFormattedDateNew(date)]) {
                            <span [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                fareMap[getFormattedDateNew(date)].price }}</span>
                            }
                        </ng-template>
                    </p-calendar>
                </div>
                }
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex flex-col w-[48%] field-blue-bg rounded-lg p-3">
                    <div class="flex flex-row justify-between">
                        <span class="text-gray text-md">Return</span>
                        @if (formGroup.get('type').value === 'rt' || formGroup.get('type').value === 'gi') {
                        <mat-icon class="icon-size-4" (click)="cancelReturnDate()">cancel</mat-icon>
                        }
                    </div>
                    @if (formGroup.get('type').value == 'gi') {
                    <div>
                        <div class="flex flex-row w-full">
                            <input class="font-semibold w-full" [min]="formGroup.get('departureDate').value" [ngClass]="{
                                            hidden: formGroup.get('type').value !== 'rt' && formGroup.get('type').value !== 'gi'
                                        }" (click)="pickerRe.open()" [readonly]="true" [matDatepicker]="pickerRe"
                                formControlName="returnDate" />
                            @if (formGroup.get('type').value !== 'rt') {
                            <span
                                (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null"
                                class="font-semibold text-lg max-w-32 w-full">-</span>
                            }
                        </div>
                        <mat-datepicker #pickerRe></mat-datepicker>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'gi') {
                    <div class="relative">
                        @if (formGroup.get('type').value === 'ow') {
                        <div class="absolute z-10 left-0 top-0 font-bold">-
                        </div>
                        }
                        <p-calendar class="fare_cal" [readonlyInput]="true" formControlName="returnDate"
                            [showOtherMonths]="false" [selectOtherMonths]="false"
                            [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                            (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null; fetchReturnDateFares()">
                            <ng-template pTemplate="date" let-date>
                                <span>
                                    {{ date.day }}
                                </span>
                                @if (returnFareMap[getFormattedDateNew(date)]) {
                                <span
                                    [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                    returnFareMap[getFormattedDateNew(date)].price }}</span>
                                }
                            </ng-template>
                        </p-calendar>
                    </div>
                    }
                </div>
                }
            </div>
            }
            @if (formGroup.get('type').value === 'mc' && formDataList) {
            <div class="w-full space-y-3 flex flex-col">
                @for (formData of formDataList; track formData; let i = $index) {
                <div class="w-full flex">
                    <div class="flex w-[calc(100%-260px)] pr-3">
                        <div class="flex flex-row items-center w-[60%] pr-3">
                            <div class="flex flex-col min-w-[49%] max-w-[49%] w-full p-3 field-blue-bg rounded-lg -mr-3 cursor-pointer"
                                (click)="openFromMultiCityDropdown(i)">
                                <span class="text-gray text-md">From</span>
                                <mat-select #fromMultiCitySelect class="font-semibold"
                                    [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                    [compareWith]="compareWith" required>
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            [(ngModel)]="formData.filterfrom" [ngModelOptions]="{
                                                            standalone: true
                                                        }" (input)="
                                                            filterfrom(
                                                                $event.target.value,
                                                                formData,
                                                                'from'
                                                            )
                                                        ">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (ct of formData.fromListData; track ct) {
                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                        <div class="flex flex-col h-15 justify-center">
                                            <span class="font-medium">{{ ct.display_name }},
                                                {{ ct.country }}</span>
                                            <span class="text-sm text-gray -mt-1">{{ ct.airport_name }}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                            <div (click)="switch(i)"
                                class="flex flex-row justify-center items-center w-9 h-9 white-bg rounded-full z-20 cursor-pointer"
                                [matTooltip]="'Switch'">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="primary-text icon-size-4"></mat-icon>
                            </div>
                            <div class="flex flex-col min-w-[49%] max-w-[49%] p-3 pl-4 items-start field-blue-bg rounded-lg -ml-3 cursor-pointer"
                                (click)="openToMultiCityDropdown(i)">
                                <span class="text-gray text-md">To</span>
                                <mat-select #toMultiCitySelect class="font-semibold"
                                    [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                    [compareWith]="compareWith" required (ngModelChange)="changeValue($event, i, 'to')">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            [(ngModel)]="formData.filterto" [ngModelOptions]="{
                                                            standalone: true
                                                        }" (input)="
                                                            filterfrom(
                                                                $event.target.value,
                                                                formData,
                                                                'to'
                                                            )
                                                        ">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @for (ct of formData.toListData; track ct) {
                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                        <div class="flex flex-col h-15 justify-center">
                                            <span class="font-medium">{{ ct.display_name }},
                                                {{ ct.country }}</span>
                                            <span class="text-sm text-gray -mt-1">{{ ct.airport_name }}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                        </div>
                        <div class="flex flex-row items-center space-x-3 w-[40%]">
                            <div class="flex flex-col w-full field-blue-bg rounded-lg p-3">
                                <span class="text-gray text-md">Departure</span>
                                <div class="flex flex-row" (click)="picker.open()">
                                    <input class="font-semibold" [ngModelOptions]="{ standalone: true }" [min]="
                                                        i == 0
                                                            ? minDate
                                                            : formDataList[i - 1]
                                                                  ?.departureDate
                                                    " [readonly]="true" [matDatepicker]="picker"
                                        [(ngModel)]="formData.departureDate" (ngModelChange)="changeDate($event, i)" />
                                </div>
                                <mat-datepicker #picker></mat-datepicker>
                            </div>
                        </div>
                    </div>
                    @if (i === 0) {
                    <div class="flex flex-col flex-grow p-3 field-blue-bg rounded-lg w-[240px]">
                        <span class="text-gray text-md">Travellers | Class</span>
                        <span
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value"
                            class="font-semibold cursor-pointer" (click)="travellersClass()">{{
                            formGroup.get("adult").value +
                            formGroup.get("child").value +
                            formGroup.get("infant").value
                            }}
                            Pax, {{ formGroup.get("cabinClass").value }}</span>
                    </div>
                    }
                    @if (i != 0 && i === formDataList.length - 1) {
                    <div class="flex items-center space-x-1">
                        @if (i > 1) {
                        <button mat-flat-button class="min-h-8 min-w-12 px-1 rounded-md bg-transparent"
                            (click)="removeCity(i)">
                            <mat-icon class="material-symbols-outlined primary-text"><span
                                    class="primary-text text-3xl">close</span></mat-icon>
                        </button>
                        }
                        @if (i < 4) { <button class="!border primary-border bg-transparent px-4 h-8 min-h-8 rounded-md"
                            (click)="addCity(i)">
                            <span class="primary-text font-medium">Add City</span>
                            </button>
                            }
                    </div>
                    }
                </div>
                }
            </div>
            }
            @if (formGroup.get('type').value != 'mc' && formGroup.get('type').value != 'gi') {
            <div class="flex flex-col flex-grow p-3 field-blue-bg rounded-lg"
                [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                <span class="text-gray text-md">Travellers | Class</span>
                <span
                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value"
                    class="font-semibold cursor-pointer" (click)="travellersClass()">{{
                    formGroup.get("adult").value +
                    formGroup.get("child").value +
                    formGroup.get("infant").value
                    }}
                    Pax, {{ formGroup.get("cabinClass").value }}</span>
            </div>
            }
        </div>
        <div class="flex justify-between">
            @if (formGroup.get('type').value != 'ab') {
            <div class="flex items-center gap-[16px] mb-4">
                <span class="font-medium text-gray">Special Fare:</span>
                <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                    formControlName="fareType" aria-label="Special Fare Selection">
                    @for (fare of fareType; track fare) {
                    <mat-button-toggle (click)="CheckFareTypeValidation()" [matTooltip]="fare.value"
                        class="rounded-[10px] h-[30px] text-[13px]" [value]="fare.key">
                        {{fare.key}}
                    </mat-button-toggle>
                    }
                </mat-button-toggle-group>
            </div>
            }
            @if (!wlSettingsDetails.is_wl && formGroup.get('type').value != 'ab') {
            <div class="flex items-center mb-4 gap-2 px-4 py-2 rounded-full cursor-pointer hover:bg-[#E8F1F8]"
                (click)="helpVideo('Flights')">
                <span class="font-medium primary-text text-sm">NEED HELP?</span>
                <mat-icon svgIcon="youtube" class="icon-size-5"></mat-icon>
            </div>
            }
        </div>
        <div class="flex flex-row justify-center items-center -mb-11 space-x-4">
            <button mat-flat-button class="primary-bg w-50 min-h-13 rounded-lg" (click)="detail()">
                <span class="white-text font-semibold text-lg">Search</span>
            </button>
            @if (formGroup.get('type').value === 'gi') {
            <button mat-flat-button class="white-bg w-50 min-h-13 rounded-lg button-primary-border"
                (click)="viewInquiry()">
                <span class="primary-text font-semibold text-lg">View Inquiry</span>
            </button>
            }
        </div>
    </form>
    <!-- RECENT FLIGHTS -->
    @if (recentFlightSearchList?.length > 0) {
    <div class="flex flex-col mt-12 space-y-3">
        <div class="pb-1">
            <div class="text-2xl font-bold">Recent Flight Search</div>
            <div class="text-sm text-gray">Compare your search history with starting fare</div>
        </div>
        <div class="grid grid-cols-3 gap-4">
            @for (rf of recentFlightSearchList; track rf) {
            <div class="flex flex-row space-x-3 white-bg w-full px-4 py-3 items-center rounded-lg shadow cursor-pointer"
                (click)="recentSearch(rf)">
                <div class="w-16">
                    <img loading="lazy" [src]="rf.airlineLogo" (error)="rf.airlineLogo = 'assets/icons/airline_placeholder.svg'" />
                </div>
                <div class="h-[80%] border-r border-gray-border"></div>
                <div class="flex flex-col w-full space-y-2">
                    <div class="flex flex-row items-center space-x-4 font-medium text-[#1C1C1C] text-lg">
                        <span>{{ rf.origin }}</span>
                        <img loading="lazy" class="icon-size-4"
                            src="assets/images/temp_images/flight_icons/take_off_icons.webp">
                        <span>{{ rf.destination }}</span>
                    </div>
                    <div class="flex flex-row justify-between">
                        <span class="text-[#696969] text-base font-medium">{{ rf.depDate | date : "dd-MM-yyyy"
                            }}</span>
                        <div>
                            <span class="pl-8 text-[#234977] text-sm font-normal">Fare starting at</span>
                            <span class="pl-[6px] text-[#234977] text-base font-semibold">{{ rf.currency }} {{
                                rf.flightRate }}</span>
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
    }
    <!-- AIR TICKET PRE PURCHASED BLOCK -->
    @if (PopularRecordsList) {
    <div class="flex flex-col mt-12 space-y-3 mx-2">
        <div class="flex justify-between items-center">
            <div>
                <div class="text-2xl font-bold">Popular Flight</div>
                <div class="text-sm text-gray">Discover popular flights that many people like for their trips right
                    now!</div>
            </div>
            <div
                class="min-w-50 border border-gray-border rounded-full white-bg px-4 h-10 flex justify-around items-center">
                <div class="font-semibold cursor-pointer" [ngClass]="tab === 0? 'primary-text':'text-gray'"
                    (click)="tabChanged(0)">Domestic</div>
                <div class="px-2">|</div>
                <div class="font-semibold cursor-pointer" [ngClass]="tab === 1? 'primary-text':'text-gray'"
                    (click)="tabChanged(1)">International</div>
            </div>
        </div>
        <div class="relative flex flex-col mt-6 mb-6 space-y-3">
            <div class="w-full">
                <ngx-slick-carousel class="carousel carousel-align-left pt-[20px]" #slickModal2="slick-carousel"
                    [config]="slideConfigFlight" [ngClass]="(PopularRecordsList) ? 'min-w-[1260px] min-h-[294px]' : ''">
                    @for (at of popularFlights; track $index) {
                    <div ngxSlickItem (click)="popular(at)"
                        class="slide flex flex-col flex-grow cursor-pointer justify-center items-center text-center">
                        <div class="">
                            <div class="rounded-xl items-center justify-center flex m-auto">
                                <div
                                    class="bg-[#FFFFFF]  border border-[#CFCFCF] w-[146px] h-[146px] flex justify-center rounded-[50%] p-5">
                                    <div class="flex mt-[0px] items-center justify-center rounded-lg">
                                        <img loading="lazy" class="w-[65px]" [src]="at.airlineLogo ? at.airlineLogo : 'assets/icons/airline_placeholder.svg'" (error)="at.airlineLogo = 'assets/icons/airline_placeholder.svg'">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-3 pb-3">
                            <div class="flex pt-1 items-center justify-center">
                                <div class="font-semibold text-xl primary-text font-sans">{{at.airline}}</div>
                            </div>
                            <div class="flex pt-1 items-center justify-center">
                                <div class="font-semibold text-xl theme-black-text font-sans">{{at.origin}}
                                </div>
                                <span class="font-semibold text-xl mx-1 font-sans">-</span>
                                <div class="font-semibold text-xl font-sans theme-black-text">{{ at.destination
                                    }}</div>
                            </div>
                            <div class="pt-1 text-center w-[200px]">
                                <span class="font-sans font-bold text-lg primary-text pt-1">{{at.currency }}
                                    {{at.flightRate}} </span>
                                <span class="font-sans font-normal text-base text-gray"> Onwards</span>
                            </div>
                        </div>
                    </div>
                    }
                </ngx-slick-carousel>
            </div>
            @if ((popularFlights?.length >= 6)) {
            <div class="flex flex-row justify-center items-center absolute h-12 w-12 rounded-full left-0 top-[45px] -ml-[26px] shadow cursor-pointer white-bg"
                (click)="slickModal2.slickPrev()">
                <mat-icon class="relative left-1 primary-text">arrow_back_ios</mat-icon>
            </div>

            <div class="flex flex-row justify-center items-center absolute h-12 w-12 white-bg rounded-full right-0 top-[45px] -mr-[18px] shadow cursor-pointer"
                (click)="slickModal2.slickNext()">
                <mat-icon class="primary-text">arrow_forward_ios</mat-icon>
            </div>
            }
        </div>
    </div>
    }
    <!------Ad------->
    @if (settings?.data?.android_app_link || settings?.data?.ios_app_link) {
    <div class="bg-add mt-15 shadow rounded-xl h-[257px]">
        <div class="flex items-center justify-end h-full">
            <div class="flex flex-col gap-3 w-[710px] h-full justify-center">
                <p class="text-[18px] font-normal text-[#c6c6c6] max-w-[400px]">Get access to all Major Travel Services
                    like Flights,
                    Hotels, Bus, Holidays, and Visas at your Fingertips!</p>
                <div class="flex flex-row gap-3.5">
                    @if (settings?.data?.ios_app_link) {
                    <img loading="lazy" src="assets/images/image/app_store.webp" class="w-[150px] cursor-pointer"
                        alt="app_store" (click)="openNewWindow(settings?.data?.ios_app_link)">
                    }
                    @if (settings?.data?.android_app_link) {
                    <img loading="lazy" src="assets/images/image/google_play.webp" class="w-[170px] cursor-pointer"
                        alt="google_play" (click)="openNewWindow(settings?.data?.android_app_link)">
                    }
                </div>
            </div>
        </div>
    </div>
    }
    <!-- FAQS -->
    <div class="flex flex-col my-12 space-y-3">
        <span class="text-xl font-bold primary-text">Flights Booking FAQ :-</span>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. What advantages do travel agencies gain from using our B2B platform for air
                ticket bookings?</span>
            <span class="text-gray">A. Explore the benefits and unique features that make our B2B platform the
                ideal choice for travel agencies. Learn about exclusive offers, streamlined processes, and enhanced
                support tailored to your business needs.</span>
        </div>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. How can our B2B air ticket services contribute to cost savings for travel
                agencies?</span>
            <span class="text-gray">A. Discover how our B2B services can help travel agencies optimize costs. From
                bulk booking discounts to special promotions, find out how partnering with us can be a strategic move
                for your agency's financial efficiency.</span>
        </div>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. What sets our B2B air ticket platform apart in terms of technology and user
                experience?</span>
            <span class="text-gray">A. Delve into the technological advancements and user-centric features that
                distinguish our B2B platform. Learn about the intuitive interface, real-time updates, and other
                tech-driven elements designed to enhance the overall user experience for travel agencies.
            </span>
        </div>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. How can travel agencies access and manage bookings efficiently through our
                B2B portal?</span>
            <span class="text-gray">A. Get insights into the tools and resources available on our B2B portal for
                seamless booking management. Learn about the user-friendly dashboard, reporting functionalities, and
                other tools designed to simplify the booking process for travel agencies.</span>
        </div>
        <div class="flex flex-col space-y-1">
            <span class="font-semibold">Q. What support and assistance can travel agencies expect from our dedicated B2B
                customer service team?</span>
            <span class="text-gray">A. Understand the level of support travel agencies can anticipate from our
                dedicated customer service team. Explore the various channels of communication, response times, and the
                personalized assistance available to ensure a smooth experience for our B2B partners.
            </span>
        </div>
    </div>
</div>
} @else {
<!--Theme 1 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme1) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[19rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="pt-3">
        <div class="min-w-[1260px] max-w-[1260px] m-auto relative  mt-[-110px] rounded-xl">
            <div class="rounded-[10px] min-w-[1260px] max-w-[1260px] m-auto">
                <form [formGroup]="formGroup" class="flex flex-col px-0 rounded-[10px]">
                    <div class="flex flex-row gap-1">
                        @for (ft of flightType; track ft) {
                        <div [value]="ft.id" class="text-lg font-medium cursor-pointer rounded-full px-6 py-1"
                            [ngClass]="ft.id === formGroup.get('type').value ? 'primary-text white-bg' : 'white-text'"
                            (click)="flightTypeChange(ft);selectedField = ''">
                            {{ft.name}}
                        </div>
                        }
                    </div>
                    <div class="flex flex-row white-bg mt-7 rounded-[10px] shadow-xl">
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row min-w-[40%] max-w-[40%] border-r gray-border">
                            <div class="flex flex-col min-w-1/2 max-w-1/2 border-r py-[25px] pr-1 gray-border pl-8"
                                [ngClass]="selectedField == 'from' ? 'secondary-bg' : ''">
                                <div class="cursor-pointer" (click)="openFromCityDropdown()">
                                    <span class="font-Roboto text-[15px] text-secondary font-normal">From</span>
                                    <div class="pt-3">
                                        <mat-select #fromCitySelect
                                            (selectionChange)="onFromCitySelectionChange($event.value)"
                                            class="pr-[10px] left-[-6px] font-Roboto font-bold text-xl"
                                            (click)="selectedField = 'from'"
                                            [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : formGroup.get('fromCity').value.display_name + ', ' + formGroup.get('fromCity').value.country + ', ' + formGroup.get('fromCity').value.airport_name"
                                            [compareWith]="compareWith" formControlName="fromCity">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    formControlName="fromCityfilter">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @if (formGroup.get('type')?.value === 'ab') {
                                            <mat-option [value]="'All Cities'">
                                                <div class="flex flex-col h-15 justify-center w-[380px]">
                                                    <span class="font-medium">All Cities</span>
                                                    <span class="text-sm text-gray -mt-1"></span>
                                                </div>
                                            </mat-option>
                                            }
                                            @for (ct of fromCityList | async; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                            <div class="relative w-9">
                                <div (click)="switch()"
                                    class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[37px] -left-[18px]"
                                    [matTooltip]="'Switch'">
                                    <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                        class="icon-size-4 primary-text"></mat-icon>
                                </div>
                            </div>
                            <div class="flex flex-col min-w-1/2 max-w-1/2 pl-5 pr-2 py-[25px]"
                                [ngClass]="selectedField == 'to' ? 'secondary-bg' : ''">
                                <div class="cursor-pointer" (click)="openToCityDropdown()">
                                    <span class="text-[15px] text-secondary">To</span>
                                    <mat-select #toCitySelect class="pt-3 font-Roboto font-bold text-xl"
                                        (selectionChange)="onToCitySelectionChange($event.value)"
                                        (click)="selectedField = 'to'"
                                        [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : formGroup.get('toCity').value.display_name + ', ' +formGroup.get('toCity').value.country + ', ' +formGroup.get('toCity').value.airport_name"
                                        [compareWith]="compareWith" formControlName="toCity">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="toCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @if (formGroup.get('type')?.value === 'ab') {
                                        <mat-option [value]="'All Cities'">
                                            <div class="flex flex-col h-15 justify-center w-[380px]">
                                                <span class="font-medium">All Cities</span>
                                                <span class="text-sm text-gray -mt-1"></span>
                                            </div>
                                        </mat-option>
                                        }
                                        @for (ct of toCityList | async; track ct) {
                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                            <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                <span class="font-medium truncate">{{ ct.display_name }},
                                                    {{ct.country}}</span>
                                                <span
                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row w-[29%]">
                            @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                            <div class="flex flex-col pl-[15px] w-[165px] border-r gray-border"
                                [ngClass]="selectedField == 'departure' ? 'secondary-bg' : ''">
                                <div class="ml-[7px] py-[25px]">
                                    <mat-label class="white-text text-[15px] items-center gap-1 flex">
                                        <span class="pt-1 pb-1 pr-1">
                                            <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                                alt="date_icon"></span>
                                        <span class="ml-0 pr-3 pt-[2px] text-secondary">Departure</span>
                                        @if (formGroup.get('type').value === 'ab') {
                                        <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                        }
                                    </mat-label>
                                    <input readonly
                                        class="font-Roboto font-bold text-xl pt-2 cursor-pointer max-w-[135px]"
                                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                        [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                        matInput [matDatepicker]="picker" [min]="minDate"
                                        (click)="picker.open();selectedField = 'departure'"
                                        formControlName="departureDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker"
                                        class="-mr-[19px] hidden"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </div>
                            </div>
                            }
                            @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                            <div class="pl-[15px] pt-[28px] w-[165px] border-r gray-border relative">
                                <span class="text-secondary text-[15px]">Departure</span>
                                <p-calendar class="fare_cal theam_1" [readonlyInput]="true"
                                    formControlName="departureDate" [showOtherMonths]="false"
                                    [selectOtherMonths]="false" [minDate]="minDate" [dateFormat]="'dd M yy'">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (fareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                            fareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                            }
                            @if (formGroup.get('type').value != 'ab') {
                            <div class="flex flex-col relative py-[25px] w-[165px] border-r gray-border pl-[15px]"
                                [ngClass]="selectedField == 'return' ? 'secondary-bg' : ''">
                                <div class="flex flex-row justify-between">
                                    <span class="text-[15px]  flex items-center gap-1">
                                        <span class="p-1">
                                            <img loading="lazy" class="w-[18px]" src="assets/images/b2c/date_icon.webp"
                                                alt="date_icon">
                                        </span>
                                        <span class="pt-[2px] text-secondary">Return</span>
                                    </span>
                                    @if (formGroup.get('type').value === 'rt') {
                                    <mat-icon class="icon-size-4 absolute z-999 top-[16px] right-[16px] cursor-pointer"
                                        (click)="cancelReturnDate();selectedField = 'return'">cancel</mat-icon>
                                    }
                                </div>
                                <div class="relative">
                                    @if (formGroup.get('type').value === 'ow') {
                                    <div class="absolute z-10 left-0 top-1 font-bold">-</div>
                                    }
                                    <p-calendar class="fare_cal theam_1" [readonlyInput]="true"
                                        formControlName="returnDate" [showOtherMonths]="false"
                                        [selectOtherMonths]="false" [minDate]="formGroup.get('departureDate').value"
                                        [dateFormat]="'dd M yy'" (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()
                                            ">
                                        <ng-template pTemplate="date" let-date>
                                            <span>
                                                {{ date.day }}
                                            </span>
                                            @if (returnFareMap[getFormattedDateNew(date)]) {
                                            <span
                                                [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                                returnFareMap[getFormattedDateNew(date)].price }}</span>
                                            }
                                        </ng-template>
                                    </p-calendar>
                                </div>
                            </div>
                            }
                        </div>
                        }
                        @if (formGroup.get('type').value === 'mc' && formDataList) {
                        <div class="flex flex-row w-full">
                            <div class="w-full flex flex-col">
                                @for (formData of formDataList; track formData; let i = $index) {
                                <div class="w-full flex">
                                    <div class="flex w-full pr-3">
                                        <div class="flex flex-row items-center">
                                            <div [ngClass]="{'secondary-bg' : (selectedField == 'from' && selectedFieldIndex == i), 'border-t' :i != 0}"
                                                class="flex flex-col w-[250px] py-[25px] -mr-[18px] pl-8 border-r gray-border cursor-pointer"
                                                (click)="openFromMultiCityDropdown(i)">
                                                <span
                                                    class="text-[15px] font-Roboto max-w-max font-normal text-secondary">From</span>
                                                <mat-select #fromMultiCitySelect
                                                    (click)="selectedField = 'from'; selectedFieldIndex = i"
                                                    class="pt-3 pr-[10px] font-bold font-Roboto text-xl theme-black-text"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.fromCity" [compareWith]="compareWith"
                                                    [matTooltip]=" formData.fromCity == null ? '' : formData.fromCity.display_name + ', ' + formData.fromCity.country + ', ' + formData.fromCity.airport_name">
                                                    <mat-option>
                                                        <ngx-mat-select-search placeholderLabel="Search City"
                                                            noEntriesFoundLabel="'no matching city found'"
                                                            [(ngModel)]="formData.filterfrom"
                                                            [ngModelOptions]="{standalone: true}" (input)="filterfrom(
                                                                                              $event.target.value,
                                                                                              formData,
                                                                                              'from')">
                                                        </ngx-mat-select-search>
                                                    </mat-option>
                                                    @for (ct of formData.fromListData; track ct) {
                                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                        <div
                                                            class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                            <span class="font-medium truncate">
                                                                {{ ct.display_name }},
                                                                {{ct.country}}</span>
                                                            <span
                                                                class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                        </div>
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </div>
                                            <div (click)="switch(i)"
                                                class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border"
                                                [matTooltip]="'Switch'">
                                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                    class="icon-size-4 primary-text"></mat-icon>
                                            </div>
                                            <div [ngClass]="{'secondary-bg' : (selectedField == 'to' && selectedFieldIndex == i), 'border-t' :i != 0}"
                                                class="flex flex-col w-[250px] py-[25px] border-r gray-border ml-[-18px] pl-[11px] cursor-pointer"
                                                (click)="openToMultiCityDropdown(i)">
                                                <span
                                                    class="text-[15px] font-Roboto px-[10px] max-w-max font-normal pr-3 text-secondary">To</span>
                                                <mat-select #toMultiCitySelect
                                                    (click)="selectedField = 'to'; selectedFieldIndex = i"
                                                    class="font-bold pt-3 pl-2 pr-2 font-Roboto text-xl theme-black-text"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.toCity" [compareWith]="compareWith"
                                                    (ngModelChange)="changeValue($event, i, 'to')"
                                                    [matTooltip]="formData.toCity == null ? '' : formData.toCity.display_name + ', ' +formData.toCity.country + ', ' +formData.toCity.airport_name">
                                                    <mat-option>
                                                        <ngx-mat-select-search placeholderLabel="Search City"
                                                            noEntriesFoundLabel="'no matching city found'"
                                                            [(ngModel)]="formData.filterto"
                                                            [ngModelOptions]="{ standalone: true }"
                                                            (input)=" filterfrom($event.target.value, formData, 'to')">
                                                        </ngx-mat-select-search>
                                                    </mat-option>
                                                    @for (ct of formData.toListData; track ct) {
                                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                        <div
                                                            class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                            <span class="font-medium truncate">{{ ct.display_name
                                                                }},
                                                                {{ct.country}}</span>
                                                            <span
                                                                class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                        </div>
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </div>
                                        </div>
                                        <div class="flex flex-col pl-[15px] w-[165px] border-r gray-border"
                                            [ngClass]="{'secondary-bg' : (selectedField == 'departure' && selectedFieldIndex == i), 'border-t' :i != 0}">
                                            <div class="ml-[7px] py-[23px]">
                                                <label for="departure-date-{{i}}"
                                                    class="white-text text-[15px] items-center flex gap-1">
                                                    <span class="pt-1 pb-1 pr-1">
                                                        <img loading="lazy" class="w-5"
                                                            src="assets/images/b2c/date_icon.webp" alt="date_icon">
                                                    </span>
                                                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Departure</span>
                                                </label>
                                                <input readonly id="departure-date-{{i}}"
                                                    class="font-Roboto font-bold text-xl pt-2 cursor-pointer max-w-[135px]"
                                                    matInput [matDatepicker]="picker"
                                                    [min]="i == 0 ? minDate : formDataList[i - 1]?.departureDate"
                                                    (click)="picker.open(); selectedField = 'departure'; selectedFieldIndex = i"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.departureDate"
                                                    (ngModelChange)="changeDate($event, i)">
                                                <mat-datepicker-toggle matSuffix [for]="picker"
                                                    class="-mr-[19px] hidden"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </div>
                                        </div>
                                        @if (i === 0) {
                                        <div class="min-w-[330px] max-w-[330px] flex flex-col pb-[23px] pt-[27px] pl-4 border-r border-b gray-border"
                                            [ngClass]="{'secondary-bg' : (selectedField == 'travellersClass')}">
                                            <span
                                                class="text-[15px] rounded-lg w-[186px] h-[24px] text-secondary">Travellers
                                                | Class</span>
                                            <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold text-xl pt-[8px] cursor-pointer"
                                                (click)="travellersClass();selectedField = 'travellersClass'"
                                                [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">
                                                {{ formGroup.get("adult").value + formGroup.get("child").value +
                                                formGroup.get("infant").value }} Pax, {{
                                                formGroup.get("cabinClass").value
                                                }}
                                            </div>
                                        </div>
                                        }
                                        @if (i != 0 && i === formDataList.length - 1) {
                                        <div
                                            class="flex items-center justify-center space-x-1 min-w-[330px] max-w-[330px] gray-border gap-6">
                                            @if (i < 4) { <button mat-flat-button
                                                class="border border-solid px-4 py-1.5 rounded-lg primary-border secondary-bg"
                                                (click)="addCity(i)">
                                                <span class="font-bold font-Roboto_Condensed text-base primary-text">+
                                                    ADD ANOTHER CITY</span>
                                                </button>
                                                }
                                                @if (i > 1) {
                                                <mat-icon svgIcon="heroicons_solid:x-circle"
                                                    class="text-secondary icon-size-7 cursor-pointer"
                                                    (click)="removeCity(i)"></mat-icon>
                                                }
                                        </div>
                                        }
                                    </div>
                                </div>
                                }
                            </div>
                            <div class="w-full h-full justify-center flex items-center">
                                <button class="primary-bg rounded-lg py-10 px-12" mat-flat-button (click)="detail()">
                                    <span class="white-text font-semibold text-2xl font-Roboto">Search</span>
                                </button>
                            </div>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row rounded-lg w-full h-full">
                            <div class="min-w-[52%] max-w-[52%] flex flex-col pt-[28px] pb-[29px] pl-4"
                                [ngClass]="selectedField == 'travellersClass' ? 'secondary-bg' : ''">
                                <span class="text-[15px] rounded-lg w-[186px] h-[24px] text-secondary">Travellers
                                    | Class</span>
                                <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold text-xl pt-[8px] cursor-pointer"
                                    (click)="travellersClass();selectedField = 'travellersClass'"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">
                                    {{ formGroup.get("adult").value + formGroup.get("child").value +
                                    formGroup.get("infant").value }} Pax, {{ formGroup.get("cabinClass").value }}
                                </div>
                            </div>
                            @if (formGroup.get('type').value != 'mc') {
                            <div class="w-full h-[115px] flex items-center"
                                [ngClass]="(formGroup.get('type').value == 'ab') ? 'justify-end me-5' : 'justify-center'">
                                <button class="primary-bg rounded-lg py-10 px-12" mat-flat-button (click)="detail()">
                                    <span class="white-text font-semibold text-2xl font-Roboto">Search</span>
                                </button>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    @if (formGroup.get('type').value != 'ab') {
                    <div class="flex items-center gap-[16px] my-4">
                        <span class="font-medium text-gray">Special Fare:</span>
                        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                            formControlName="fareType" aria-label="Special Fare Selection">
                            @for (fare of fareType; track fare) {
                            <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                                class="rounded-[6px] h-[30px] text-[13px]"
                                [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' : ''"
                                [value]="fare.key">
                                {{fare.key}}
                            </mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    </div>
                    }
                </form>
            </div>
        </div>
    </div>
</div>
}
<!--Theme 2 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme2) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[16.5rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] mt-[-110px] rounded-[15px]">
        <div class="mr-6 rounded-[15px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-4 py-4 rounded-[15px] pb-5 white-bg shadow-xl">
                <div class="flex flex-row">
                    <mat-radio-group formControlName="type" (change)="optionChange($event.value); selectedField = ''">
                        <div class="flex flex-row space-x-8">
                            @for (ft of flightType; track ft) {
                            <mat-radio-button class="ctm_radio1" [value]="ft.id">
                                <div class="cursor-pointer font-semibold text-lg pl-1 pt-[3px]"
                                    [ngClass]="ft.id == this.formGroup.get('type').value ? 'primary-text' :'text-secondary'">
                                    {{ ft.name }}</div>
                            </mat-radio-button>
                            }
                        </div>
                    </mat-radio-group>
                </div>
                <div class="flex flex-row space-x-3 mt-7 mb-5">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center w-1/2"
                        [ngClass]="(formGroup.get('fromCity')?.value === 'All Cities' ||  formGroup.get('toCity')?.value === 'All Cities') ? 'w-full' : ''">
                        <div class="flex flex-col min-w-[49%] max-w-[49%] h-[60px] border-2 pt-0 pb-3 pl-3 pr-3 rounded-lg -mr-3 cursor-pointer"
                            [ngClass]="selectedField == 'from' ? 'primary-border' : 'gray-border'"
                            (click)="openFromCityDropdown()">
                            <span class="text-[15px] mt-[-11px] font-Roboto px-[10px] white-bg max-w-max font-medium"
                                [ngClass]="selectedField == 'from' ? 'primary-text' : 'text-secondary'">From</span>
                            <mat-select #fromCitySelect (click)="selectedField = 'from'"
                                (selectionChange)="onFromCitySelectionChange($event.value)"
                                class="mt-1 pl-2 font-bold font-Roboto text-2xl text-[#1C1C1C]" [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : 
                                      formGroup.get('fromCity').value.display_name +
                                      ', ' +
                                      formGroup.get('fromCity').value.country +
                                      ', ' +
                                      formGroup.get('fromCity').value.airport_name
                                  " [compareWith]="compareWith" formControlName="fromCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-9 h-9 border gray-border white-bg rounded-full z-20 cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[49%] h-[60px] max-w-[49%] pt-0 pb-3 pl-3 pr-3 border-2 rounded-lg -mr-3 ml-[-12px] cursor-pointer"
                            [ngClass]="selectedField == 'to' ? 'primary-border' : 'gray-border'"
                            (click)="openToCityDropdown()">
                            <span class="text-[15px] mt-[-14px] font-Roboto px-[10px] white-bg max-w-max font-medium"
                                [ngClass]="selectedField == 'to' ? 'primary-text' : 'text-secondary'">To</span>
                            <mat-select #toCitySelect (click)="selectedField = 'to'"
                                (selectionChange)="onToCitySelectionChange($event.value)"
                                class="font-bold pl-2 font-Roboto text-2xl text-[#1C1C1C] mt-2" [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : 
                                      formGroup.get('toCity').value.display_name + ', ' +
                                      formGroup.get('toCity').value.country + ', ' +
                                      formGroup.get('toCity').value.airport_name" [compareWith]="compareWith"
                                formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center w-90 space-x-3"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div [ngClass]="[selectedField == 'departure' ? 'primary-border' : 'gray-border',(formGroup.get('type').value == 'ab') ? 'w-full' : '']"
                            class="flex flex-col w-[48%] h-[60px] white-bg rounded-lg pb-3 pr-3 border-2">
                            <div class="flex flex-row justify-between relative">
                                <span
                                    class="text-[15px] mt-[-11px] ml-2 font-Roboto white-bg px-[5px] max-w-max font-medium"
                                    [ngClass]="selectedField == 'departure' ? 'primary-text' : 'text-secondary'">Departure</span>
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4 absolute top-[5px] -right-2 cursor-pointer"
                                    (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </div>
                            <div class="flex flex-row pl-3">
                                <input class="font-bold text-2xl font-Roboto max-w-[9rem] theme-black-text mt-1"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    [min]="minDate" (click)="picker.open(); selectedField = 'departure'"
                                    [readonly]="true" [matDatepicker]="picker" formControlName="departureDate" />
                            </div>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-[48%] h-[60px] white-bg rounded-lg p-3 border-2 relative"
                            [ngClass]="selectedField == 'departure' ? 'primary-border' : 'gray-border'">
                            <span
                                class="text-[15px] absolute px-[10px] top-[-13px] font-Roboto white-bg  max-w-max font-medium"
                                [ngClass]="selectedField == 'departure' ? 'primary-text' : 'text-secondary'">Departure</span>
                            <p-calendar class="fare_cal theam_2" [readonlyInput]="true" formControlName="departureDate"
                                [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                                [dateFormat]="'dd M yy'" (click)="picker.open(); selectedField = 'departure'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div [ngClass]="selectedField == 'return' ? 'primary-border' : 'gray-border'"
                            class="flex flex-col w-[48%] h-[60px] white-bg rounded-lg pb-3  px-3 border-2">
                            <div class="flex flex-row justify-between relative">
                                <span
                                    class="font-Roboto white-bg px-[5px] ml-2 max-w-max font-medium text-[15px] mt-[-12px]"
                                    [ngClass]="selectedField == 'return' ? 'primary-text' : 'text-secondary'">Return</span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 absolute top-[5px] -right-2 cursor-pointer"
                                    (click)="cancelReturnDate();selectedField = ''">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-2 top-2  font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_2" [readonlyInput]="true" formControlName="returnDate"
                                    [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-3 flex flex-col">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex w-full pr-3">
                                <div class="flex flex-row items-center">
                                    <div [ngClass]="selectedField == 'from' && selectedFieldIndex == i ? 'primary-border' : 'gray-border'"
                                        class="flex flex-col w-[358px] white-bg pt-0 pb-3 pl-3 pr-3 h-[60px] border-2 rounded-lg -mr-3 cursor-pointer"
                                        (click)="openFromMultiCityDropdown(i)">
                                        <span
                                            class="text-[15px] mt-[-11px] font-Roboto white-bg px-[10px] max-w-max font-medium"
                                            [ngClass]="selectedField == 'from' && selectedFieldIndex == i ? 'primary-text' : 'text-secondary'">From</span>
                                        <mat-select #fromMultiCitySelect
                                            (click)="selectedField = 'from'; selectedFieldIndex = i"
                                            class="mt-1 pl-2 font-bold font-Roboto text-2xl text-[#1C1C1C]"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                            [compareWith]="compareWith" [matTooltip]=" formData.fromCity == null ? '' :
                                      formData.fromCity.display_name + ', ' +
                                      formData.fromCity.country + ', ' +
                                      formData.fromCity.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom" [ngModelOptions]="{
                                                          standalone: true
                                                      }" (input)="
                                                          filterfrom(
                                                              $event.target.value,
                                                              formData,
                                                              'from'
                                                          )
                                                      ">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                    <div (click)="switch(i)"
                                        class="flex flex-row justify-center items-center w-9 h-9 white-bg rounded-full z-20 cursor-pointer border gray-border"
                                        [matTooltip]="'Switch'">
                                        <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                            class="icon-size-4 primary-text"></mat-icon>
                                    </div>
                                    <div [ngClass]="selectedField == 'to' && selectedFieldIndex == i ? 'primary-border' : 'gray-border'"
                                        class="flex flex-col w-[358px] h-[60px] pt-0 pb-3 pl-3 pr-3 border-2 rounded-lg -mr-3 ml-[-12px] cursor-pointer"
                                        (click)="openToMultiCityDropdown(i)">
                                        <span
                                            class="text-[15px] mt-[-14px] font-Roboto white-bg px-[10px] max-w-max font-medium"
                                            [ngClass]="selectedField == 'to' && selectedFieldIndex == i ? 'primary-text' : 'text-secondary'">To</span>
                                        <mat-select #toMultiCitySelect
                                            (click)="selectedField = 'to'; selectedFieldIndex = i"
                                            class="font-bold pl-2 font-Roboto text-2xl text-[#1C1C1C] mt-2"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                            [compareWith]="compareWith" (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="formData.toCity == null ? '' :
                                      formData.toCity.display_name + ', ' +
                                      formData.toCity.country + ', ' +
                                      formData.toCity.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                                <div class="flex flex-row items-center space-x-0 w-[280px] ml-6">
                                    <div [ngClass]="selectedField == 'departure' && selectedFieldIndex == i ? 'primary-border' : 'gray-border'"
                                        class="flex flex-col w-[150px] h-[60px] white-bg rounded-lg pb-3 pr-3 border-2">
                                        <span
                                            class="font-Roboto white-bg ml-2 px-[5px] max-w-max font-medium text-[15px] mt-[-10px]"
                                            [ngClass]="selectedField == 'departure' && selectedFieldIndex == i ? 'primary-text' : 'text-secondary'">Departure</span>
                                        <div class="flex flex-row pl-3"
                                            (click)="picker.open();selectedField = 'departure'; selectedFieldIndex = i">
                                            <input class="font-bold text-2xl font-Roboto text-[#1C1C1C] mt-1"
                                                [ngModelOptions]="{ standalone: true }" [min]="
                                                  i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                [readonly]="true" [matDatepicker]="picker"
                                                [(ngModel)]="formData.departureDate"
                                                (ngModelChange)="changeDate($event, i)" />
                                        </div>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </div>
                                </div>
                            </div>
                            @if (i === 0) {
                            <div [ngClass]="selectedField == 'travellers' && selectedFieldIndex == i ? 'primary-border' : 'gray-border'"
                                class="flex flex-col flex-grow p-3 ml-[-325px] h-[60px] white-bg rounded-lg w-[240px] pl-0 border-2">
                                <span
                                    class="font-Roboto white-bg ml-2 px-[5px] max-w-max font-medium text-[15px] mt-[-24px]"
                                    [ngClass]="selectedField == 'travellers' && selectedFieldIndex == i ? 'primary-text' : 'text-secondary'">Travellers
                                    | Class</span>
                                <span class="truncate font-bold pl-3 text-2xl font-Roboto theme-black-text pt-[5px]"
                                    (click)="travellersClass(); selectedField = 'travellers'; selectedFieldIndex = i"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}}Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-center space-x-1 ml-[-322px]">
                                @if (i > 1) {
                                <button mat-flat-button class="min-h-8 min-w-12 px-1 rounded-md bg-transparent"
                                    (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button
                                    class="!border  bg-transparent px-4 h-8 min-h-8 rounded-md primary-border"
                                    (click)="addCity(i)">
                                    <span class="font-bold font-Roboto_Condensed text-lg primary-text">+ ADD
                                        ANOTHER CITY</span>
                                    </button>
                                    }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col flex-grow p-3 pl-0 min-w-[18%]  white-bg rounded-lg border-2 h-[60px]"
                        [ngClass]="[selectedField == 'travellers' ? 'primary-border' : 'gray-border', (formGroup.get('type').value == 'ab') ? 'w-full ' : 'max-w-[18%]']">
                        <span [ngClass]="selectedField == 'travellers' ? 'primary-text' : 'text-secondary'"
                            class="font-Roboto white-bg ml-2 px-[5px] max-w-max font-medium text-[15px] mt-[-23px]">
                            Travellers | Class</span>
                        <span class="truncate font-bold pl-3 text-2xl font-Roboto theme-black-text pt-1"
                            (click)="travellersClass(); selectedField = 'travellers'"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">{{
                            formGroup.get("adult").value + formGroup.get("child").value +
                            formGroup.get("infant").value
                            }} Pax, {{ formGroup.get("cabinClass").value }}</span>
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4">
                    <span class="font-medium text-gray">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' : ''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
                <div class="flex flex-row justify-center items-center mb-[-45px] space-x-4">
                    <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-semibold text-2xl font-Inter">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!--Theme 3 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme3) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[16.5rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px]  flex rounded-xl mt-[-108px]">
        <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-5 py-4 rounded-lg pb-5 white-bg shadow-xl">
                <div class="flex flex-row gap-7 text-lg font-semibold">
                    @for (ft of flightType; track ft) {
                    <div class="flex flex-row gap-3 cursor-pointer" (click)="flightTypeChange(ft)">
                        <div class="flex flex-row"
                            [ngClass]="ft.id == this.formGroup.get('type').value ? 'border-b-2 primary-border primary-text' :''">
                            {{ft.name}}
                        </div>
                    </div>
                    }
                </div>
                <div class="flex flex-row space-x-3 mt-6 mb-5">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center w-1/2"
                        [ngClass]="(formGroup.get('fromCity')?.value === 'All Cities' ||  formGroup.get('toCity')?.value === 'All Cities') ? 'w-full' : ''">
                        <div class="flex flex-col min-w-[49%] max-w-[49%] h-[74px] py-3 px-2 secondary-bg rounded-lg -mr-3 cursor-pointer"
                            (click)="openFromCityDropdown()">
                            <span
                                class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">From</span>
                            <mat-select #fromCitySelect class="mt-1 pl-2 font-semibold text-xl"
                                (selectionChange)="onFromCitySelectionChange($event.value)" [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' :
                                          formGroup.get('fromCity').value.display_name +
                                          ', ' +
                                          formGroup.get('fromCity').value.country +
                                          ', ' +
                                          formGroup.get('fromCity').value.airport_name
                                      " [compareWith]="compareWith" formControlName="fromCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-9 h-9 secondary-bg border-4 rounded-full z-20 border-white cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[49%] h-[74px] max-w-[49%] py-3 px-2 rounded-lg secondary-bg -mr-3 ml-[-12px] cursor-pointer"
                            (click)="openToCityDropdown()">
                            <span class="text-lg px-[10px] max-w-max font-normal text-secondary">To</span>
                            <mat-select #toCitySelect class="font-semibold pl-2 text-xl mt-1"
                                (selectionChange)="onToCitySelectionChange($event.value)" [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' :
                                          formGroup.get('toCity').value.display_name + ', ' +
                                          formGroup.get('toCity').value.country + ', ' +
                                          formGroup.get('toCity').value.airport_name" [compareWith]="compareWith"
                                formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center w-90 space-x-3"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'max-w-90 min-w-90'">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col w-[48%] h-[74px] secondary-bg rounded-lg px-3 py-2.5"
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                            <div class="flex flex-row justify-between">
                                <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Departure</span>
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </div>
                            <div class="flex flex-row justify-between">
                                <input class="font-semibold text-xl mt-1 max-w-[120px]" [min]="minDate"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="departureDate" />
                                <mat-icon svgIcon="mat_outline:date_range" class="primary-text mt-1 cursor-pointer"
                                    (click)="picker.open()"></mat-icon>
                            </div>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-[48%] h-[74px] secondary-bg rounded-lg px-3 py-2.5">
                            <span class="text-gray text-md">Departure</span>
                            <p-calendar class="fare_cal theam_1" [readonlyInput]="true" formControlName="departureDate"
                                [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                                [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex flex-col w-[48%] h-[74px] secondary-bg rounded-lg px-3 py-2.5">
                            <div class="flex flex-row justify-between">
                                <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Return</span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 pt-[2px] mr-[-4px] cursor-pointer"
                                    (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-0 top-1 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_1" [readonlyInput]="true" formControlName="returnDate"
                                    [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-3 flex flex-col gap-3">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex w-full pr-3">
                                <div class="flex flex-row items-center">
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 secondary-bg rounded-lg -mr-3 cursor-pointer"
                                        (click)="openFromMultiCityDropdown(i)">
                                        <span class="px-[10px] max-w-max text-lg font-normal text-secondary">From</span>
                                        <mat-select #fromMultiCitySelect class="mt-1 pl-2 font-semibold text-xl"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                            [compareWith]="compareWith" [matTooltip]="
                                                              formData?.fromCity?.display_name + ', ' +
                                                              formData?.fromCity?.country + ', ' +
                                                              formData?.fromCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (input)="filterfrom($event.target.value, formData, 'from')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                    <div (click)="switch(i)"
                                        class="flex flex-row justify-center items-center w-9 h-9 secondary-bg border-4 rounded-full border-white z-20 cursor-pointer"
                                        [matTooltip]="'Switch'">
                                        <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                            class="icon-size-4 primary-text"></mat-icon>
                                    </div>
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 rounded-lg secondary-bg -mr-3 ml-[-12px] cursor-pointer"
                                        (click)="openToMultiCityDropdown(i)">
                                        <span class="text-lg px-[10px] max-w-max font-normal text-secondary">To</span>
                                        <mat-select #toMultiCitySelect class="pl-2 font-semibold text-xl mt-1"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                            [compareWith]="compareWith" (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="!formData?.toCity ? '' :
                                                              formData?.toCity?.display_name + ', ' +
                                                              formData?.toCity?.country + ', ' +
                                                              formData?.toCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                                <div class="flex flex-row items-center space-x-0 w-[168px] ml-6">
                                    <div class="flex flex-col w-[170px] h-[74px] secondary-bg rounded-lg px-3 py-2.5">
                                        <span
                                            class="max-w-max secondary-bg text-secondary text-lg font-normal">Departure</span>
                                        <div class="flex flex-row" (click)="picker.open()">
                                            <input class="font-semibold text-xl mt-1 max-w-[120px]"
                                                [ngModelOptions]="{ standalone: true }" [min]="
                                                              i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                [readonly]="true" [matDatepicker]="picker"
                                                [(ngModel)]="formData.departureDate"
                                                (ngModelChange)="changeDate($event, i)" />
                                            <mat-icon svgIcon="mat_outline:date_range"
                                                class="primary-text mt-1 cursor-pointer"></mat-icon>
                                        </div>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </div>
                                </div>
                            </div>
                            @if (i === 0) {
                            <div class="flex flex-col flex-grow px-3 py-2.5 h-[74px] rounded-lg w-[434px] secondary-bg">
                                <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Travellers
                                    | Class</span>
                                <span class="truncate font-semibold text-xl cursor-pointer" (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-center gap-1 space-x-1 w-[434px]">
                                @if (i > 1) {
                                <button mat-flat-button class="rounded-md primary-border border border-solid"
                                    (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button mat-flat-button
                                    class="rounded-md font-semibold text-[15px] primary-text primary-border border border-solid"
                                    (click)="addCity(i)">
                                    <div class="pt-0.5">+ Add Another City</div>
                                    </button>
                                    }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col min-w-[226px] flex-grow p-3 secondary-bg rounded-lg h-[74px]"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'w-[20%]'">
                        <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Travellers
                            | Class</span>
                        <span class="truncate font-semibold max-w-full cursor-pointer text-xl"
                            (click)="travellersClass()"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">
                            {{formGroup.get("adult").value + formGroup.get("child").value +
                            formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}</span>
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4 my-2">
                    <span class="font-medium text-gray">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' : ''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
                <div class="flex flex-row justify-center items-center -mb-11 space-x-4">
                    <button mat-flat-button class="w-50 min-h-13 rounded-lg primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!--Theme 4 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme4) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[375px] primary-bg w-full gray-text" style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] flex rounded-xl mt-[-95px]">
        <div class="mr-6 rounded-[10px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-5 py-4 rounded-[22px] pb-5 white-bg shadow-xl">
                <div class="flex flex-row gap-4 text-lg font-semibold">
                    @for (ft of flightType; track ft) {
                    <div class="flex flex-row gap-3 cursor-pointer" (click)="flightTypeChange(ft)">
                        <div class="flex flex-row px-3 py-1 text-lg font-medium rounded-full"
                            [ngClass]="ft.id == this.formGroup.get('type').value ? 'secondary-bg primary-text' :'text-secondary'">
                            {{ft.name}}
                        </div>
                    </div>
                    }
                </div>
                <div class="flex flex-row space-x-3 mt-4 mb-5">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row gap-3 items-center w-1/2"
                        [ngClass]="(formGroup.get('fromCity')?.value === 'All Cities' ||  formGroup.get('toCity')?.value === 'All Cities') ? 'w-full' : ''">
                        <div class="flex flex-col min-w-[48%] max-w-[48%] h-[74px] py-3 px-2 -mr-3 pl-[16px] cursor-pointer"
                            (click)="openFromCityDropdown()">
                            <span class="text-lg pr-[10px] pl-[2px] max-w-max font-normal text-secondary">From</span>
                            <mat-select #fromCitySelect class="mt-1 font-semibold text-xl"
                                (selectionChange)="onFromCitySelectionChange($event.value)" [compareWith]="compareWith"
                                formControlName="fromCity"
                                [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : formGroup.get('fromCity').value.display_name + ', ' + formGroup.get('fromCity').value.country + ', ' + formGroup.get('fromCity').value.airport_name">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-9 h-9 secondary-bg border-4 rounded-full z-20 border-white cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[48%] h-[74px] max-w-[48%] py-3 pr-2 pl-[16px] -mr-3 ml-[-12px] cursor-pointer"
                            (click)="openToCityDropdown()">
                            <span class="text-lg pr-[10px] max-w-max font-normal text-secondary">To</span>
                            <mat-select #toCitySelect class="font-semibold text-xl mt-1"
                                (selectionChange)="onToCitySelectionChange($event.value)" [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' :
                                          formGroup.get('toCity').value.display_name + ', ' +
                                          formGroup.get('toCity').value.country + ', ' +
                                          formGroup.get('toCity').value.airport_name" [compareWith]="compareWith"
                                formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center w-90 space-x-3"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'max-w-90 min-w-90'">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col w-[48%] h-[74px] px-3 py-2.5"
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                            <div class="flex flex-row justify-between">
                                <span class="max-w-max text-secondary text-lg font-normal">Departure</span>
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </div>
                            <div class="flex flex-row">
                                <input class="font-semibold text-xl mt-1 max-w-[145px]" [min]="minDate"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="departureDate" />
                            </div>
                            <mat-datepicker #picker></mat-datepicker>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-[48%] h-[74px] px-3 py-2.5">
                            <span class="max-w-max text-secondary text-lg font-normal">Departure</span>
                            <p-calendar class="fare_cal theam_3" [readonlyInput]="true" formControlName="departureDate"
                                [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                                [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex flex-col w-[48%] h-[74px] px-3 pt-[8px]">
                            <div class="flex flex-row justify-between">
                                <span class="max-w-max text-secondary text-lg font-normal">Return</span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 pt-[2px] mr-[2px] cursor-pointer"
                                    (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-0 top-1 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_3" [readonlyInput]="true" formControlName="returnDate"
                                    [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                                <div class="gray-border mt-[3px] w-full border-t-2"></div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-3 flex flex-col gap-1">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex w-full pr-3">
                                <div class="flex flex-row gap-3 items-center">
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 -mr-3 cursor-pointer"
                                        (click)="openFromMultiCityDropdown(i)">
                                        <span class="px-[10px] max-w-max text-lg font-normal text-secondary">From</span>
                                        <mat-select #fromMultiCitySelect class="mt-1 pl-2 font-semibold text-xl"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                            [compareWith]="compareWith" [matTooltip]="
                                                  formData?.fromCity?.display_name + ', ' +
                                                  formData?.fromCity?.country + ', ' +
                                                  formData?.fromCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom" [ngModelOptions]="{
                                                              standalone: true
                                                          }" (input)="
                                                              filterfrom(
                                                                  $event.target.value,
                                                                  formData,
                                                                  'from'
                                                              )
                                                          ">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                        <div class="gray-border mt-[3px] ml-2 w-full border-t-2"></div>
                                    </div>
                                    <div (click)="switch(i)"
                                        class="flex flex-row justify-center items-center w-9 h-9 secondary-bg border-4 rounded-full border-white z-20 cursor-pointer"
                                        [matTooltip]="'Switch'">
                                        <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                            class="icon-size-4 primary-text"></mat-icon>
                                    </div>
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 -mr-3 ml-[-12px] cursor-pointer"
                                        (click)="openToMultiCityDropdown(i)">
                                        <span class="text-lg px-[10px] max-w-max font-normal text-secondary">To</span>
                                        <mat-select #toMultiCitySelect class="pl-2 font-semibold text-xl mt-1"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                            [compareWith]="compareWith" (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="formData?.toCity == null ? '' :
                                                  formData?.toCity?.display_name + ', ' +
                                                  formData?.toCity?.country + ', ' +
                                                  formData?.toCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                        <div class="gray-border mt-[3px] ml-2 w-full border-t-2"></div>
                                    </div>
                                </div>
                                <div class="flex flex-row items-center space-x-0 w-[168px] ml-6">
                                    <div class="flex flex-col w-[170px] h-[74px] rounded-lg px-3 py-2.5">
                                        <span class="max-w-max text-secondary text-lg font-normal">Departure</span>
                                        <div class="flex flex-row" (click)="picker.open()">
                                            <input class="font-semibold text-xl mt-1 max-w-[120px]"
                                                [ngModelOptions]="{ standalone: true }" [min]="
                                                      i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                [readonly]="true" [matDatepicker]="picker"
                                                [(ngModel)]="formData.departureDate"
                                                (ngModelChange)="changeDate($event, i)" />
                                        </div>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <div class="gray-border mt-[3px] w-full border-t-2"></div>
                                    </div>
                                </div>
                            </div>
                            @if (i === 0) {
                            <div class="flex flex-col flex-grow px-3 justify-end pt-2.5 h-[74px] w-[434px]">
                                <span class="max-w-max text-secondary text-lg font-normal">Travellers
                                    | Class</span>
                                <span class="truncate font-semibold text-xl cursor-pointer" (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                                <div class="gray-border mt-[3px] w-full mb-1 border-t-2"></div>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-center gap-1 space-x-1 w-[434px]">
                                @if (i > 1) {
                                <button mat-flat-button class="rounded-md primary-border border border-solid"
                                    (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button mat-flat-button
                                    class="rounded-md font-semibold text-[15px] primary-text primary-border border border-solid"
                                    (click)="addCity(i)">
                                    <div>+ Add Another City</div>
                                    </button>
                                    }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col justify-end flex-grow px-3 pt-3 h-[74px]"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'w-[20%]'">
                        <span class="max-w-max text-secondary text-lg font-normal">Travellers
                            | Class</span>
                        <span class="truncate font-semibold max-w-full cursor-pointer text-xl"
                            (click)="travellersClass()"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">
                            {{formGroup.get("adult").value + formGroup.get("child").value +
                            formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}</span>
                        <div class="gray-border mt-[3px] w-full border-t-2 mb-1"></div>
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4">
                    <span class="font-medium text-gray">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' : ''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
                <div class="flex flex-row justify-center items-center -mb-[47px] space-x-4">
                    <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!--Theme 5 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme5) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-row bg-center justify-center items-center bg-no-repeat min-h-[540px] primary-bg w-full"
        style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important;
background-color: #000000b3 !important;">
        <div class="flex flex-row gap-6 min-w-[1260px] max-w-[1260px] h-full">
            <div class="flex flex-col min-h-full items-center justify-center w-1/2">
                <div class="flex flex-col gap-[2px]">
                    <div class="flex">
                        <h1
                            class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
                            {{flightData?.title}}</h1>
                    </div>
                    <div class="flex text-base justify-center font-Inter white-text">
                        <div class="text-center w-[500px] z-[99] textNote4 font-normal gray-text">
                            {{flightData?.description}}</div>
                    </div>
                </div>
            </div>
            <div class="w-1/2 h-full flex flex-col pt-8 pb-10">
                <form [formGroup]="formGroup"
                    class="flex flex-col h-full w-full justify-center gap-3 theme5-form-field">
                    <div class="flex flex-row w-full">
                        <mat-radio-group formControlName="type" class="disable-whight-color"
                            (change)="optionChange($event.value); selectedField = ''">
                            <div class="flex flex-row space-x-8">
                                @for (ft of flightType; track ft) {
                                <mat-radio-button class="" [value]="ft.id">
                                    <div class="cursor-pointer font-light text-lg pl-1 pt-[3px] white-text">
                                        {{ft.name}}</div>
                                </mat-radio-button>
                                }
                            </div>
                        </mat-radio-group>
                    </div>
                    <div class="flex flex-col white-bg rounded-lg shadow-xl p-5 w-full gap-5">
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row gap-3 w-full">
                            <mat-form-field class="w-1/2 cursor-pointer" (click)="openFromCityDropdown()">
                                <mat-label class="text-secondary text-base font-normal">From</mat-label>
                                <mat-select #fromCitySelect class="font-medium text-[15px] text-black w-[230px] pr-1"
                                    [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : formGroup.get('fromCity').value.display_name +', ' +formGroup.get('fromCity').value.country +', ' +formGroup.get('fromCity').value.airport_name"
                                    (selectionChange)="onFromCitySelectionChange($event.value)"
                                    [compareWith]="compareWith" formControlName="fromCity">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="fromCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @if (formGroup.get('type')?.value === 'ab') {
                                    <mat-option [value]="'All Cities'">
                                        <div class="flex flex-col h-15 justify-center w-[380px]">
                                            <span class="font-medium">All Cities</span>
                                            <span class="text-sm text-gray -mt-1"></span>
                                        </div>
                                    </mat-option>
                                    }
                                    @for (ct of fromCityList | async; track ct) {
                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                        <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                            <span class="font-medium truncate">{{ ct.display_name }},
                                                {{ct.country}}</span>
                                            <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                                <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                            </mat-form-field>

                            <div class="relative">
                                <div (click)="switch()" [matTooltip]="'Switch'"
                                    class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[28px] -left-[18px]">
                                    <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                        class="icon-size-4 primary-text"></mat-icon>
                                </div>
                            </div>

                            <mat-form-field class="w-1/2 cursor-pointer" (click)="openToCityDropdown()">
                                <mat-label class="text-secondary text-base font-normal">To</mat-label>
                                <mat-select #toCitySelect class="font-medium text-[15px] text-black w-[230px] pr-1"
                                    (selectionChange)="onToCitySelectionChange($event.value)"
                                    [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : formGroup.get('toCity').value.display_name +', ' +formGroup.get('toCity').value.country +', ' +formGroup.get('toCity').value.airport_name"
                                    [compareWith]="compareWith" formControlName="toCity">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="toCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @if (formGroup.get('type')?.value === 'ab') {
                                    <mat-option [value]="'All Cities'">
                                        <div class="flex flex-col h-15 justify-center w-[380px]">
                                            <span class="font-medium">All Cities</span>
                                            <span class="text-sm text-gray -mt-1"></span>
                                        </div>
                                    </mat-option>
                                    }
                                    @for (ct of toCityList | async; track ct) {
                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                        <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                            <span class="font-medium truncate">{{ ct.display_name }},
                                                {{ct.country}}</span>
                                            <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                                <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                            </mat-form-field>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row gap-3 w-full">
                            @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                            <div class="flex flex-col w-full"
                                [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                                <mat-label
                                    class="text-secondary text-base font-normal flex justify-between items-center">Departure
                                    @if (formGroup.get('type').value === 'ab') {
                                    <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                    }
                                </mat-label>
                                @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                                <mat-form-field class="w-1/2 mt-1"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                                    <input matInput class="font-medium text-[15px]" [min]="minDate"
                                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                        [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                        (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                        formControlName="departureDate" />
                                    <mat-datepicker #picker></mat-datepicker>
                                    <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text"
                                        (click)="picker.open()"></mat-icon>
                                </mat-form-field>
                                }
                            </div>
                            }
                            @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                            <div class="w-1/2">
                                <span class="text-secondary text-base font-normal">Departure</span>
                                <p-calendar class="fare_cal theam_5" [readonlyInput]="true"
                                    formControlName="departureDate" [showOtherMonths]="false"
                                    [selectOtherMonths]="false" [minDate]="minDate" [dateFormat]="'dd M yy'">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (fareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                            fareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                            }
                            @if (formGroup.get('type').value != 'ab') {
                            <div class="w-1/2 singleBorder">
                                <div class="text-secondary  text-base font-normal flex flex-row justify-between">
                                    <span class="leading-5">Return</span>
                                    @if (formGroup.get('type').value === 'rt') {
                                    <mat-icon class="icon-size-4 cursor-pointer mr-3"
                                        (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                    }
                                </div>
                                <div class="relative">
                                    @if (formGroup.get('type').value === 'ow') {
                                    <div class="absolute z-10 left-3 top-5 font-bold text-black">-</div>
                                    }
                                    <p-calendar class="fare_cal theam_5" [readonlyInput]="true"
                                        formControlName="returnDate" [showOtherMonths]="false"
                                        [selectOtherMonths]="false" [minDate]="formGroup.get('departureDate').value"
                                        [dateFormat]="'dd M yy'"
                                        (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                        <ng-template pTemplate="date" let-date>
                                            <span>
                                                {{ date.day }}
                                            </span>
                                            @if (returnFareMap[getFormattedDateNew(date)]) {
                                            <span
                                                [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                                returnFareMap[getFormattedDateNew(date)].price }}</span>
                                            }
                                        </ng-template>
                                    </p-calendar>
                                </div>
                            </div>
                            }
                        </div>
                        }
                        @if (formGroup.get('type').value == 'mc') {
                        <div class="flex flex-col gap-4">
                            @for (formData of formDataList; track formData; let i = $index) {
                            <div class="flex flex-row gap-3 w-full">
                                <mat-form-field class="w-1/3 cursor-pointer mr-[-24px]"
                                    (click)="openFromMultiCityDropdown(i)">
                                    @if (i == 0) {
                                    <mat-label class="text-secondary text-base font-normal">From</mat-label>
                                    }
                                    <mat-select #fromMultiCitySelect
                                        class="font-medium text-[15px] text-black w-[131px] pr-1"
                                        [compareWith]="compareWith"
                                        [matTooltip]="formData?.fromCity?.display_name + ', ' + formData?.fromCity?.country + ', ' + formData?.fromCity?.airport_name"
                                        [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                noEntriesFoundLabel="'no matching city found'"
                                                [(ngModel)]="formData.filterfrom" [ngModelOptions]="{standalone: true}"
                                                (input)="filterfrom($event.target.value,formData,'from')">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (ct of formData.fromListData; track ct) {
                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                            <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                <span class="font-medium truncate">{{ ct.display_name }},
                                                    {{ct.country}}</span>
                                                <span
                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                                </mat-form-field>

                                <div class="flex items-center z-20">
                                    <div (click)="switch(i)" [ngClass]="{'mt-[24px]': i == 0}"
                                        class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg cursor-pointer border gray-border"
                                        [matTooltip]="'Switch'">
                                        <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                            class="icon-size-4 primary-text"></mat-icon>
                                    </div>
                                </div>

                                <mat-form-field class="w-1/3 cursor-pointer ml-[-24px]"
                                    (click)="openToMultiCityDropdown(i)">
                                    @if (i == 0) {
                                    <mat-label class="text-secondary text-base font-normal">To</mat-label>
                                    }
                                    <mat-select #toMultiCitySelect
                                        class="font-medium text-[15px] text-black  w-[131px] pr-1"
                                        (ngModelChange)="changeValue($event, i, 'to')"
                                        [matTooltip]="formData?.toCity == null ? '' :
                                                                                                                                  formData?.toCity?.display_name + ', ' + formData?.toCity?.country + ', ' + formData?.toCity?.airport_name"
                                        [compareWith]="compareWith" [ngModelOptions]="{ standalone: true }"
                                        [(ngModel)]="formData.toCity">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                noEntriesFoundLabel="'no matching city found'"
                                                [(ngModel)]="formData.filterto" [ngModelOptions]="{ standalone: true }"
                                                (input)=" filterfrom($event.target.value, formData, 'to')">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @for (ct of formData.toListData; track ct) {
                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                            <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                <span class="font-medium truncate">{{ ct.display_name }},
                                                    {{ct.country}}</span>
                                                <span
                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                    <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                                </mat-form-field>
                                <mat-form-field class="w-1/3">
                                    @if (i == 0) {
                                    <mat-label class="text-secondary text-base font-normal">Departure</mat-label>
                                    }
                                    <input matInput class="font-medium text-[15px] text-black"
                                        [ngModelOptions]="{ standalone: true }"
                                        [min]="i == 0 ? minDate : formDataList[i - 1] ?.departureDate" [readonly]="true"
                                        [matDatepicker]="picker2" [(ngModel)]="formData.departureDate"
                                        (ngModelChange)="changeDate($event, i)" (click)="picker.open()" />
                                    <mat-datepicker #picker2></mat-datepicker>
                                    <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text"
                                        (click)="picker2.open()"></mat-icon>
                                </mat-form-field>
                            </div>
                            }
                            <div class="flex flex-row gap-5">
                                @if (formDataList.length < 5) { <button mat-flat-button
                                    class="text-md primary-text font-medium rounded-md primary-border border border-solid secondary-bg"
                                    (click)="addCity(formDataList.length - 1)">
                                    Add City
                                    </button>
                                    }
                                    @if (formDataList.length > 2) {
                                    <button mat-flat-button class="rounded-md primary-border border border-solid"
                                        (click)="removeCity(formDataList.length - 1)">
                                        <mat-icon class="material-symbols-outlined"><span
                                                class="text-3xl primary-text">close</span></mat-icon>
                                    </button>
                                    }
                            </div>
                        </div>
                        }
                        <div class="flex flex-col w-full">
                            <span class="text-secondary text-base font-normal pb-[6px]">Travellers | Class</span>
                            <span
                                class="truncate font-medium text-[15px] text-black cursor-pointer rounded-md border-[1px] py-[13px] px-4"
                                [ngClass]="isOpenTravellersClass ? 'border-[#4f46e5]' :'border-[#737373]'"
                                (click)="travellersClass()"
                                [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                formGroup.get("adult").value +
                                formGroup.get("child").value +
                                formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }} </span>
                        </div>
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex flex-col w-full mb-4">
                            <span class="text-secondary text-base font-normal pb-[6px]">Special Fare:</span>
                            <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                                formControlName="fareType" aria-label="Special Fare Selection">
                                @for (fare of fareType; track fare) {
                                <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn
                                    [matTooltip]="fare.value" class="rounded-[6px] h-[30px] text-[13px]"
                                    [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' : ''"
                                    [value]="fare.key">
                                    {{fare.key}}
                                </mat-button-toggle>
                                }
                            </mat-button-toggle-group>
                        </div>
                        }
                        <div class="flex justify-center items-center py-1">
                            <button mat-flat-button class="w-full py-[26px] rounded-lg primary-bg" (click)="detail()">
                                <span class="white-text font-medium text-[17px]">Search</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
}
<!--Theme 6 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme6) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text" style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[18rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Racing_Sans_One white-text flex w-full z-[99] tracking-[4px]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="pt-3">
        <div class="min-w-[1260px] max-w-[1260px] m-auto relative mt-[-105px] rounded-xl">
            <div class="rounded-[10px] min-w-[1260px] max-w-[1260px] m-auto">
                <form [formGroup]="formGroup" class="flex flex-col px-0 rounded-[10px]">
                    <div class="flex flex-row gap-1 pl-12">
                        @for (ft of flightType; track ft) {
                        <div [value]="ft.id" class="text-lg font-normal cursor-pointer rounded-full px-4 py-1"
                            [ngClass]="ft.id == formGroup.get('type').value ? 'white-bg primary-text font-semibold' : 'white-text'"
                            (click)="flightTypeChange(ft);selectedField = ''">
                            {{ft.name}}
                        </div>
                        }
                    </div>
                    <div class="flex flex-row white-bg mt-3 rounded-[65px]  shadow-xl min-h-[100px] max-h-fit">
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row min-w-[42%] max-w-[42%] border-r gray-border">
                            <div class="flex flex-col min-w-[53%] max-w-[53%] border-r pr-1 gray-border pl-13 justify-center"
                                [ngClass]="selectedField == 'from' ? 'secondary-bg' : ''">
                                <div class="cursor-pointer" (click)="openFromCityDropdown()">
                                    <span class="font-Roboto text-[15px] text-secondary font-normal">From</span>
                                    <div class="pt-1">
                                        <mat-select #fromCitySelect
                                            (selectionChange)="onFromCitySelectionChange($event.value)"
                                            class="pr-[10px] left-[-6px] font-Roboto font-bold text-xl"
                                            (click)="selectedField = 'from'"
                                            [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : formGroup.get('fromCity').value.display_name + ', ' + formGroup.get('fromCity').value.country + ', ' + formGroup.get('fromCity').value.airport_name"
                                            [compareWith]="compareWith" formControlName="fromCity">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    formControlName="fromCityfilter">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @if (formGroup.get('type')?.value === 'ab') {
                                            <mat-option [value]="'All Cities'">
                                                <div class="flex flex-col h-15 justify-center w-[380px]">
                                                    <span class="font-medium">All Cities</span>
                                                    <span class="text-sm text-gray -mt-1"></span>
                                                </div>
                                            </mat-option>
                                            }
                                            @for (ct of fromCityList | async; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                            </div>
                            <div class="relative w-9">
                                <div (click)="switch()"
                                    class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[37px] -left-[18px]"
                                    [matTooltip]="'Switch'">
                                    <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                        class="icon-size-4 primary-text"></mat-icon>
                                </div>
                            </div>
                            <div class="flex flex-col min-w-[47%] max-w-[47%] pl-5 pr-2 justify-center"
                                [ngClass]="selectedField == 'to' ? 'secondary-bg' : ''">
                                <div class="cursor-pointer" (click)="openToCityDropdown()">
                                    <span class="text-[15px] text-secondary">To</span>
                                    <mat-select #toCitySelect class="pt-1 font-Roboto font-bold text-xl pr-[18px]"
                                        (selectionChange)="onToCitySelectionChange($event.value)"
                                        (click)="selectedField = 'to'"
                                        [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' :formGroup.get('toCity').value.display_name + ', ' +formGroup.get('toCity').value.country + ', ' +formGroup.get('toCity').value.airport_name"
                                        [compareWith]="compareWith" formControlName="toCity">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="toCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @if (formGroup.get('type')?.value === 'ab') {
                                        <mat-option [value]="'All Cities'">
                                            <div class="flex flex-col h-15 justify-center w-[380px]">
                                                <span class="font-medium">All Cities</span>
                                                <span class="text-sm text-gray -mt-1"></span>
                                            </div>
                                        </mat-option>
                                        }
                                        @for (ct of toCityList | async; track ct) {
                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                            <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                <span class="font-medium truncate">{{ ct.display_name }},
                                                    {{ct.country}}</span>
                                                <span
                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row w-[29%]">
                            @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                            <div class="flex flex-col pl-[11px] w-[150px] border-r gray-border justify-center"
                                [ngClass]="selectedField == 'departure' ? 'secondary-bg' : ''">
                                <div class="">
                                    <mat-label class="white-text text-[15px] items-center gap-1 flex">
                                        <span class="pt-1 pb-1 pr-1">
                                            <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                                alt="date_icon">
                                        </span>
                                        <span class="ml-0 pr-3 pt-[2px] text-secondary">Departure</span>
                                        @if (formGroup.get('type').value === 'ab') {
                                        <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                        }
                                    </mat-label>
                                    <input readonly
                                        class="font-Roboto font-bold text-xl pt-0.5 cursor-pointer max-w-[135px]"
                                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                        [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                        matInput [matDatepicker]="picker" [min]="minDate"
                                        (click)="picker.open();selectedField = 'departure'"
                                        formControlName="departureDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker"
                                        class="-mr-[19px] hidden"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </div>
                            </div>
                            }
                            @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                            <div class="pl-[11px] w-[150px] py-[25px] border-r gray-border justify-center relative">
                                <div class="flex gap-2">
                                    <div class="p-1">
                                        <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                            alt="date_icon">
                                    </div>
                                    <span class="ml-0 pr-3 pt-[3px] text-secondary">Departure</span>
                                </div>
                                <p-calendar class="fare_cal theam_6" [readonlyInput]="true"
                                    formControlName="departureDate" [showOtherMonths]="false"
                                    [selectOtherMonths]="false" [minDate]="minDate" [dateFormat]="'dd M yy'">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (fareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                            fareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                            }
                            @if (formGroup.get('type').value != 'ab') {
                            <div class="flex flex-col relative w-[150px] border-r gray-border pl-2 justify-center"
                                [ngClass]="selectedField == 'return' ? 'secondary-bg' : ''">
                                <div class="flex flex-row justify-between">
                                    <span class="text-[15px] flex items-center gap-1">
                                        <span class="p-1">
                                            <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                                alt="date_icon">
                                        </span>
                                        <span class="pt-[2px] text-secondary">Return</span>
                                    </span>
                                    @if (formGroup.get('type').value === 'rt') {
                                    <mat-icon class="icon-size-4 absolute z-999 top-[16px] right-[16px] cursor-pointer"
                                        (click)="cancelReturnDate();selectedField = 'return'">cancel</mat-icon>
                                    }
                                </div>
                                <div class="relative">
                                    @if (formGroup.get('type').value === 'ow') {
                                    <div class="absolute z-10 left-1 top-0 font-bold">-</div>
                                    }
                                    <p-calendar class="fare_cal theam_6" [readonlyInput]="true"
                                        formControlName="returnDate" [showOtherMonths]="false"
                                        [selectOtherMonths]="false" [minDate]="formGroup.get('departureDate').value"
                                        [dateFormat]="'dd M yy'"
                                        (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                        <ng-template pTemplate="date" let-date>
                                            <span>
                                                {{ date.day }}
                                            </span>
                                            @if (returnFareMap[getFormattedDateNew(date)]) {
                                            <span
                                                [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                                returnFareMap[getFormattedDateNew(date)].price }}</span>
                                            }
                                        </ng-template>
                                    </p-calendar>
                                </div>
                            </div>
                            }
                        </div>
                        }
                        @if (formGroup.get('type').value === 'mc' && formDataList) {
                        <div class="flex flex-row w-full">
                            <div class="w-full flex flex-col">
                                @for (formData of formDataList; track formData; let i = $index) {
                                <div class="w-full flex h-[100px]">
                                    <div class="flex w-full h-full">
                                        <div class="flex flex-row items-center h-full" [ngClass]="{'border-t' :i != 0}">
                                            <div [ngClass]="{'secondary-bg' : (selectedField == 'from' && selectedFieldIndex == i)}"
                                                class="flex flex-col w-[300px] -mr-[18px] border-r gray-border h-full justify-center pl-13 cu">
                                                <div class="cursor-pointer" (click)="openFromMultiCityDropdown(i)">
                                                    <span
                                                        class="text-[15px] font-Roboto max-w-max font-normal text-secondary">From</span>
                                                    <mat-select #fromMultiCitySelect
                                                        (click)="selectedField = 'from'; selectedFieldIndex = i"
                                                        class="pt-1 pr-[10px] font-bold font-Roboto text-xl theme-black-text"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        [(ngModel)]="formData.fromCity" [compareWith]="compareWith"
                                                        [matTooltip]=" formData.fromCity == null ? '' : formData.fromCity.display_name + ', ' + formData.fromCity.country + ', ' + formData.fromCity.airport_name">
                                                        <mat-option>
                                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                                noEntriesFoundLabel="'no matching city found'"
                                                                [(ngModel)]="formData.filterfrom"
                                                                [ngModelOptions]="{standalone: true}" (input)="filterfrom(
                                            $event.target.value,
                                            formData,
                                            'from')">
                                                            </ngx-mat-select-search>
                                                        </mat-option>
                                                        @for (ct of formData.fromListData; track ct) {
                                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                            <div
                                                                class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                                <span class="font-medium truncate">{{
                                                                    ct.display_name
                                                                    }},
                                                                    {{ct.country}}</span>
                                                                <span
                                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                            </div>
                                                        </mat-option>
                                                        }
                                                    </mat-select>
                                                </div>
                                            </div>
                                            <div (click)="switch(i)"
                                                class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border"
                                                [matTooltip]="'Switch'">
                                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                    class="icon-size-4 primary-text"></mat-icon>
                                            </div>
                                            <div [ngClass]="{'secondary-bg' : (selectedField == 'to' && selectedFieldIndex == i)}"
                                                class="flex flex-col w-[280px] border-r gray-border ml-[-18px] pl-[11px] h-full justify-center">
                                                <div class="cursor-pointer" (click)="openToMultiCityDropdown(i)">
                                                    <span
                                                        class="text-[15px] font-Roboto px-[10px] max-w-max font-normal pr-3 text-secondary">To</span>
                                                    <mat-select #toMultiCitySelect
                                                        (click)="selectedField = 'to'; selectedFieldIndex = i"
                                                        class="font-bold pt-1 pl-2 pr-2 font-Roboto text-xl theme-black-text"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        [(ngModel)]="formData.toCity" [compareWith]="compareWith"
                                                        (ngModelChange)="changeValue($event, i, 'to')"
                                                        [matTooltip]="formData.toCity == null ? '' : formData.toCity.display_name + ', ' +formData.toCity.country + ', ' +formData.toCity.airport_name">
                                                        <mat-option>
                                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                                noEntriesFoundLabel="'no matching city found'"
                                                                [(ngModel)]="formData.filterto"
                                                                [ngModelOptions]="{ standalone: true }"
                                                                (input)=" filterfrom($event.target.value, formData, 'to')">
                                                            </ngx-mat-select-search>
                                                        </mat-option>
                                                        @for (ct of formData.toListData; track ct) {
                                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                            <div
                                                                class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                                <span class="font-medium truncate">{{
                                                                    ct.display_name
                                                                    }},
                                                                    {{ct.country}}</span>
                                                                <span
                                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                            </div>
                                                        </mat-option>
                                                        }
                                                    </mat-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="flex flex-col pl-[3px] w-[165px] border-r gray-border justify-center"
                                            [ngClass]="{'secondary-bg' : (selectedField == 'departure' && selectedFieldIndex == i), 'border-t' :i != 0}">
                                            <div class="ml-[7px]">
                                                <mat-label class="white-text text-[15px] items-center flex gap-1">
                                                    <span class="pt-1 pb-1 pr-1">
                                                        <img loading="lazy" class="w-5"
                                                            src="assets/images/b2c/date_icon.webp" alt="date_icon">
                                                    </span>
                                                    <span class="ml-0 pr-3 pt-[2px] text-secondary">Departure</span>
                                                </mat-label>
                                                <input readonly
                                                    class="font-Roboto font-bold text-xl pt-0.5 cursor-pointer max-w-[135px]"
                                                    matInput [matDatepicker]="picker"
                                                    [min]="i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                    (click)="picker.open();selectedField = 'departure'; selectedFieldIndex = i"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.departureDate"
                                                    (ngModelChange)="changeDate($event, i)">
                                                <mat-datepicker-toggle matSuffix [for]="picker"
                                                    class="-mr-[19px] hidden"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </div>
                                        </div>
                                        @if (i === 0) {
                                        <div class="min-w-[310px] max-w-[310px] flex flex-col pl-2 border-r border-b gray-border h-full justify-center"
                                            [ngClass]="{'secondary-bg' : (selectedField == 'travellersClass')}">
                                            <span
                                                class="text-[15px] rounded-lg w-[186px] h-[24px] text-secondary">Travellers
                                                | Class | Fare</span>
                                            <div class="truncate pr-3 w-full rounded-md font-Roboto font-bold text-xl pt-0.5 cursor-pointer"
                                                (click)="travellersClass();selectedField = 'travellersClass'"
                                                [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                                                {{ formGroup.get("adult").value + formGroup.get("child").value +
                                                formGroup.get("infant").value }} Pax, {{
                                                formGroup.get("cabinClass").value
                                                }}, {{formGroup.get('fareType').value}}
                                            </div>
                                        </div>
                                        }
                                        @if (i != 0 && i === formDataList.length - 1) {
                                        <div
                                            class="flex items-center justify-center space-x-1 min-w-[310px] max-w-[310px] gray-border gap-6">
                                            @if (i < 4) { <button mat-flat-button
                                                class="border border-solid px-4 py-1.5 rounded-lg primary-border secondary-bg"
                                                (click)="addCity(i)">
                                                <span class="font-bold font-Roboto_Condensed text-base primary-text">+
                                                    ADD ANOTHER CITY</span>
                                                </button>
                                                }
                                                @if (i > 1) {
                                                <mat-icon svgIcon="heroicons_solid:x-circle"
                                                    class="text-secondary icon-size-7 cursor-pointer"
                                                    (click)="removeCity(i)"></mat-icon>
                                                }
                                        </div>
                                        }
                                    </div>
                                </div>
                                }
                            </div>
                            <div class="w-full h-full justify-center flex items-center">
                                <button class="primary-bg rounded-full py-8 px-13" mat-flat-button (click)="detail()">
                                    <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                                </button>
                            </div>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row rounded-lg w-full h-[100px]">
                            <div class="min-w-[52%] max-w-[52%] w-[225px] flex flex-col pl-2 justify-center"
                                [ngClass]="selectedField == 'travellersClass' ? 'secondary-bg' : ''">
                                <span class="text-[15px] rounded-lg w-[186px] h-[24px] text-secondary">Travellers
                                    | Class</span>
                                <div class="truncate pr-3 w-full pt-0.5 rounded-md font-Roboto font-bold text-xl cursor-pointer"
                                    (click)="travellersClass();selectedField = 'travellersClass'"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                                    {{ formGroup.get("adult").value + formGroup.get("child").value +
                                    formGroup.get("infant").value }} Pax, {{ formGroup.get("cabinClass").value }}
                                </div>
                            </div>
                            @if (formGroup.get('type').value != 'mc') {
                            <div class="w-full justify-center flex items-center">
                                <button class="primary-bg rounded-full py-8 px-13" mat-flat-button (click)="detail()">
                                    <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                                </button>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    @if (formGroup.get('type').value != 'ab') {
                    <div class="flex items-center gap-[16px] my-4 pl-12">
                        <span class="font-medium text-gray">Special Fare:</span>
                        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                            formControlName="fareType" aria-label="Special Fare Selection">
                            @for (fare of fareType; track fare) {
                            <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                                class="rounded-[6px] h-[30px] text-[13px]"
                                [ngClass]="formGroup.get('fareType').value === fare.key ? 'bg-white' : ''"
                                [value]="fare.key">
                                {{fare.key}}
                            </mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    </div>
                    }
                </form>
            </div>
        </div>
    </div>
</div>
}
<!--Theme 7 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme7) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative"
    [ngClass]="formGroup.get('type').value == 'mc' ? '' : 'h-[635px]'">
    <div class="absolute top-[-73px] w-full h-[710px] z-10"
        [style]="'background-image: url('+flightData?.background_image+');background-blend-mode: color !important; background-color: rgb(0 0 0 / 70%) !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
    </div>
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
        <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem] mt-[73px]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[100] flex rounded-xl mt-[-100px]">
        <div class="mr-6 rounded-b-xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col p-5 pb-1.5 rounded-b-xl white-bg shadow-xl">
                <div class="flex flex-row gap-3 text-lg font-medium gray-text">
                    @for (ft of flightType; track ft) {
                    <div class="flex flex-row gap-3 cursor-pointer px-4 pb-1 pt-1.5 rounded-full"
                        [ngClass]="ft.id == this.formGroup.get('type').value ? 'shadow-md primary-text' :''"
                        (click)="flightTypeChange(ft)">
                        <div class="flex flex-row">
                            {{ft.name}}
                        </div>
                    </div>
                    }
                </div>
                <div class="flex flex-row space-x-3 mt-6 mb-5 theme7-form-field">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center w-1/2">
                        <mat-form-field class="min-w-[49%] max-w-[49%] mr-[-12px]">
                            <mat-label class="text-secondary text-lg font-normal">From</mat-label>
                            <mat-select class="font-medium text-[17px] h-[60px]"
                                (selectionChange)="onFromCitySelectionChange($event.value)"
                                [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' :  formGroup.get('fromCity').value.display_name +', ' +formGroup.get('fromCity').value.country +', ' +formGroup.get('fromCity').value.airport_name"
                                [compareWith]="compareWith" formControlName="fromCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-9 h-9 bg-white border-2 mt-[23px] rounded-full z-20 gray-border cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <mat-form-field class="min-w-[49%] max-w-[49%] -mr-3 ml-[-13px]">
                            <mat-label class="text-secondary text-lg font-normal">To</mat-label>
                            <mat-select class="font-medium text-[17px] h-[60px]"
                                (selectionChange)="onToCitySelectionChange($event.value)"
                                [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' :  formGroup.get('toCity').value.display_name +', ' +formGroup.get('toCity').value.country +', ' +formGroup.get('toCity').value.airport_name"
                                [compareWith]="compareWith" formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center max-w-64 min-w-64 space-x-3">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col w-full">
                            <mat-label
                                class="text-secondary text-lg font-normal flex justify-between items-center">Departure
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </mat-label>
                            <mat-form-field class=""
                                [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'w-1/2'">
                                <input matInput class="font-medium text-[17px] h-[60px]" [min]="minDate"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="departureDate" />
                                <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-1/2 relative">
                            <span class="text-secondary text-lg font-normal">Departure</span>
                            <p-calendar class="fare_cal theam_7" [readonlyInput]="true" formControlName="departureDate"
                                [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                                [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="w-1/2 singleBorder">
                            <div class="text-secondary pb-[3px] text-lg font-normal flex flex-row justify-between">
                                <span class="leading-5">Return</span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 cursor-pointer mr-3"
                                    (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-3 top-5 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_7" [readonlyInput]="true" formControlName="returnDate"
                                    [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-3 flex flex-col gap-3">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex w-fit pr-3">
                                <div class="flex flex-row items-center">
                                    <mat-form-field class="w-[345px] -mr-3">
                                        <mat-label class="text-secondary text-lg font-normal">From</mat-label>
                                        <mat-select class="font-medium text-[17px] h-[60px]"
                                            [matTooltip]="formData?.fromCity?.display_name + ', ' + formData?.fromCity?.country + ', ' + formData?.fromCity?.airport_name"
                                            [compareWith]="compareWith" [ngModelOptions]="{ standalone: true }"
                                            [(ngModel)]="formData.fromCity">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (input)="filterfrom($event.target.value,formData,'from')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                    <div (click)="switch(i)"
                                        class="flex flex-row justify-center items-center w-9 h-9 bg-white border-2 mt-[23px] rounded-full z-20 gray-border cursor-pointer"
                                        [matTooltip]="'Switch'">
                                        <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                            class="icon-size-4 primary-text"></mat-icon>
                                    </div>
                                    <mat-form-field class="w-[345px] -mr-3 ml-[-12px]">
                                        <mat-label class="text-secondary text-lg font-normal">To</mat-label>
                                        <mat-select class="font-medium text-[17px] h-[60px]"
                                            (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="formData?.toCity == null ? '' : formData?.toCity?.display_name + ', ' + formData?.toCity?.country + ', ' + formData?.toCity?.airport_name"
                                            [compareWith]="compareWith" [ngModelOptions]="{ standalone: true }"
                                            [(ngModel)]="formData.toCity">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <mat-form-field class="w-[168px] ml-6">
                                    <mat-label class="text-secondary text-lg font-normal">Departure</mat-label>
                                    <input matInput class="font-medium text-[17px] h-[60px]"
                                        [ngModelOptions]="{ standalone: true }"
                                        [min]="i == 0 ? minDate : formDataList[i - 1] ?.departureDate" [readonly]="true"
                                        [matDatepicker]="picker3" [(ngModel)]="formData.departureDate"
                                        (ngModelChange)="changeDate($event, i)" (click)="picker3.open()" />
                                    <mat-datepicker #picker3></mat-datepicker>
                                </mat-form-field>
                            </div>
                            @if (i === 0) {
                            <div class="flex flex-col w-[165px]">
                                <span class="text-secondary text-lg font-normal pb-[3px] leading-[21px]">Travellers
                                    | Class</span>
                                <span
                                    class="truncate font-medium text-[17px] cursor-pointer rounded-md border-[1px] pt-[18px] pb-[17px] px-4"
                                    [ngClass]="isOpenTravellersClass ? 'border-[#4f46e5]' :'border-[#c2c2c799]'"
                                    (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-end gap-1 space-x-1 w-fit pb-[10px]">
                                @if (i > 1) {
                                <button mat-flat-button class="rounded-md primary-border border border-solid px-0"
                                    (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button mat-flat-button
                                    class="rounded-md font-semibold text-[15px] primary-text primary-border border border-solid px-4"
                                    (click)="addCity(i)">
                                    <div class="pt-0.5">Add City</div>
                                    </button>
                                    }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col w-[20%]">
                        <span class="text-secondary text-lg font-normal pb-[3px] leading-[21px]">Travellers |
                            Class</span>
                        <span
                            class="truncate font-medium text-[17px] cursor-pointer rounded-[10px] border-[1px] pt-[18px] pb-[17px] px-4"
                            [ngClass]="isOpenTravellersClass ? 'border-[#4f46e5]' :'border-[#c2c2c799]'"
                            (click)="travellersClass()"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                            formGroup.get("adult").value +
                            formGroup.get("child").value +
                            formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}</span>
                    </div>
                    }
                    <div class="flex flex-row justify-center items-end pl-1">
                        <button mat-flat-button class="w-36 min-h-[65px] rounded-lg primary-bg" (click)="detail()">
                            <span class="white-text font-medium text-2xl">Search</span>
                        </button>
                    </div>
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4">
                    <span class="text-gray">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' : ''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
            </form>
        </div>
    </div>
</div>
}
<!--Theme 8 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme8) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative"
    [ngClass]="formGroup.get('type').value == 'mc' ? '' : 'h-[575px]'">
    <div class="absolute top-[-73px] w-full h-[665px] z-10"
        [style]="'background-image: url('+flightData?.background_image+');background-blend-mode: color !important; background-color: #333030b3 !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
    </div>
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
        <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem] mt-[120px]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[41px] justify-center font-normal leading-[65px] white-text flex w-full z-[99]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-2xl mt-[-100px]">
        <div class="mr-6 rounded-2xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup"
                class="flex flex-col p-5 pb-1.5 rounded-2xl bg-[#0a0707ab] border light-border">
                <div class="flex flex-row">
                    <mat-radio-group formControlName="type" (change)="optionChange($event.value); selectedField = ''">
                        <div class="flex flex-row space-x-8">
                            @for (ft of flightType; track ft) {
                            <mat-radio-button class="ctm_radio1" [value]="ft.id">
                                <div class="cursor-pointer font-light text-lg pl-1 pt-[3px]"
                                    [ngClass]="ft.id == this.formGroup.get('type').value ? 'primary-text' :'text-white'">
                                    {{ft.name }}</div>
                            </mat-radio-button>
                            }
                        </div>
                    </mat-radio-group>
                </div>
                <div class="flex flex-row white-bg my-5 rounded-[5px] shadow-xl">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row min-w-[40%] max-w-[40%] border-r gray-border">
                        <div class="flex flex-col justify-center min-w-1/2 max-w-1/2 border-r pr-1 gray-border pl-5"
                            [ngClass]="selectedField == 'from' ? 'secondary-bg' : ''">
                            <div class="cursor-pointer" (click)="openFromCityDropdown()">
                                <span class="font-Roboto text-[15px] text-secondary font-normal">From</span>
                                <div class="pt-1">
                                    <mat-select #fromCitySelect
                                        (selectionChange)="onFromCitySelectionChange($event.value)"
                                        class="pr-[10px] left-[-6px] font-Roboto font-medium text-xl"
                                        (click)="selectedField = 'from'"
                                        [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : formGroup.get('fromCity').value.display_name + ', ' + formGroup.get('fromCity').value.country + ', ' + formGroup.get('fromCity').value.airport_name"
                                        [compareWith]="compareWith" formControlName="fromCity">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="fromCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @if (formGroup.get('type')?.value === 'ab') {
                                        <mat-option [value]="'All Cities'">
                                            <div class="flex flex-col h-15 justify-center w-[380px]">
                                                <span class="font-medium">All Cities</span>
                                                <span class="text-sm text-gray -mt-1"></span>
                                            </div>
                                        </mat-option>
                                        }
                                        @for (ct of fromCityList | async; track ct) {
                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                            <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                <span class="font-medium truncate">{{ ct.display_name }},
                                                    {{ct.country}}</span>
                                                <span
                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="relative w-9">
                            <div (click)="switch()"
                                class="flex flex-row justify-center items-center rounded-full w-8 h-8 white-bg z-20 cursor-pointer border gray-border absolute top-[22px] -left-[18px]"
                                [matTooltip]="'Switch'">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>
                        <div class="flex flex-col justify-center min-w-1/2 max-w-1/2 pl-5 pr-2"
                            [ngClass]="selectedField == 'to' ? 'secondary-bg' : ''">
                            <div class="cursor-pointer" (click)="openToCityDropdown()">
                                <span class="font-Roboto text-[15px] text-secondary font-normal">To</span>
                                <mat-select #toCitySelect class="pt-1 font-Roboto font-medium text-xl"
                                    (click)="selectedField = 'to'"
                                    (selectionChange)="onToCitySelectionChange($event.value)"
                                    [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : formGroup.get('toCity').value.display_name + ', ' +formGroup.get('toCity').value.country + ', ' +formGroup.get('toCity').value.airport_name"
                                    [compareWith]="compareWith" formControlName="toCity">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="toCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @if (formGroup.get('type')?.value === 'ab') {
                                    <mat-option [value]="'All Cities'">
                                        <div class="flex flex-col h-15 justify-center w-[380px]">
                                            <span class="font-medium">All Cities</span>
                                            <span class="text-sm text-gray -mt-1"></span>
                                        </div>
                                    </mat-option>
                                    }
                                    @for (ct of toCityList | async; track ct) {
                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                        <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                            <span class="font-medium truncate">{{ ct.display_name }},
                                                {{ct.country}}</span>
                                            <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row w-[29%]">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col justify-center pl-2 w-[165px] border-r gray-border"
                            [ngClass]="selectedField == 'departure' ? 'secondary-bg' : ''">
                            <div class="ml-[7px]">
                                <mat-label class="white-text text-[15px] items-center gap-1 flex">
                                    <span class="pt-1 pb-1 pr-1">
                                        <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                            alt="date_icon"></span>
                                    <span
                                        class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Departure</span>
                                    @if (formGroup.get('type').value === 'ab') {
                                    <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                    }
                                </mat-label>
                                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''" matInput
                                    [matDatepicker]="picker" [min]="minDate"
                                    (click)="picker.open();selectedField = 'departure'" formControlName="departureDate">
                                <mat-datepicker-toggle matSuffix [for]="picker"
                                    class="-mr-[19px] hidden"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </div>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="justify-center pt-[10px] pl-2 w-[165px] border-r gray-border relative">
                            <div class="flex gap-2">
                                <div class="p-1">
                                    <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                        alt="date_icon">
                                </div>
                                <span class="ml-0 pr-3 pt-[3px] text-secondary">Departure</span>
                            </div>
                            <p-calendar class="fare_cal theam_6" [readonlyInput]="true" formControlName="departureDate"
                                [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                                [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex flex-col justify-center relative w-[165px] border-r gray-border pl-[10px]"
                            [ngClass]="selectedField == 'return' ? 'secondary-bg' : ''">
                            <div class="flex flex-row justify-between">
                                <span class="text-[15px] flex items-center gap-1">
                                    <span class="p-1">
                                        <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                            alt="date_icon">
                                    </span>
                                    <span
                                        class="pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Return</span>
                                </span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 absolute z-999 top-[16px] right-[16px] cursor-pointer"
                                    (click)="cancelReturnDate();selectedField = 'return'">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-0 top-0 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_1 theam_8" [readonlyInput]="true"
                                    formControlName="returnDate" [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="flex flex-row w-full">
                        <div class="w-full flex flex-col">
                            @for (formData of formDataList; track formData; let i = $index) {
                            <div class="w-full flex">
                                <div class="flex w-full pr-3">
                                    <div class="flex flex-row items-center h-[75px]">
                                        <div [ngClass]="{'secondary-bg' : (selectedField == 'from' && selectedFieldIndex == i), 'border-t' :i != 0}"
                                            class="flex flex-col w-[250px] -mr-[18px] pl-5 border-r gray-border h-full justify-center">
                                            <div class="cursor-pointer" (click)="openFromMultiCityDropdown(i)">
                                                <span
                                                    class="font-Roboto text-[15px] text-secondary font-normal max-w-max">From</span>
                                                <mat-select #fromMultiCitySelect
                                                    (click)="selectedField = 'from'; selectedFieldIndex = i"
                                                    class="pt-1 pr-[10px] font-medium font-Roboto text-xl theme-black-text"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.fromCity" [compareWith]="compareWith"
                                                    [matTooltip]=" formData.fromCity == null ? '' : formData.fromCity.display_name + ', ' + formData.fromCity.country + ', ' + formData.fromCity.airport_name">
                                                    <mat-option>
                                                        <ngx-mat-select-search placeholderLabel="Search City"
                                                            noEntriesFoundLabel="'no matching city found'"
                                                            [(ngModel)]="formData.filterfrom"
                                                            [ngModelOptions]="{standalone: true}"
                                                            (input)="filterfrom($event.target.value,formData,'from')">
                                                        </ngx-mat-select-search>
                                                    </mat-option>
                                                    @for (ct of formData.fromListData; track ct) {
                                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                        <div
                                                            class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                            <span class="font-medium truncate">{{ ct.display_name
                                                                }},
                                                                {{ct.country}}</span>
                                                            <span
                                                                class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                        </div>
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </div>
                                        </div>
                                        <div (click)="switch(i)"
                                            class="flex flex-row justify-center items-center rounded-full w-8 h-8 white-bg z-20 cursor-pointer border gray-border"
                                            [matTooltip]="'Switch'">
                                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                class="icon-size-4 primary-text"></mat-icon>
                                        </div>
                                        <div [ngClass]="{'secondary-bg' : (selectedField == 'to' && selectedFieldIndex == i), 'border-t' :i != 0}"
                                            class="flex flex-col w-[250px] border-r gray-border ml-[-18px] pl-[11px] h-full justify-center">
                                            <div class="cursor-pointer" (click)="openToMultiCityDropdown(i)">
                                                <span
                                                    class="px-[10px] max-w-max pr-3 font-Roboto text-[15px] text-secondary font-normal">To</span>
                                                <mat-select #toMultiCitySelect
                                                    (click)="selectedField = 'to'; selectedFieldIndex = i"
                                                    class="pt-1 pl-2 pr-2 font-medium font-Roboto text-xl theme-black-text"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.toCity" [compareWith]="compareWith"
                                                    (ngModelChange)="changeValue($event, i, 'to')"
                                                    [matTooltip]="formData.toCity == null ? '' : formData.toCity.display_name + ', ' +formData.toCity.country + ', ' +formData.toCity.airport_name">
                                                    <mat-option>
                                                        <ngx-mat-select-search placeholderLabel="Search City"
                                                            noEntriesFoundLabel="'no matching city found'"
                                                            [(ngModel)]="formData.filterto"
                                                            [ngModelOptions]="{ standalone: true }"
                                                            (input)=" filterfrom($event.target.value, formData, 'to')">
                                                        </ngx-mat-select-search>
                                                    </mat-option>
                                                    @for (ct of formData.toListData; track ct) {
                                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                        <div
                                                            class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                            <span class="font-medium truncate">{{ ct.display_name
                                                                }},
                                                                {{ct.country}}</span>
                                                            <span
                                                                class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                        </div>
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </div>
                                        </div>
                                        <div class="flex flex-col justify-center pl-2 w-[165px] border-r gray-border h-[75px]"
                                            [ngClass]="{'secondary-bg' : (selectedField == 'departure' && selectedFieldIndex == i), 'border-t' :i != 0}">
                                            <div class="ml-[7px]">
                                                <mat-label class="white-text text-[15px] items-center flex gap-1">
                                                    <span class="pt-1 pb-1 pr-1">
                                                        <img loading="lazy" class="w-5"
                                                            src="assets/images/b2c/date_icon.webp"
                                                            alt="date_icon"></span>
                                                    <span
                                                        class="pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Departure</span>
                                                </mat-label>
                                                <input readonly
                                                    class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]"
                                                    matInput [matDatepicker]="picker"
                                                    [min]="i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                    (click)="picker.open();selectedField = 'departure'; selectedFieldIndex = i"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.departureDate"
                                                    (ngModelChange)="changeDate($event, i)">
                                                <mat-datepicker-toggle matSuffix [for]="picker"
                                                    class="-mr-[19px] hidden"></mat-datepicker-toggle>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </div>
                                        </div>
                                        @if (i === 0) {
                                        <div class="min-w-[330px] max-w-[330px] flex flex-col h-[75px] pl-4 pt-1 border-r border-b gray-border justify-center"
                                            [ngClass]="{'secondary-bg' : (selectedField == 'travellersClass')}">
                                            <span
                                                class="rounded-lg w-[186px] h-[24px] font-Roboto text-[15px] text-secondary font-normal">Travellers
                                                | Class</span>
                                            <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer"
                                                (click)="travellersClass();selectedField = 'travellersClass'"
                                                [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                                                {{ formGroup.get("adult").value + formGroup.get("child").value +
                                                formGroup.get("infant").value }} Pax, {{
                                                formGroup.get("cabinClass").value
                                                }}
                                            </div>
                                        </div>
                                        }
                                        @if (i != 0 && i === formDataList.length - 1) {
                                        <div
                                            class="flex items-center justify-center space-x-1 min-w-[330px] max-w-[330px] gray-border gap-6">
                                            @if (i < 4) { <button mat-flat-button
                                                class="border border-solid px-4 rounded-lg primary-border secondary-bg"
                                                (click)="addCity(i)">
                                                <span class="font-bold font-Roboto_Condensed text-base primary-text">+
                                                    ADD ANOTHER CITY</span>
                                                </button>
                                                }
                                                @if (i > 1) {
                                                <mat-icon svgIcon="heroicons_solid:x-circle"
                                                    class="text-secondary icon-size-7 cursor-pointer"
                                                    (click)="removeCity(i)"></mat-icon>
                                                }
                                        </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        <div class="w-full h-full justify-center flex items-center">
                            <button class="primary-bg rounded-lg py-8 px-12" mat-flat-button (click)="detail()">
                                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                            </button>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row rounded-lg w-full h-full"
                        [ngClass]="formGroup.get('type').value === 'ab' ? 'justify-between': ''">
                        <div class="min-w-[52%] max-w-[52%] w-[225px] flex flex-col pl-4 pt-1 justify-center"
                            [ngClass]="selectedField == 'travellersClass' ? 'secondary-bg' : ''">
                            <span
                                class="rounded-lg w-[186px] h-[24px] font-Roboto text-[15px] text-secondary font-normal">Travellers
                                | Class</span>
                            <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer"
                                (click)="travellersClass();selectedField = 'travellersClass'"
                                [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                                {{ formGroup.get("adult").value + formGroup.get("child").value +
                                formGroup.get("infant").value }} Pax, {{ formGroup.get("cabinClass").value }}
                            </div>
                        </div>
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="w-[195px] min-w-[195px] h-[75px] min-h-[75px] justify-end flex items-center">
                            <button class="primary-bg rounded-none rounded-r-md h-[75px] min-h-[75px] w-full"
                                mat-flat-button (click)="detail()"
                                [ngClass]="formGroup.get('type').value === 'ab' ? '-mr-1': 'mr-3'">
                                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                            </button>
                        </div>
                        }
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4">
                    <span class=" text-white">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'primary-bg' :'bg-white'"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
            </form>
        </div>
    </div>
</div>
}
<!--Theme 9 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme9) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden"
    [ngClass]="formGroup.get('type').value == 'ab' ? 'h-[633px]' : formGroup.get('type').value == 'mc' ? 'h-[747px]' : 'h-[680px]'">
    <div class="absolute top-[-73px] w-full h-[600px] z-10"
        [style]="'background-image: url('+flightData?.background_image+');background-blend-mode: color !important; background-color: #000000bd !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
    </div>
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[400px] primary-bg w-full gray-text"
        [ngClass]="formGroup.get('type').value == 'mc' ? 'mt-[24px]' : ''">
        <div class="flex flex-col h-full items-center justify-center max-h-[14.5rem] mt-[50px]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1 class="text-center text-[46px] justify-center font-semibold white-text flex w-full z-[99]">
                        {{flightData?.title}}
                    </h1>
                </div>
                <div class="flex text-xl justify-center font-normal font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl">
        <div class="mr-6 rounded-[12px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-5 py-4 rounded-[12px] pb-5 white-bg shadow-xl">
                <div class="flex flex-row gap-4 text-lg font-semibold">
                    @for (ft of flightType; track ft) {
                    <div class="flex flex-row gap-3 cursor-pointer" (click)="flightTypeChange(ft)">
                        <div class="flex flex-row px-3 py-1 text-lg font-normal rounded-full"
                            [ngClass]="ft.id == this.formGroup.get('type').value ? 'primary-bg text-white' :'text-secondary'">
                            {{ft.name}}
                        </div>
                    </div>
                    }
                </div>
                <div class="flex flex-row space-x-3 mt-4 mb-5">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row gap-3 items-center w-1/2">
                        <div class="flex flex-col min-w-[48%] max-w-[48%] h-[74px] py-3 px-2 -mr-3 pl-[16px] cursor-pointer"
                            (click)="openFromCityDropdown()">
                            <span class="text-lg pr-[10px] pl-[2px] max-w-max font-normal text-secondary">From</span>
                            <mat-select #fromCitySelect class="mt-1 font-medium text-xl"
                                (selectionChange)="onFromCitySelectionChange($event.value)" [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : 
                                          formGroup.get('fromCity').value.display_name +
                                          ', ' +
                                          formGroup.get('fromCity').value.country +
                                          ', ' +
                                          formGroup.get('fromCity').value.airport_name
                                      " [compareWith]="compareWith" formControlName="fromCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-9 h-9 bg-white border-2 mt-[23px] rounded-full z-20 gray-border cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[48%] h-[74px] max-w-[48%] py-3 pr-2 pl-[16px] -mr-3 ml-[-12px] cursor-pointer"
                            (click)="openToCityDropdown()">
                            <span class="text-lg pr-[10px] max-w-max font-normal text-secondary">To</span>
                            <mat-select #toCitySelect class="font-medium text-xl mt-1"
                                (selectionChange)="onToCitySelectionChange($event.value)" [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : 
                                          formGroup.get('toCity').value.display_name + ', ' +
                                          formGroup.get('toCity').value.country + ', ' +
                                          formGroup.get('toCity').value.airport_name" [compareWith]="compareWith"
                                formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center max-w-90 min-w-90 space-x-3">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col w-[48%] h-[74px] px-3 py-2.5"
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                            <div class="flex flex-row justify-between">
                                <span class="max-w-max text-secondary text-lg font-normal">Departure</span>
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </div>
                            <div class="flex flex-row">
                                <input class="font-medium text-xl mt-1 max-w-[145px]" [min]="minDate"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="departureDate" />
                            </div>
                            <mat-datepicker #picker></mat-datepicker>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-[48%] h-[74px] px-3 py-2.5">
                            <span class="max-w-max text-secondary text-lg font-normal">Departure</span>
                            <p-calendar class="fare_cal theam_3" [readonlyInput]="true" formControlName="departureDate"
                                [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                                [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                            <div class="gray-border mt-[3px] w-full border-t-2"></div>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex flex-col w-[48%] h-[74px] px-3 py-2.5">
                            <div class="flex flex-row justify-between">
                                <span class="max-w-max text-secondary text-lg font-normal">Return</span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 pt-[2px] mr-[2px] cursor-pointer"
                                    (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-0 top-1 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_3" [readonlyInput]="true" formControlName="returnDate"
                                    [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                                <div class="gray-border mt-[3px] w-full border-t-2"></div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-3 flex flex-col gap-1">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex  pr-3">
                                <div class="flex flex-row gap-3 items-center">
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 -mr-3 cursor-pointer"
                                        (click)="openFromMultiCityDropdown(i)">
                                        <span class="px-[10px] max-w-max text-lg font-normal text-secondary">From</span>
                                        <mat-select #fromMultiCitySelect class="mt-1 pl-2 font-medium text-xl"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                            [compareWith]="compareWith" [matTooltip]="
                                                              formData?.fromCity?.display_name + ', ' +
                                                              formData?.fromCity?.country + ', ' +
                                                              formData?.fromCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom" [ngModelOptions]="{
                                                                          standalone: true
                                                                      }" (input)="
                                                                          filterfrom(
                                                                              $event.target.value,
                                                                              formData,
                                                                              'from'
                                                                          )
                                                                      ">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                        <div class="gray-border mt-[3px] ml-2 w-full border-t-2"></div>
                                    </div>
                                    <div (click)="switch(i)"
                                        class="flex flex-row justify-center items-center w-9 h-9 secondary-bg border-4 rounded-full border-white z-20 cursor-pointer"
                                        [matTooltip]="'Switch'">
                                        <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                            class="icon-size-4 primary-text"></mat-icon>
                                    </div>
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 -mr-3 ml-[-12px] cursor-pointer"
                                        (click)="openToMultiCityDropdown(i)">
                                        <span class="text-lg px-[10px] max-w-max font-normal text-secondary">To</span>
                                        <mat-select #toMultiCitySelect class="pl-2 font-medium text-xl mt-1"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                            [compareWith]="compareWith" (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="formData?.toCity == null ? '' :
                                                              formData?.toCity?.display_name + ', ' +
                                                              formData?.toCity?.country + ', ' +
                                                              formData?.toCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                        <div class="gray-border mt-[3px] ml-2 w-full border-t-2"></div>
                                    </div>
                                </div>
                                <div class="flex flex-row items-center space-x-0 w-[168px] ml-6">
                                    <div class="flex flex-col w-[170px] h-[74px] rounded-lg px-3 py-2.5">
                                        <span class="max-w-max text-secondary text-lg font-normal">Departure</span>
                                        <div class="flex flex-row" (click)="picker.open()">
                                            <input class="font-medium text-xl mt-1 max-w-[120px]"
                                                [ngModelOptions]="{ standalone: true }" [min]="
                                                          i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                [readonly]="true" [matDatepicker]="picker"
                                                [(ngModel)]="formData.departureDate"
                                                (ngModelChange)="changeDate($event, i)" />
                                        </div>
                                        <mat-datepicker #picker></mat-datepicker>
                                        <div class="gray-border mt-[3px] w-full border-t-2"></div>
                                    </div>
                                </div>
                            </div>
                            @if (i === 0) {
                            <div class="flex flex-col flex-grow px-3 justify-start pt-2.5 h-[74px] w-[300px]">
                                <span class="max-w-max text-secondary text-lg font-normal">Travellers
                                    | Class</span>
                                <span class="truncate font-medium text-xl cursor-pointer" (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                                <div class="gray-border mt-[3px] w-full mb-1 border-t-2"></div>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-center gap-1 space-x-1 w-[434px]">
                                @if (i > 1) {
                                <button mat-flat-button class="rounded-md primary-border border border-solid"
                                    (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button mat-flat-button
                                    class="rounded-md font-medium text-[15px] primary-text primary-border border border-solid"
                                    (click)="addCity(i)">
                                    <div>+ Add Another City</div>
                                    </button>
                                    }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col justify-end w-[225px] flex-grow px-3 pt-3 h-[74px]">
                        <span class="max-w-max text-secondary text-lg font-normal">Travellers
                            | Class</span>
                        <span class="truncate font-medium max-w-full cursor-pointer text-xl" (click)="travellersClass()"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                            {{formGroup.get("adult").value + formGroup.get("child").value +
                            formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}</span>
                        <div class="gray-border mt-[3px] w-full border-t-2 mb-1"></div>
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4 pr-[10px]">
                    <span class="font-medium text-gray">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' :''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
                <div class="flex flex-row justify-center items-center -mb-[42px] space-x-4">
                    <button mat-flat-button class="w-60 min-h-13 rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!--Theme 10 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme10) {
<div class="flex flex-col justify-center w-full relative items-center mobile:hidden tablet:hidden">
    <div class="absolute top-0 w-full h-[375px] flex flex-row items-end">
        <div class="w-full min-h-full h-full relative">
            <div style="background-image: url(assets/images/b2c/theme_10_header_img.svg);
         background-repeat: no-repeat;
         background-position: right;
         background-size: cover;" class="z-10 min-h-full h-full w-[55%] absolute top-0 left-0"></div>
            <img loading="lazy" [src]="flightData?.background_image" alt="background_image"
                class="object-cover bg-left h-full w-1/2 absolute top-0 right-0">
        </div>
    </div>
    <div class="flex flex-col bg-no-repeat h-[375px] bg-[#F9F9F9] w-full gray-text">
        <div class="flex flex-col min-w-[1260px] max-w-[1260px] m-auto h-full items-center justify-center">
            <div class="flex flex-col w-full">
                <div class="flex">
                    <h1
                        class="text-[52px] justify-start font-bold font-Dosis theme-black-text flex w-[50%] z-[99] pr-2">
                        {{flightData?.title}}
                    </h1>
                </div>
                <div class="flex text-xl justify-start font-Ibm_Plex_Sans_Devanagari theme-black-text w-[50%] pr-2">
                    <div class="w-full z-[99] textNote4">
                        {{flightData?.description}}
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] mt-[-85px] rounded-[15px]">
        <div class="mr-6 rounded-[15px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col ">
                <div class="flex flex-row">
                    <mat-radio-group formControlName="type" (change)="optionChange($event.value); selectedField = ''">
                        <div class="flex flex-row space-x-8">
                            @for (ft of flightType; track ft) {
                            <mat-radio-button class="ctm_radio1" [value]="ft.id">
                                <div class="cursor-pointer font-semibold text-lg pl-1 pt-[3px]"
                                    [ngClass]="ft.id == this.formGroup.get('type').value ? 'primary-text' :'theme-black-text'">
                                    {{ft.name}}
                                </div>
                            </mat-radio-button>
                            }
                        </div>
                    </mat-radio-group>
                </div>
                <div class="flex flex-row white-bg my-5 rounded-[5px]  shadow-xl">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row min-w-[40%] max-w-[40%] border-r gray-border">
                        <div class="flex flex-col justify-center min-w-1/2 max-w-1/2 border-r pr-1 gray-border pl-5"
                            [ngClass]="selectedField == 'from' ? 'secondary-bg' : ''">
                            <div class="cursor-pointer" (click)="openFromCityDropdown()">
                                <span class="font-Roboto text-[15px] text-secondary font-normal">From</span>
                                <div class="pt-1">
                                    <mat-select #fromCitySelect
                                        (selectionChange)="onFromCitySelectionChange($event.value)"
                                        class="pr-[10px] left-[-6px] font-Roboto font-medium text-xl"
                                        (click)="selectedField = 'from'"
                                        [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' :  formGroup.get('fromCity').value.display_name + ', ' + formGroup.get('fromCity').value.country + ', ' + formGroup.get('fromCity').value.airport_name"
                                        [compareWith]="compareWith" formControlName="fromCity">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="fromCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @if (formGroup.get('type')?.value === 'ab') {
                                        <mat-option [value]="'All Cities'">
                                            <div class="flex flex-col h-15 justify-center w-[380px]">
                                                <span class="font-medium">All Cities</span>
                                                <span class="text-sm text-gray -mt-1"></span>
                                            </div>
                                        </mat-option>
                                        }
                                        @for (ct of fromCityList | async; track ct) {
                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                            <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                <span class="font-medium truncate">{{ ct.display_name }},
                                                    {{ct.country}}</span>
                                                <span
                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                        </div>
                        <div class="relative w-9">
                            <div (click)="switch()"
                                class="flex flex-row justify-center items-center rounded-full w-8 h-8 white-bg z-20 cursor-pointer border gray-border absolute top-[22px] -left-[18px]"
                                [matTooltip]="'Switch'">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>
                        <div class="flex flex-col justify-center min-w-1/2 max-w-1/2 pl-5 pr-2"
                            [ngClass]="selectedField == 'to' ? 'secondary-bg' : ''">
                            <div class="cursor-pointer" (click)="openToCityDropdown()">
                                <span class="font-Roboto text-[15px] text-secondary font-normal">To</span>
                                <mat-select #toCitySelect class="pt-1 font-Roboto font-medium text-xl"
                                    (selectionChange)="onToCitySelectionChange($event.value)"
                                    (click)="selectedField = 'to'"
                                    [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : formGroup.get('toCity').value.display_name + ', ' +formGroup.get('toCity').value.country + ', ' +formGroup.get('toCity').value.airport_name"
                                    [compareWith]="compareWith" formControlName="toCity">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="toCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @if (formGroup.get('type')?.value === 'ab') {
                                    <mat-option [value]="'All Cities'">
                                        <div class="flex flex-col h-15 justify-center w-[380px]">
                                            <span class="font-medium">All Cities</span>
                                            <span class="text-sm text-gray -mt-1"></span>
                                        </div>
                                    </mat-option>
                                    }
                                    @for (ct of toCityList | async; track ct) {
                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                        <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                            <span class="font-medium truncate">{{ ct.display_name }},
                                                {{ct.country}}</span>
                                            <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row w-[29%]">
                        <div class="flex flex-col justify-center pl-2 w-[165px] border-r gray-border"
                            [ngClass]="selectedField == 'departure' ? 'secondary-bg' : ''">
                            @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                            <div class="ml-[7px]" [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                                <mat-label class="white-text text-[15px] items-center gap-1 flex">
                                    <span class="pt-1 pb-1 pr-1"><img loading="lazy" class="w-5"
                                            src="assets/images/b2c/date_icon.webp" alt="date_icon"></span>
                                    <div class="flex flex-row justify-between">
                                        <span
                                            class="ml-0 pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Departure</span>
                                        @if (formGroup.get('type').value === 'ab') {
                                        <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                        }
                                    </div>
                                </mat-label>
                                <input readonly class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''" matInput
                                    [matDatepicker]="picker" [min]="minDate"
                                    (click)="picker.open();selectedField = 'departure'" formControlName="departureDate">
                                <mat-datepicker-toggle matSuffix [for]="picker"
                                    class="-mr-[19px] hidden"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                            </div>
                            }
                            @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                            <div class="ml-[7px] relative">
                                <div class="flex gap-2">
                                    <div class="p-1">
                                        <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                            alt="date_icon">
                                    </div>
                                    <span
                                        class="ml-0 pr-3 pt-[3px] font-Roboto text-[15px] text-secondary font-normal">Departure</span>
                                </div>
                                <p-calendar class="fare_cal theam_6" [readonlyInput]="true"
                                    formControlName="departureDate" [showOtherMonths]="false"
                                    [selectOtherMonths]="false" [minDate]="minDate" [dateFormat]="'dd M yy'">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (fareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                            fareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                            }
                        </div>
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex flex-col justify-center relative w-[165px] border-r gray-border pl-[10px]"
                            [ngClass]="selectedField == 'return' ? 'secondary-bg' : ''">
                            <div class="flex flex-row justify-between">
                                <span class="text-[15px] flex items-center gap-1">
                                    <span class="p-1">
                                        <img loading="lazy" class="w-5" src="assets/images/b2c/date_icon.webp"
                                            alt="date_icon">
                                    </span>
                                    <span
                                        class="pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Return</span>
                                </span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 absolute z-999 top-[16px] right-[16px] cursor-pointer"
                                    (click)="cancelReturnDate();selectedField = 'return'">cancel</mat-icon>
                                }
                            </div>
                            <div class="w-full h-[26px] relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-1 top-0 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_6" [readonlyInput]="true" formControlName="returnDate"
                                    [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="flex flex-row w-full">
                        <div class="w-full flex flex-col">
                            @for (formData of formDataList; track formData; let i = $index) {
                            <div class="w-full flex">
                                <div class="flex w-full pr-3">
                                    <div class="flex flex-row items-center h-[75px]">
                                        <div [ngClass]="{'secondary-bg' : (selectedField == 'from' && selectedFieldIndex == i), 'border-t' :i != 0}"
                                            class="flex flex-col w-[250px] -mr-[18px] pl-5 border-r gray-border h-full justify-center cursor-pointer"
                                            (click)="openFromMultiCityDropdown(i)">
                                            <span
                                                class="font-Roboto text-[15px] text-secondary font-normal max-w-max">From</span>
                                            <mat-select #fromMultiCitySelect
                                                (click)="selectedField = 'from'; selectedFieldIndex = i"
                                                class="pt-1 pr-[10px] font-medium font-Roboto text-xl theme-black-text"
                                                [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                                [compareWith]="compareWith"
                                                [matTooltip]=" formData.fromCity == null ? '' : formData.fromCity.display_name + ', ' + formData.fromCity.country + ', ' + formData.fromCity.airport_name">
                                                <mat-option>
                                                    <ngx-mat-select-search placeholderLabel="Search City"
                                                        noEntriesFoundLabel="'no matching city found'"
                                                        [(ngModel)]="formData.filterfrom"
                                                        [ngModelOptions]="{standalone: true}"
                                                        (input)="filterfrom($event.target.value,formData,'from')">
                                                    </ngx-mat-select-search>
                                                </mat-option>
                                                @for (ct of formData.fromListData; track ct) {
                                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                    <div
                                                        class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                        <span class="font-medium truncate">{{ ct.display_name
                                                            }},
                                                            {{ct.country}}</span>
                                                        <span
                                                            class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                    </div>
                                                </mat-option>
                                                }
                                            </mat-select>
                                        </div>
                                        <div (click)="switch(i)"
                                            class="flex flex-row justify-center items-center rounded-full w-8 h-8 white-bg z-20 cursor-pointer border gray-border"
                                            [matTooltip]="'Switch'">
                                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                class="icon-size-4 primary-text"></mat-icon>
                                        </div>
                                        <div [ngClass]="{'secondary-bg' : (selectedField == 'to' && selectedFieldIndex == i), 'border-t' :i != 0}"
                                            class="flex flex-col w-[250px] border-r gray-border ml-[-18px] pl-[11px] h-full justify-center cursor-pointer"
                                            (click)="openToMultiCityDropdown(i)">
                                            <span
                                                class="px-[10px] max-w-max pr-3 font-Roboto text-[15px] text-secondary font-normal">To</span>
                                            <mat-select #toMultiCitySelect
                                                (click)="selectedField = 'to'; selectedFieldIndex = i"
                                                class="pt-1 pl-2 pr-2 font-medium font-Roboto text-xl theme-black-text"
                                                [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                                [compareWith]="compareWith"
                                                (ngModelChange)="changeValue($event, i, 'to')"
                                                [matTooltip]="formData.toCity == null ? '' : formData.toCity.display_name + ', ' +formData.toCity.country + ', ' +formData.toCity.airport_name">
                                                <mat-option>
                                                    <ngx-mat-select-search placeholderLabel="Search City"
                                                        noEntriesFoundLabel="'no matching city found'"
                                                        [(ngModel)]="formData.filterto"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        (input)=" filterfrom($event.target.value, formData, 'to')">
                                                    </ngx-mat-select-search>
                                                </mat-option>
                                                @for (ct of formData.toListData; track ct) {
                                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                    <div
                                                        class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                        <span class="font-medium truncate">{{ ct.display_name
                                                            }},
                                                            {{ct.country}}</span>
                                                        <span
                                                            class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                    </div>
                                                </mat-option>
                                                }
                                            </mat-select>
                                        </div>
                                    </div>
                                    <div class="flex flex-col justify-center pl-2 w-[165px] border-r gray-border h-[75px]"
                                        [ngClass]="{'secondary-bg' : (selectedField == 'departure' && selectedFieldIndex == i), 'border-t' :i != 0}">
                                        <div class="ml-[7px]">
                                            <mat-label class="white-text text-[15px] items-center flex gap-1">
                                                <span class="pt-1 pb-1 pr-1">
                                                    <img loading="lazy" class="w-5"
                                                        src="assets/images/b2c/date_icon.webp" alt="date_icon"></span>
                                                <span
                                                    class="pr-3 pt-[2px] font-Roboto text-[15px] text-secondary font-normal">Departure</span>
                                            </mat-label>
                                            <input readonly
                                                class="font-Roboto font-medium text-xl cursor-pointer max-w-[135px]"
                                                matInput [matDatepicker]="picker"
                                                [min]="i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                (click)="picker.open();selectedField = 'departure'; selectedFieldIndex = i"
                                                [ngModelOptions]="{ standalone: true }"
                                                [(ngModel)]="formData.departureDate"
                                                (ngModelChange)="changeDate($event, i)">
                                            <mat-datepicker-toggle matSuffix [for]="picker"
                                                class="-mr-[19px] hidden"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </div>
                                    </div>
                                    @if (i === 0) {
                                    <div class="min-w-[330px] max-w-[330px] flex flex-col h-[75px] pl-4 pt-1 border-r border-b gray-border justify-center"
                                        [ngClass]="{'secondary-bg' : (selectedField == 'travellersClass')}">
                                        <span
                                            class="rounded-lg w-[186px] h-[24px] font-Roboto text-[15px] text-secondary font-normal">Travellers
                                            | Class</span>
                                        <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer"
                                            (click)="travellersClass();selectedField = 'travellersClass'"
                                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                                            {{ formGroup.get("adult").value + formGroup.get("child").value +
                                            formGroup.get("infant").value }} Pax, {{
                                            formGroup.get("cabinClass").value
                                            }}
                                        </div>
                                    </div>
                                    }
                                    @if (i != 0 && i === formDataList.length - 1) {
                                    <div
                                        class="flex items-center justify-center space-x-1 min-w-[330px] max-w-[330px] gray-border gap-6">
                                        @if (i < 4) { <button mat-flat-button
                                            class="border border-solid px-4 rounded-lg primary-border secondary-bg"
                                            (click)="addCity(i)">
                                            <span class="font-bold font-Roboto_Condensed text-base primary-text">+
                                                ADD ANOTHER CITY</span>
                                            </button>
                                            }
                                            @if (i > 1) {
                                            <mat-icon svgIcon="heroicons_solid:x-circle"
                                                class="text-secondary icon-size-7 cursor-pointer"
                                                (click)="removeCity(i)"></mat-icon>
                                            }
                                    </div>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                        <div class="w-full h-full justify-center flex items-center">
                            <button class="primary-bg rounded-lg py-8 px-12" mat-flat-button (click)="detail()">
                                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                            </button>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row rounded-lg w-full h-full">
                        <div class="min-w-[52%] max-w-[52%] w-[225px] flex flex-col pl-4 pt-1 justify-center"
                            [ngClass]="selectedField == 'travellersClass' ? 'secondary-bg' : ''">
                            <span
                                class="rounded-lg w-[186px] h-[24px] font-Roboto text-[15px] text-secondary font-normal">Travellers
                                | Class</span>
                            <div class="truncate pr-3 w-full rounded-md font-Roboto font-medium text-xl cursor-pointer"
                                (click)="travellersClass();selectedField = 'travellersClass'"
                                [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                                {{ formGroup.get("adult").value + formGroup.get("child").value +
                                formGroup.get("infant").value }} Pax, {{ formGroup.get("cabinClass").value }}
                            </div>
                        </div>
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="w-full h-[75px] min-h-[75px] justify-end flex items-center">
                            <button class="primary-bg rounded-l-none rounded-r-md h-[75px] min-h-[75px] w-full"
                                mat-flat-button (click)="detail()">
                                <span class="white-text font-normal text-2xl font-Roboto">Search</span>
                            </button>
                        </div>
                        }
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4">
                    <span class="font-medium">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' :''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
            </form>
        </div>
    </div>
</div>
}
<!--Theme 11 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme11) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden xl:px-10 px-0">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[600px] xl:rounded-[30px] rounded-none primary-bg w-full gray-text"
        style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important;
    background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[14rem]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[52px] justify-center font-bold font-Dosis white-text flex w-full z-[99]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px]  flex rounded-xl mt-[-318px]">
        <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup" class="flex flex-col px-5 pt-16 rounded-xl pb-[18px] white-bg shadow-xl">
                <div class="flex flex-row gap-7 text-lg font-medium">
                    @for (ft of flightType; track ft) {
                    <div class="flex flex-row gap-3 cursor-pointer" (click)="flightTypeChange(ft)">
                        <div class="flex flex-row px-1"
                            [ngClass]="ft.id == this.formGroup.get('type').value ? 'border-b-2 primary-border primary-text' :'text-secondary'">
                            {{ft.name}}
                        </div>
                    </div>
                    }
                </div>
                <div class="flex flex-row space-x-3 mt-4 mb-5">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center "
                        [ngClass]="(formGroup.get('fromCity')?.value === 'All Cities' ||  formGroup.get('toCity')?.value === 'All Cities') ? 'w-full' : 'w-1/2'">
                        <div class="flex flex-col min-w-[49%] max-w-[49%] h-[74px] py-3 px-2 secondary-bg rounded-[4px] -mr-3 cursor-pointer"
                            (click)="openFromCityDropdown()">
                            <span
                                class="text-lg secondary-bg px-[10px] max-w-max font-normal text-secondary">From</span>
                            <mat-select #fromCitySelect class="mt-1 pl-2 font-semibold text-xl"
                                (selectionChange)="onFromCitySelectionChange($event.value)" [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : 
                                      formGroup.get('fromCity').value.display_name +
                                      ', ' +
                                      formGroup.get('fromCity').value.country +
                                      ', ' +
                                      formGroup.get('fromCity').value.airport_name
                                  " [compareWith]="compareWith" formControlName="fromCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        <div (click)="switch()" [matTooltip]="'Switch'"
                            class="flex flex-row justify-center items-center w-8 h-8 bg-white rounded-full z-20 cursor-pointer">
                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                class="icon-size-4 primary-text"></mat-icon>
                        </div>
                        <div class="flex flex-col min-w-[49%] h-[74px] max-w-[49%] py-3 px-2 rounded-[4px] secondary-bg -mr-3 ml-[-12px] cursor-pointer"
                            (click)="openToCityDropdown()">
                            <span class="text-lg px-[10px] max-w-max font-normal text-secondary">To</span>
                            <mat-select #toCitySelect class="font-semibold pl-2 text-xl mt-1"
                                (selectionChange)="onToCitySelectionChange($event.value)" [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : 
                                      formGroup.get('toCity').value.display_name + ', ' +
                                      formGroup.get('toCity').value.country + ', ' +
                                      formGroup.get('toCity').value.airport_name" [compareWith]="compareWith"
                                formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center space-x-3"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'max-w-90 min-w-90'">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col w-[48%] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5"
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                            <div class="flex flex-row justify-between">
                                <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Departure</span>
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </div>
                            <div class="flex flex-row">
                                <input class="font-semibold text-xl mt-1 max-w-[100px]" [min]="minDate"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="departureDate" />
                            </div>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-[48%] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5 relative">
                            <span class="secondary-bg text-secondary text-lg font-normal">Departure</span>
                            <p-calendar class="fare_cal theam_1" [readonlyInput]="true" formControlName="departureDate"
                                [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                                [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex flex-col w-[48%] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5">
                            <div class="flex flex-row justify-between">
                                <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Return</span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 pt-[2px] mr-[-4px] cursor-pointer"
                                    (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-0 top-3 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_1" [readonlyInput]="true" formControlName="returnDate"
                                    [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-3 flex flex-col gap-3">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex  pr-3">
                                <div class="flex flex-row items-center">
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 secondary-bg rounded-[4px] -mr-3 cursor-pointer"
                                        (click)="openFromMultiCityDropdown(i)">
                                        <span class="px-[10px] max-w-max text-lg font-normal text-secondary">From</span>
                                        <mat-select #fromMultiCitySelect class="mt-1 pl-2 font-semibold text-xl"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                            [compareWith]="compareWith" [matTooltip]="
                                                  formData?.fromCity?.display_name + ', ' +
                                                  formData?.fromCity?.country + ', ' +
                                                  formData?.fromCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom" [ngModelOptions]="{
                                                              standalone: true
                                                          }" (input)="
                                                              filterfrom(
                                                                  $event.target.value,
                                                                  formData,
                                                                  'from'
                                                              )
                                                          ">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                    <div (click)="switch(i)"
                                        class="flex flex-row justify-center items-center w-8 h-8 bg-white rounded-full z-20 cursor-pointer"
                                        [matTooltip]="'Switch'">
                                        <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                            class="icon-size-4 primary-text"></mat-icon>
                                    </div>
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 rounded-[4px] secondary-bg -mr-3 ml-[-12px] cursor-pointer"
                                        (click)="openToMultiCityDropdown(i)">
                                        <span class="text-lg px-[10px] max-w-max font-normal text-secondary">To</span>
                                        <mat-select #toMultiCitySelect class="pl-2 font-semibold text-xl mt-1"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                            [compareWith]="compareWith" (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="!formData?.toCity ? '' :
                                                  formData?.toCity?.display_name + ', ' +
                                                  formData?.toCity?.country + ', ' +
                                                  formData?.toCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                                <div class="flex flex-row items-center space-x-0 w-[168px] ml-6">
                                    <div
                                        class="flex flex-col w-[170px] h-[74px] secondary-bg rounded-[4px] px-3 py-2.5">
                                        <span
                                            class="max-w-max secondary-bg text-secondary text-lg font-normal">Departure</span>
                                        <div class="flex flex-row" (click)="picker.open()">
                                            <input class="font-semibold text-xl mt-1 max-w-[120px]"
                                                [ngModelOptions]="{ standalone: true }" [min]="
                                                      i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                [readonly]="true" [matDatepicker]="picker"
                                                [(ngModel)]="formData.departureDate"
                                                (ngModelChange)="changeDate($event, i)" />
                                        </div>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </div>
                                </div>
                            </div>
                            @if (i === 0) {
                            <div
                                class="flex flex-col flex-grow px-3 py-2.5 h-[74px] rounded-[4px] w-[330px] secondary-bg">
                                <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Travellers
                                    | Class</span>
                                <span class="truncate font-semibold text-xl cursor-pointer" (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-center gap-1 space-x-1 w-[434px]">
                                @if (i > 1) {
                                <button mat-flat-button class="rounded-md primary-border border border-solid"
                                    (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button mat-flat-button
                                    class="rounded-md font-semibold text-[15px] primary-text primary-border border border-solid"
                                    (click)="addCity(i)">
                                    <div class="pt-0.5">+ Add Another City</div>
                                    </button>
                                    }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col  w-[225px] flex-grow p-3 secondary-bg rounded-[4px] h-[74px]"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                        <span class="max-w-max secondary-bg text-secondary text-lg font-normal">Travellers
                            | Class</span>
                        <span class="truncate font-semibold max-w-full cursor-pointer text-xl"
                            (click)="travellersClass()"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                            {{formGroup.get("adult").value + formGroup.get("child").value +
                            formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}</span>
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px]">
                    <span class="font-medium text-gray">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ?  'secondary-bg'  :''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
                <div class="flex flex-row justify-center items-center -mb-11 pt-[20px] space-x-4">
                    <button mat-flat-button class="w-64 min-h-13 rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!--Theme 12 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme12) {
<div class="flex flex-col w-full items-center mobile:hidden tablet:hidden relative">
    <div class="absolute top-[-73px] w-full min-h-[700px] z-10"
        [style]="'background-image: url('+flightData?.background_image+');background-blend-mode: color !important; background-repeat: no-repeat;background-size: cover;background-position: center;'">
    </div>
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[475px] primary-bg w-full gray-text">
        <div class="flex flex-col h-full items-center justify-center max-h-[11rem] mt-[73px]">
            <div class="flex flex-col">
                <div class="flex">
                    <h1
                        class="text-center text-[42px] justify-center font-normal leading-[65px] font-[ui-serif] white-text flex w-full z-[99]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-xl justify-center font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="text-center w-[1000px] z-[99] textNote3">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px] z-[99] flex rounded-xl mt-[-100px]">
        <div class="mr-6 rounded-xl min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup"
                class="flex flex-col p-5 pb-2.5 rounded-xl bg-[#000000bd] shadow-xl theme12-form-field">
                <div class="flex flex-row gap-8 text-xl font-[400] gray-text pl-3">
                    @for (ft of flightType; track ft) {
                    <div class="flex flex-row gap-3 cursor-pointer pb-1"
                        [ngClass]="ft.id == this.formGroup.get('type').value ? 'shadow-md primary-text primary-border border-b-2' :''"
                        (click)="flightTypeChange(ft)">
                        <div class="flex flex-row leading-6">
                            {{ft.name}}
                        </div>
                    </div>
                    }
                </div>
                <div class="flex flex-row space-x-3 mt-6 mb-5">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center gap-1.5 w-1/2">
                        <mat-form-field class="w-1/2">
                            <mat-label class="text-[15px] text-white font-normal">From</mat-label>
                            <mat-select class="font-medium py-[16px] text-[15px] min-w-[235px] w-[235px] pr-1"
                                (selectionChange)="onFromCitySelectionChange($event.value)"
                                [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : formGroup.get('fromCity').value.display_name +', ' +formGroup.get('fromCity').value.country +', ' +formGroup.get('fromCity').value.airport_name"
                                [compareWith]="compareWith" formControlName="fromCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                        </mat-form-field>

                        <div class="relative">
                            <div (click)="switch()" [matTooltip]="'Switch'"
                                class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[-5px] -left-[18px]">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>

                        <mat-form-field class="w-1/2">
                            <mat-label class="text-white text-[15px] font-normal">To</mat-label>
                            <mat-select class="font-medium py-[16px] text-[15px] w-[235px] min-w-[235px] pr-1"
                                (selectionChange)="onToCitySelectionChange($event.value)"
                                [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : formGroup.get('toCity').value.display_name +', ' +formGroup.get('toCity').value.country +', ' +formGroup.get('toCity').value.airport_name"
                                [compareWith]="compareWith" formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                        </mat-form-field>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center max-w-[18rem] min-w-[18rem] space-x-3">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col w-full">
                            <mat-label
                                class="text-white text-[15px] pb-[1px] font-normal flex flex-row justify-between">Departure
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </mat-label>
                            <mat-form-field class="w-1/2"
                                [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                                <input matInput class="font-medium py-[16px] text-[15px]" [min]="minDate"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="departureDate" />
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text"
                                    (click)="picker.open()"></mat-icon>
                            </mat-form-field>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-1/2">
                            <span class="text-base font-normal text-white">Departure</span>
                            <p-calendar class="fare_cal theam_5 theam_12" [readonlyInput]="true"
                                formControlName="departureDate" [showOtherMonths]="false" [selectOtherMonths]="false"
                                [minDate]="minDate" [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="w-1/2 singleBorder">
                            <div class="text-white pb-1 text-[15px] font-normal flex flex-row justify-between">
                                <span class="leading-5">Return</span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 cursor-pointer mr-3 text-white"
                                    (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-3 top-5 font-bold text-black">-</div>
                                }
                                <p-calendar class="fare_cal theam_5 theam_12" [readonlyInput]="true"
                                    formControlName="returnDate" [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-3 flex flex-col gap-3">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex w-fit pr-3">
                                <div class="flex flex-row items-center gap-3">
                                    <mat-form-field class="w-[345px] mr-[-24px]">
                                        <mat-label class="text-white text-[15px] font-normal">From</mat-label>
                                        <mat-select class="font-medium py-[16px] text-[15px] w-[291px] pr-1"
                                            [matTooltip]="formData?.fromCity?.display_name + ', ' +
                              formData?.fromCity?.country + ', ' +
                              formData?.fromCity?.airport_name" [compareWith]="compareWith"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (input)="filterfrom($event.target.value,formData,'from')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                        <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                                    </mat-form-field>
                                    <div class="flex items-center z-20">
                                        <div (click)="switch(i)" [matTooltip]="'Switch'"
                                            class="mt-[24px] flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg cursor-pointer border gray-border">
                                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                class="icon-size-4 primary-text"></mat-icon>
                                        </div>
                                    </div>
                                    <mat-form-field class="w-[345px] ml-[-24px]">
                                        <mat-label class="text-white text-[15px] font-normal">To</mat-label>
                                        <mat-select class="font-medium py-[16px] text-[15px] w-[291px] pr-1"
                                            (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="formData?.toCity == null ? '' :
                          formData?.toCity?.display_name + ', ' + formData?.toCity?.country + ', ' + formData?.toCity?.airport_name" [compareWith]="compareWith"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                        <mat-icon svgIcon="feather:map-pin" class="icon-size-5 gray-text"></mat-icon>
                                    </mat-form-field>
                                </div>
                                <mat-form-field class="w-[168px] ml-3">
                                    <mat-label class="text-white text-[15px] font-normal">Departure</mat-label>
                                    <input matInput class="font-medium text-[15px] py-[16px]"
                                        [ngModelOptions]="{ standalone: true }"
                                        [min]="i == 0 ? minDate : formDataList[i - 1] ?.departureDate" [readonly]="true"
                                        [matDatepicker]="picker2" [(ngModel)]="formData.departureDate"
                                        (ngModelChange)="changeDate($event, i)" (click)="picker2.open()" />
                                    <mat-datepicker #picker2></mat-datepicker>
                                    <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text"
                                        (click)="picker2.open()"></mat-icon>
                                </mat-form-field>
                            </div>
                            @if (i === 0) {
                            <div class="flex flex-col w-[225px]">
                                <span class="text-white text-[15px] font-normal pb-[3px] leading-[20px]">Travellers
                                    | Class</span>
                                <span
                                    class="truncate bg-white font-medium text-[15px] cursor-pointer border-[1px] py-[18px] px-4 rounded-[9px]"
                                    [ngClass]="isOpenTravellersClass ? 'border-[#4f46e5]' :'border-[#737373]'"
                                    (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-end gap-1 space-x-1 w-fit pb-[10px]">
                                @if (i > 1) {
                                <button mat-flat-button class="rounded-md primary-border border border-solid px-0"
                                    (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button mat-flat-button
                                    class="rounded-md font-medium text-[15px] primary-text primary-border border border-solid px-4"
                                    (click)="addCity(i)">
                                    <div class="pt-0.5">Add City</div>
                                    </button>
                                    }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col w-[20%]">
                        <span class="text-white text-[15px] font-normal pb-[2px]">Travellers | Class</span>
                        <span
                            class="truncate bg-white font-medium text-[15px] cursor-pointer border-[1px] py-[17px] px-4 rounded-[9px]"
                            [ngClass]="isOpenTravellersClass ? 'border-[#4f46e5]' :'border-[#737373]'"
                            (click)="travellersClass()"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                            formGroup.get("adult").value +
                            formGroup.get("child").value +
                            formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}</span>
                    </div>
                    }
                    <div class="flex flex-row justify-center items-end pl-1">
                        <button mat-flat-button
                            class="w-[70px] min-w-[70px] min-h-[60px] rounded-lg primary-bg text-white"
                            (click)="detail()">
                            <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
                        </button>
                    </div>
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4">
                    <span class="font-medium text-white">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px] bg-transparent" [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
            </form>
        </div>
    </div>
</div>
}
<!--Theme 13 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme13) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[560px] primary-bg w-full gray-text" style="border-bottom-left-radius: 100% 250px;
            border-bottom-right-radius: 100% 250px;
            border-bottom: 14px solid white;
            background-color: #0000007a !important;
            background-image: url('{{flightData?.background_image}}');
            background-blend-mode: color !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[30rem]">
            <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
                <div class="flex">
                    <h1 class="text-[50px] font-semibold font-[cursive] white-text flex w-full z-[99] tracking-[7px]">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-[30px] font-extralight pt-3 font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="w-[1000px] z-[99] textNote4 leading-[35px]">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px]  flex rounded-[12px] mt-[-145px]">
        <div class="rounded-[12px] min-w-[1260px] max-w-[1260px]">
            <form [formGroup]="formGroup"
                class="flex flex-col px-5 py-4 rounded-[12px] pb-5 white-bg shadow-xl theme12-form-field">
                <div class="flex flex-row gap-1 text-lg font-semibold">
                    @for (ft of flightType; track ft) {
                    <div class="flex flex-row gap-3 cursor-pointer" (click)="flightTypeChange(ft)">
                        <div class="flex flex-row rounded-full px-4 pb-1.5 pt-2 text-[17px] font-medium unselected-text"
                            [ngClass]="ft.id == this.formGroup.get('type').value ? 'secondary-bg primary-text' :''">
                            {{ft.name}}
                        </div>
                    </div>
                    }
                </div>
                <div class="flex flex-row space-x-4 mt-6 mb-7">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center gap-2 w-1/2">
                        <mat-form-field class="w-1/2">
                            <mat-label class="text-[16px] unselected-text font-normal">From</mat-label>
                            <mat-select class="font-medium py-[16px] text-[15px] min-w-[235px] w-[235px] pr-1"
                                (selectionChange)="onFromCitySelectionChange($event.value)"
                                [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : formGroup.get('fromCity').value.display_name +', ' +formGroup.get('fromCity').value.country +', ' +formGroup.get('fromCity').value.airport_name"
                                [compareWith]="compareWith" formControlName="fromCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <mat-icon svgIcon="feather:map-pin" matPrefix class="icon-size-5 gray-text"></mat-icon>
                        </mat-form-field>
                        <div class="relative">
                            <div (click)="switch()" [matTooltip]="'Switch'"
                                class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[-5px] -left-[18px]">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>
                        <mat-form-field class="w-1/2">
                            <mat-label class="unselected-text text-[16px] font-normal">To</mat-label>
                            <mat-select class="font-medium py-[16px] text-[15px] w-[235px] min-w-[235px] pr-1"
                                (selectionChange)="onToCitySelectionChange($event.value)"
                                [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : formGroup.get('toCity').value.display_name +', ' +formGroup.get('toCity').value.country +', ' +formGroup.get('toCity').value.airport_name"
                                [compareWith]="compareWith" formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                            <mat-icon svgIcon="feather:map-pin" matPrefix class="icon-size-5 gray-text"></mat-icon>
                        </mat-form-field>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center max-w-[21rem] min-w-[21rem] space-x-4">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col w-full"
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                            <mat-label
                                class="unselected-text text-[16px] font-normal flex flex-row justify-between pb-[1px]">Departure
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </mat-label>
                            @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                            <mat-form-field class="w-1/2"
                                [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                                <input matInput class="font-medium pb-[15px] pt-[16px] text-[15px]" [min]="minDate"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="departureDate" />
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-icon svgIcon="feather:calendar" matPrefix class="icon-size-5 gray-text"
                                    (click)="picker.open()"></mat-icon>
                            </mat-form-field>
                            }
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-1/2">
                            <span class="unselected-text text-[16px] font-normal">Departure</span>
                            <p-calendar class="fare_cal theam_13" [readonlyInput]="true" formControlName="departureDate"
                                [showOtherMonths]="false" [selectOtherMonths]="false" [minDate]="minDate"
                                [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="w-1/2 singleBorder">
                            <div class="unselected-text pb-1 text-[16px] font-normal flex flex-row justify-between">
                                <span class="leading-5">Return</span>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 cursor-pointer mr-3"
                                    (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-3 top-5 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_13" [readonlyInput]="true"
                                    formControlName="returnDate" [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-3 flex flex-col gap-3">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex w-fit pr-4">
                                <div class="flex flex-row items-center gap-3.5">
                                    <mat-form-field class="w-[345px] mr-[-24px]">
                                        <mat-label class="unselected-text text-[16px] font-normal">From</mat-label>
                                        <mat-select class="font-medium py-[16px] text-[15px] w-[291px] pr-1"
                                            [matTooltip]="formData?.fromCity?.display_name + ', ' +
                              formData?.fromCity?.country + ', ' +
                              formData?.fromCity?.airport_name" [compareWith]="compareWith"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (input)="filterfrom($event.target.value,formData,'from')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                        <mat-icon svgIcon="feather:map-pin" matPrefix
                                            class="icon-size-5 gray-text"></mat-icon>
                                    </mat-form-field>
                                    <div class="flex items-center z-20">
                                        <div (click)="switch(i)" [matTooltip]="'Switch'"
                                            class="mt-[24px] flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg cursor-pointer border gray-border">
                                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                class="icon-size-4 primary-text"></mat-icon>
                                        </div>
                                    </div>

                                    <mat-form-field class="w-[345px] ml-[-24px]">
                                        <mat-label class="unselected-text text-[16px] font-normal">To</mat-label>
                                        <mat-select class="font-medium py-[16px] text-[15px] w-[291px] pr-1"
                                            (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="formData?.toCity == null ? '' :
                          formData?.toCity?.display_name + ', ' + formData?.toCity?.country + ', ' + formData?.toCity?.airport_name" [compareWith]="compareWith"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                        <mat-icon svgIcon="feather:map-pin" matPrefix
                                            class="icon-size-5 gray-text"></mat-icon>
                                    </mat-form-field>
                                </div>
                                <mat-form-field class="w-[168px] ml-4">
                                    <mat-label class="unselected-text text-[16px] font-normal">Departure</mat-label>
                                    <input matInput class="font-medium text-[15px] pb-[15px] pt-[16px]"
                                        [ngModelOptions]="{ standalone: true }"
                                        [min]="i == 0 ? minDate : formDataList[i - 1] ?.departureDate" [readonly]="true"
                                        [matDatepicker]="picker2" [(ngModel)]="formData.departureDate"
                                        (ngModelChange)="changeDate($event, i)" (click)="picker2.open()" />
                                    <mat-datepicker #picker2></mat-datepicker>
                                    <mat-icon svgIcon="feather:calendar" class="icon-size-5 gray-text" matPrefix
                                        (click)="picker2.open()"></mat-icon>
                                </mat-form-field>
                            </div>
                            @if (i === 0) {
                            <div class="flex flex-col w-full">
                                <span class="unselected-text text-[16px] font-normal pb-[3px] leading-[20px]">Travellers
                                    | Class</span>
                                <span
                                    class="truncate bg-white font-medium text-[15px] cursor-pointer border-[1px] py-[16px] px-4 rounded-[9px]"
                                    [ngClass]="isOpenTravellersClass ? 'border-[#4f46e5]' :'border-[#d2d2d2]'"
                                    (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-end gap-1 space-x-1 w-fit pb-[10px]">
                                @if (i > 1) {
                                <button mat-flat-button class="rounded-md primary-border border border-solid px-0"
                                    (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button mat-flat-button
                                    class="rounded-md font-medium text-[15px] primary-text primary-border border border-solid px-4"
                                    (click)="addCity(i)">
                                    <div class="pt-0.5">Add City</div>
                                    </button>
                                    }
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col w-[20%]">
                        <span class="unselected-text text-[16px] font-normal pb-[2px]">Travellers | Class</span>
                        <span
                            class="truncate bg-white font-medium text-[15px] cursor-pointer border-[1px] py-[16px] px-4 rounded-[9px]"
                            [ngClass]="isOpenTravellersClass ? 'border-[#4f46e5]' :'border-[#d2d2d2]'"
                            (click)="travellersClass()"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">{{
                            formGroup.get("adult").value +
                            formGroup.get("child").value +
                            formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}</span>
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4">
                    <span class="font-medium text-gray">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' :''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
                <div class="flex flex-row justify-center items-center -mb-[50px] space-x-4">
                    <button mat-flat-button class="w-64 min-h-[60px] rounded-full primary-bg" (click)="detail()">
                        <span class="white-text font-medium text-2xl">Search</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
}
<!--Theme 14 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme14) {
<div class="flex flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover flex flex-col bg-center bg-no-repeat h-[510px] primary-bg w-full gray-text" style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important;
background-color: #0000007a !important;">
        <div class="flex flex-col h-full items-center justify-center max-h-[24rem] pt-[70px]">
            <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
                <div class="flex">
                    <h1 class="text-[48px] font-medium white-text w-full z-[99]" style="font-family: sans-serif;">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-[22px] font-normal font-Ibm_Plex_Sans_Devanagari white-text">
                    <div class="w-[650px] z-[99] textNote4">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="min-w-[1260px] max-w-[1260px]  flex mt-[-61px]">
        <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] rounded-t-none white-bg shadow-xl">
            <form [formGroup]="formGroup" class="flex border-t-2 flex-col pt-6 pb-2">
                <div class="flex flex-row">
                    <mat-radio-group formControlName="type" (change)="optionChange($event.value); selectedField = ''">
                        <div class="flex flex-row space-x-6">
                            @for (ft of flightType; track ft) {
                            <mat-radio-button class="ctm_radio1" [value]="ft.id">
                                <div class="cursor-pointer font-semibold text-lg pl-1 pt-[3px]"
                                    [ngClass]="ft.id == this.formGroup.get('type').value ? 'primary-text' :'theme-black-text'">
                                    {{ft.name}}
                                </div>
                            </mat-radio-button>
                            }
                        </div>
                    </mat-radio-group>
                </div>
                <div class="flex flex-row space-x-3 mt-5 mb-5">
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center  border-[1px] rounded-[10px] gray-border"
                        [ngClass]="(formGroup.get('fromCity')?.value === 'All Cities' ||  formGroup.get('toCity')?.value === 'All Cities') ? 'w-full' : 'w-[45%]'">
                        <div class="flex flex-col min-w-[49%] max-w-[49%] h-[74px] py-3 pl-2 pr-[18px] border-r-[1px] gray-border cursor-pointer"
                            (click)="openFromCityDropdown()">
                            <span class="text-base px-[10px] max-w-max font-medium text-secondary">From</span>
                            <mat-select #fromCitySelect class="mt-1 pl-2 font-semibold text-lg"
                                (selectionChange)="onFromCitySelectionChange($event.value)" [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : 
                                     formGroup.get('fromCity').value.display_name +
                                     ', ' +
                                     formGroup.get('fromCity').value.country +
                                     ', ' +
                                     formGroup.get('fromCity').value.airport_name
                                 " [compareWith]="compareWith" formControlName="fromCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="fromCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of fromCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                        <div class="relative">
                            <div (click)="switch()" [matTooltip]="'Switch'"
                                class="flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg z-20 cursor-pointer border gray-border absolute top-[-16px] -left-[18px]">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                        </div>

                        <div class="flex flex-col min-w-[49%] h-[74px] max-w-[49%] py-3 pr-2 pl-[18px] cursor-pointer"
                            (click)="openToCityDropdown()">
                            <span class="text-base px-[10px] max-w-max font-medium text-secondary">To</span>
                            <mat-select #toCitySelect class="font-semibold text-lg pl-2 mt-1"
                                (selectionChange)="onToCitySelectionChange($event.value)" [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : 
                                     formGroup.get('toCity').value.display_name + ', ' +
                                     formGroup.get('toCity').value.country + ', ' +
                                     formGroup.get('toCity').value.airport_name" [compareWith]="compareWith"
                                formControlName="toCity">
                                <mat-option>
                                    <ngx-mat-select-search placeholderLabel="Search City"
                                        noEntriesFoundLabel="'no matching city found'" formControlName="toCityfilter">
                                    </ngx-mat-select-search>
                                </mat-option>
                                @if (formGroup.get('type')?.value === 'ab') {
                                <mat-option [value]="'All Cities'">
                                    <div class="flex flex-col h-15 justify-center w-[380px]">
                                        <span class="font-medium">All Cities</span>
                                        <span class="text-sm text-gray -mt-1"></span>
                                    </div>
                                </mat-option>
                                }
                                @for (ct of toCityList | async; track ct) {
                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                    <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                        <span class="font-medium truncate">{{ ct.display_name }},
                                            {{ct.country}}</span>
                                        <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                    </div>
                                </mat-option>
                                }
                            </mat-select>
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row items-center border-[1px] rounded-[10px] gray-border"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'max-w-90 min-w-90'">
                        @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                        <div class="flex flex-col w-[50%] h-[74px] px-3 py-3 "
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'border-r-[1px] gray-border'">
                            <div
                                class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                                <span class="font-medium text-secondary">Departure</span>
                                @if (formGroup.get('type').value !== 'ab') {
                                <mat-icon svgIcon="mat_outline:date_range" class="gray-text icon-size-5 cursor-pointer"
                                    (click)="picker.open()"></mat-icon>
                                }
                                @if (formGroup.get('type').value === 'ab') {
                                <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                }
                            </div>
                            <div class="flex flex-row">
                                <input class="font-semibold text-lg mt-1.5 max-w-[120px]" [min]="minDate"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                    [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                    (click)="picker.open()" [readonly]="true" [matDatepicker]="picker"
                                    formControlName="departureDate" />
                            </div>
                            <mat-datepicker #picker></mat-datepicker>
                        </div>
                        }
                        @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                        <div class="w-[50%] h-[74px] px-3 py-3 border-r-[1px] gray-border">
                            <span class="font-medium text-secondary">Departure</span>
                            <p-calendar class="fare_cal theam_1 theam_14" [readonlyInput]="true"
                                formControlName="departureDate" [showOtherMonths]="false" [selectOtherMonths]="false"
                                [minDate]="minDate" [dateFormat]="'dd M yy'">
                                <ng-template pTemplate="date" let-date>
                                    <span>
                                        {{ date.day }}
                                    </span>
                                    @if (fareMap[getFormattedDateNew(date)]) {
                                    <span
                                        [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                        fareMap[getFormattedDateNew(date)].price }}</span>
                                    }
                                </ng-template>
                            </p-calendar>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex flex-col w-[50%] h-[74px] px-3 py-3">
                            <div class="flex flex-row justify-between">
                                <div
                                    class="max-w-max w-[90%] flex flex-row justify-between text-secondary text-base min-w-[90%] font-medium">
                                    <span class="font-medium text-secondary">Return</span>
                                    <mat-icon svgIcon="mat_outline:date_range"
                                        class="gray-text icon-size-5 cursor-pointer"
                                        [ngClass]="{hidden: formGroup.get('type').value !== 'rt'}"
                                        (click)="pickerRe.open()"></mat-icon>
                                </div>
                                @if (formGroup.get('type').value === 'rt') {
                                <mat-icon class="icon-size-4 pt-[2px] mr-[-6px] cursor-pointer"
                                    (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                }
                            </div>
                            <div class="relative">
                                @if (formGroup.get('type').value === 'ow') {
                                <div class="absolute z-10 left-0 top-3 font-bold">-</div>
                                }
                                <p-calendar class="fare_cal theam_1 theam_14" [readonlyInput]="true"
                                    formControlName="returnDate" [showOtherMonths]="false" [selectOtherMonths]="false"
                                    [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                    (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (returnFareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                            returnFareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value === 'mc' && formDataList) {
                    <div class="w-full space-y-1 flex flex-col gap-3">
                        @for (formData of formDataList; track formData; let i = $index) {
                        <div class="w-full flex">
                            <div class="flex w-full pr-3">
                                <div class="flex flex-row items-center border-[1px] rounded-[10px] gray-border">
                                    <div class="flex flex-col w-[345px] h-[74px] py-3 px-2 border-r-[1px] gray-border cursor-pointer"
                                        (click)="openFromMultiCityDropdown(i)">
                                        <span
                                            class="px-[10px] max-w-max text-base font-medium text-secondary">From</span>
                                        <mat-select #fromMultiCitySelect
                                            class="mt-1 pl-2 pr-[18px] font-semibold text-lg"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                            [compareWith]="compareWith" [matTooltip]="
                                                         formData?.fromCity?.display_name + ', ' +
                                                         formData?.fromCity?.country + ', ' +
                                                         formData?.fromCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterfrom"
                                                    [ngModelOptions]="{standalone: true}"
                                                    (input)="filterfrom($event.target.value, formData, 'from')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.fromListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                    <div class="relative z-20">
                                        <div (click)="switch(i)"
                                            class="absolute top-[-16px] -left-[18px] flex flex-row justify-center items-center rounded-full w-9 h-9 white-bg cursor-pointer border gray-border"
                                            [matTooltip]="'Switch'">
                                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                class="icon-size-4 primary-text"></mat-icon>
                                        </div>
                                    </div>

                                    <div class="flex flex-col w-[345px] h-[74px] py-3 pr-2 pl-[18px]  rounded-lg  cursor-pointer"
                                        (click)="openToMultiCityDropdown(i)">
                                        <span class="px-[10px] max-w-max text-base font-medium text-secondary">To</span>
                                        <mat-select #toMultiCitySelect class="pl-2 font-semibold text-lg mt-1"
                                            [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                            [compareWith]="compareWith" (ngModelChange)="changeValue($event, i, 'to')"
                                            [matTooltip]="!formData?.toCity ? '' :
                                                         formData?.toCity?.display_name + ', ' +
                                                         formData?.toCity?.country + ', ' +
                                                         formData?.toCity?.airport_name">
                                            <mat-option>
                                                <ngx-mat-select-search placeholderLabel="Search City"
                                                    noEntriesFoundLabel="'no matching city found'"
                                                    [(ngModel)]="formData.filterto"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    (input)=" filterfrom($event.target.value, formData, 'to')">
                                                </ngx-mat-select-search>
                                            </mat-option>
                                            @for (ct of formData.toListData; track ct) {
                                            <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                    <span class="font-medium truncate">{{ ct.display_name }},
                                                        {{ct.country}}</span>
                                                    <span
                                                        class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                </div>
                                            </mat-option>
                                            }
                                        </mat-select>
                                    </div>
                                </div>
                                <div class="flex flex-row items-center space-x-0 w-[168px] ml-3">
                                    <div
                                        class="flex flex-col w-[170px] h-[74px] border-[1px] rounded-[10px] gray-border px-3 py-3">
                                        <div
                                            class="max-w-max w-full flex flex-row justify-between text-secondary text-base min-w-full font-medium">
                                            <span class="font-medium text-secondary">Departure</span>
                                            <mat-icon svgIcon="mat_outline:date_range"
                                                class="gray-text icon-size-5 cursor-pointer"
                                                (click)="picker.open()"></mat-icon>
                                        </div>
                                        <div class="flex flex-row" (click)="picker.open()">
                                            <input class="font-semibold text-lg mt-1 max-w-[120px]"
                                                [ngModelOptions]="{ standalone: true }" [min]="
                                                         i == 0 ? minDate : formDataList[i - 1] ?.departureDate"
                                                [readonly]="true" [matDatepicker]="picker"
                                                [(ngModel)]="formData.departureDate"
                                                (ngModelChange)="changeDate($event, i)" />
                                        </div>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </div>
                                </div>
                            </div>
                            @if (i === 0) {
                            <div
                                class="flex flex-col flex-grow p-3 h-[74px] border-[1px] rounded-[10px] gray-border w-[434px]">
                                <span class="max-w-max text-base font-medium text-secondary">Travellers
                                    | Class</span>
                                <span class="truncate font-semibold text-lg pt-1 cursor-pointer"
                                    (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">{{
                                    formGroup.get("adult").value +
                                    formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }} </span>
                            </div>
                            }
                            @if (i != 0 && i === formDataList.length - 1) {
                            <div class="flex items-center gap-1 space-x-1 w-[434px] justify-between">
                                @if (i > 1) {
                                <button
                                    class="rounded-md flex items-center justify-center h-[40px] w-[50px] max-w-10 primary-border border border-solid"
                                    mat-ripple [matRippleCentered]="true" (click)="removeCity(i)">
                                    <mat-icon class="material-symbols-outlined"><span
                                            class="text-3xl primary-text">close</span></mat-icon>
                                </button>
                                }
                                @if (i < 4) { <button mat-flat-button
                                    class="rounded-md font-semibold text-[15px] primary-text primary-border border border-solid"
                                    (click)="addCity(i)">
                                    <div class="pt-0.5">+ Add Another City</div>
                                    </button>
                                    }
                                    <div class="flex flex-row justify-center items-end pl-1">
                                        <button mat-flat-button
                                            class="w-[73px] mb-0.5 min-w-[73px] min-h-[73px] rounded-lg primary-bg text-white"
                                            (click)="detail()">
                                            <mat-icon svgIcon="feather:search"
                                                class="icon-size-8 font-light text-white"></mat-icon>
                                        </button>
                                    </div>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-col  flex-grow p-3 h-[74px] border-[1px] rounded-[10px] gray-border"
                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'w-[189px] max-w-[189px]'">
                        <span class="max-w-max text-secondary font-medium text-base">Travellers
                            | Class</span>
                        <div class="w-full truncate font-semibold text-lg max-w-full pt-1 cursor-pointer"
                            (click)="travellersClass()"
                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value ">
                            {{formGroup.get("adult").value + formGroup.get("child").value +
                            formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}
                        </div>
                    </div>
                    }
                    @if (formGroup.get('type').value != 'mc') {
                    <div class="flex flex-row justify-center items-end">
                        <button mat-flat-button
                            class="w-[73px] mb-0.5 min-w-[73px] min-h-[73px] rounded-lg primary-bg text-white"
                            (click)="detail()">
                            <mat-icon svgIcon="feather:search" class="icon-size-8 font-light text-white"></mat-icon>
                        </button>
                    </div>
                    }
                </div>
                @if (formGroup.get('type').value != 'ab') {
                <div class="flex items-center gap-[16px] mb-4">
                    <span class="font-medium text-gray">Special Fare:</span>
                    <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                        formControlName="fareType" aria-label="Special Fare Selection">
                        @for (fare of fareType; track fare) {
                        <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                            class="rounded-[6px] h-[30px] text-[13px]"
                            [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' :''"
                            [value]="fare.key">
                            {{fare.key}}
                        </mat-button-toggle>
                        }
                    </mat-button-toggle-group>
                </div>
                }
            </form>
        </div>
    </div>
</div>
}
<!--Theme 15 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme15) {
<div class="flex relative flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover relative flex flex-col bg-center bg-no-repeat primary-bg w-full gray-text"
        style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important; background-color: #0000007a !important;"
        [ngClass]="formGroup.get('type').value != 'mc' ? 'h-[650px]' : formDataList?.length == 2 ? 'h-[750px]' : formDataList?.length == 3 ? 'h-[850px]' : formDataList?.length == 4 ? 'h-[950px]' : formDataList?.length == 5 ? 'h-[1050px]' : 'h-[1150px]'">
        <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
            <div class="flex flex-col min-w-[1260px] max-w-[1260px]">
                <div class="flex">
                    <h1 class="text-[48px] text-center font-semibold white-text w-full z-[99]"
                        style="font-family: sans-serif;">
                        {{flightData?.title}}</h1>
                </div>
                <div class="flex text-[20px] white-text justify-center">
                    <div class="w-[900px] z-[99] font-light textNote2 text-center">
                        {{flightData?.description}}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center">
        <div class="min-w-[1260px] max-w-[1260px]  flex">
            <div class="min-w-[1260px] max-w-[1260px] px-7 rounded-[18px] white-bg shadow-xl"
                [ngClass]="{ 'rounded-tl-none' : isFirstService }">
                <form [formGroup]="formGroup" class="flex flex-col pt-6 pb-2">
                    <div class="flex flex-row">
                        <mat-radio-group formControlName="type"
                            (change)="optionChange($event.value); selectedField = ''">
                            <div class="flex flex-row space-x-6">
                                @for (ft of flightType; track ft) {
                                <mat-radio-button class="ctm_radio1" [value]="ft.id">
                                    <div class="cursor-pointer font-normal text-lg pl-1 pt-[3px]"
                                        [ngClass]="ft.id == this.formGroup.get('type').value ? 'primary-text font-medium' :'text-secondary'">
                                        {{ft.name}}
                                    </div>
                                </mat-radio-button>
                                }
                            </div>
                        </mat-radio-group>
                    </div>
                    <div class="flex flex-row space-x-3 mt-6 mb-5">
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row items-center w-[45%]"
                            [ngClass]="(formGroup.get('fromCity')?.value === 'All Cities' ||  formGroup.get('toCity')?.value === 'All Cities') ? 'w-full' : ''">
                            <div class="flex flex-col min-w-[49%] max-w-[49%] h-[74px] py-3 px-2 border gray-border rounded-xl -mr-3 cursor-pointer"
                                (click)="openFromCityDropdown()">
                                <span class="text-[15px] px-[10px] max-w-max font-normal text-secondary">From</span>
                                <mat-select #fromCitySelect class="mt-1 pl-2 font-semibold text-lg"
                                    (selectionChange)="onFromCitySelectionChange($event.value)" [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : 
                                              formGroup.get('fromCity').value.display_name +
                                              ', ' +
                                              formGroup.get('fromCity').value.country +
                                              ', ' +
                                              formGroup.get('fromCity').value.airport_name
                                          " [compareWith]="compareWith" formControlName="fromCity">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="fromCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @if (formGroup.get('type')?.value === 'ab') {
                                    <mat-option [value]="'All Cities'">
                                        <div class="flex flex-col h-15 justify-center w-[380px]">
                                            <span class="font-medium">All Cities</span>
                                            <span class="text-sm text-gray -mt-1"></span>
                                        </div>
                                    </mat-option>
                                    }
                                    @for (ct of fromCityList | async; track ct) {
                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                        <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                            <span class="font-medium truncate">{{ ct.display_name }},
                                                {{ct.country}}</span>
                                            <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                            <div (click)="switch()" [matTooltip]="'Switch'"
                                class="flex flex-row justify-center items-center w-9 h-9 bg-white gray-border border rounded-full z-20 cursor-pointer">
                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                    class="icon-size-4 primary-text"></mat-icon>
                            </div>
                            <div class="flex flex-col min-w-[49%] h-[74px] max-w-[49%] py-3 px-2 border gray-border rounded-xl -mr-3 ml-[-12px] cursor-pointer"
                                (click)="openToCityDropdown()">
                                <span class="px-[10px] max-w-max text-[15px] font-normal text-secondary">To</span>
                                <mat-select #toCitySelect class="pl-2 font-semibold text-lg mt-1"
                                    (selectionChange)="onToCitySelectionChange($event.value)" [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : 
                                              formGroup.get('toCity').value.display_name + ', ' +
                                              formGroup.get('toCity').value.country + ', ' +
                                              formGroup.get('toCity').value.airport_name" [compareWith]="compareWith"
                                    formControlName="toCity">
                                    <mat-option>
                                        <ngx-mat-select-search placeholderLabel="Search City"
                                            noEntriesFoundLabel="'no matching city found'"
                                            formControlName="toCityfilter">
                                        </ngx-mat-select-search>
                                    </mat-option>
                                    @if (formGroup.get('type')?.value === 'ab') {
                                    <mat-option [value]="'All Cities'">
                                        <div class="flex flex-col h-15 justify-center w-[380px]">
                                            <span class="font-medium">All Cities</span>
                                            <span class="text-sm text-gray -mt-1"></span>
                                        </div>
                                    </mat-option>
                                    }
                                    @for (ct of toCityList | async; track ct) {
                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                        <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                            <span class="font-medium truncate">{{ ct.display_name }},
                                                {{ct.country}}</span>
                                            <span class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                        </div>
                                    </mat-option>
                                    }
                                </mat-select>
                            </div>
                        </div>
                        }
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-row items-center space-x-3"
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'min-w-[280px] max-w-[400px]' : 'max-w-72 min-w-72'">
                            @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                            <div class="flex flex-col h-[74px] border gray-border rounded-xl p-3"
                                [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'w-[48%]'">
                                <div class="flex flex-row justify-between">
                                    <span class="max-w-max text-[15px] font-normal text-secondary">Departure</span>
                                    @if (formGroup.get('type').value === 'ab') {
                                    <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                    }
                                </div>
                                <div class="flex flex-row">
                                    <input class="font-semibold text-black text-lg mt-1 max-w-[120px]"
                                        [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                        [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                        [min]="minDate" (click)="picker.open()" [readonly]="true"
                                        [matDatepicker]="picker" formControlName="departureDate" />
                                </div>
                                <mat-datepicker #picker></mat-datepicker>
                            </div>
                            }
                            @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                            <div class="w-[48%] h-[74px] border gray-border rounded-xl p-3 relative">
                                <span class="text-[15px] font-normal text-secondary">Departure</span>
                                <p-calendar class="fare_cal theam_1 theam_15" [readonlyInput]="true"
                                    formControlName="departureDate" [showOtherMonths]="false"
                                    [selectOtherMonths]="false" [minDate]="minDate" [dateFormat]="'dd M yy'">
                                    <ng-template pTemplate="date" let-date>
                                        <span>
                                            {{ date.day }}
                                        </span>
                                        @if (fareMap[getFormattedDateNew(date)]) {
                                        <span
                                            [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                            fareMap[getFormattedDateNew(date)].price }}</span>
                                        }
                                    </ng-template>
                                </p-calendar>
                            </div>
                            }
                            @if (formGroup.get('type').value != 'ab') {
                            <div class="flex flex-col w-[48%] h-[74px] border gray-border rounded-xl p-3">
                                <div class="flex flex-row justify-between">
                                    <span class="max-w-max text-secondary text-[15px] font-normal">Return</span>
                                    @if (formGroup.get('type').value === 'rt') {
                                    <mat-icon class="icon-size-4 pt-[2px] mr-[-4px] cursor-pointer"
                                        (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                    }
                                </div>
                                <div class="relative">
                                    @if (formGroup.get('type').value === 'ow') {
                                    <div class="absolute z-10 left-0 top-2 font-bold">-</div>
                                    }
                                    <p-calendar class="fare_cal theam_1 theam_15" [readonlyInput]="true"
                                        formControlName="returnDate" [showOtherMonths]="false"
                                        [selectOtherMonths]="false" [minDate]="formGroup.get('departureDate').value"
                                        [dateFormat]="'dd M yy'"
                                        (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                        <ng-template pTemplate="date" let-date>
                                            <span>
                                                {{ date.day }}
                                            </span>
                                            @if (returnFareMap[getFormattedDateNew(date)]) {
                                            <span
                                                [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                                returnFareMap[getFormattedDateNew(date)].price }}</span>
                                            }
                                        </ng-template>
                                    </p-calendar>
                                </div>
                            </div>
                            }
                        </div>
                        }
                        @if (formGroup.get('type').value === 'mc' && formDataList) {
                        <div class="w-full space-y-3 flex flex-col gap-3">
                            @for (formData of formDataList; track formData; let i = $index) {
                            <div class="w-full flex">
                                <div class="flex pr-3">
                                    <div class="flex flex-row items-center">
                                        <div class="flex flex-col w-[300px] h-[74px] py-3 px-2 border gray-border rounded-xl -mr-3 cursor-pointer"
                                            (click)="openFromMultiCityDropdown(i)">
                                            <span
                                                class="px-[10px] max-w-max text-[15px] font-normal text-secondary">From</span>
                                            <mat-select #fromMultiCitySelect class="mt-1 pl-2 font-semibold text-lg"
                                                [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.fromCity"
                                                [compareWith]="compareWith" [matTooltip]="
                                                                  formData?.fromCity?.display_name + ', ' +
                                                                  formData?.fromCity?.country + ', ' +
                                                                  formData?.fromCity?.airport_name">
                                                <mat-option>
                                                    <ngx-mat-select-search placeholderLabel="Search City"
                                                        noEntriesFoundLabel="'no matching city found'"
                                                        [(ngModel)]="formData.filterfrom"
                                                        [ngModelOptions]="{standalone: true}"
                                                        (input)="filterfrom($event.target.value, formData, 'from')">
                                                    </ngx-mat-select-search>
                                                </mat-option>
                                                @for (ct of formData.fromListData; track ct) {
                                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                    <div
                                                        class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                        <span class="font-medium truncate">{{ ct.display_name }},
                                                            {{ct.country}}</span>
                                                        <span
                                                            class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                    </div>
                                                </mat-option>
                                                }
                                            </mat-select>
                                        </div>
                                        <div (click)="switch(i)"
                                            class="flex flex-row justify-center items-center w-9 h-9 border gray-border rounded-full white-bg z-20 cursor-pointer"
                                            [matTooltip]="'Switch'">
                                            <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                class="icon-size-4 primary-text"></mat-icon>
                                        </div>
                                        <div class="flex flex-col w-[300px] h-[74px] py-3 px-2 rounded-xl border gray-border -mr-3 ml-[-12px] cursor-pointer"
                                            (click)="openToMultiCityDropdown(i)">
                                            <span
                                                class="text-[15px] px-[10px] max-w-max font-normal text-secondary">To</span>
                                            <mat-select #toMultiCitySelect class="pl-2 font-semibold text-lg mt-1"
                                                [ngModelOptions]="{ standalone: true }" [(ngModel)]="formData.toCity"
                                                [compareWith]="compareWith"
                                                (ngModelChange)="changeValue($event, i, 'to')" [matTooltip]="!formData?.toCity ? '' :
                                                                  formData?.toCity?.display_name + ', ' +
                                                                  formData?.toCity?.country + ', ' +
                                                                  formData?.toCity?.airport_name">
                                                <mat-option>
                                                    <ngx-mat-select-search placeholderLabel="Search City"
                                                        noEntriesFoundLabel="'no matching city found'"
                                                        [(ngModel)]="formData.filterto"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        (input)=" filterfrom($event.target.value, formData, 'to')">
                                                    </ngx-mat-select-search>
                                                </mat-option>
                                                @for (ct of formData.toListData; track ct) {
                                                <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                    <div
                                                        class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                        <span class="font-medium truncate">{{ ct.display_name }},
                                                            {{ct.country}}</span>
                                                        <span
                                                            class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                    </div>
                                                </mat-option>
                                                }
                                            </mat-select>
                                        </div>
                                    </div>
                                    <div class="flex flex-row items-center space-x-0 w-[150px] ml-6">
                                        <div
                                            class="flex flex-col w-[170px] h-[74px] border gray-border rounded-xl px-3 py-2.5">
                                            <span
                                                class="max-w-max text-secondary text-[15px] font-normal">Departure</span>
                                            <div class="flex flex-row" (click)="picker.open()">
                                                <input class="font-semibold text-black text-lg mt-1 max-w-[120px]"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [min]="
                                                                  i == 0 ? minDate : formDataList[i - 1] ?.departureDate" [readonly]="true"
                                                    [matDatepicker]="picker" [(ngModel)]="formData.departureDate"
                                                    (ngModelChange)="changeDate($event, i)" />
                                            </div>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </div>
                                    </div>
                                </div>
                                @if (i === 0) {
                                <div
                                    class="flex flex-col flex-grow p-3 pt-[13px] h-[74px] border gray-border rounded-xl w-[260px] max-w-[260px]">
                                    <span class="max-w-max text-secondary text-[15px] font-normal">Travellers
                                        | Class</span>
                                    <span class="truncate font-semibold text-black text-lg cursor-pointer max-w-[260px]"
                                        (click)="travellersClass()"
                                        [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">{{
                                        formGroup.get("adult").value +
                                        formGroup.get("child").value +
                                        formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                        }}</span>
                                </div>
                                }
                                @if (i != 0 && i === formDataList.length - 1) {
                                <div class="flex items-center gap-1 space-x-1 w-[275px]">
                                    @if (i > 1) {
                                    <button mat-flat-button class="rounded-md primary-border border border-solid"
                                        (click)="removeCity(i)">
                                        <mat-icon class="material-symbols-outlined"><span
                                                class="text-3xl primary-text">close</span></mat-icon>
                                    </button>
                                    }
                                    @if (i < 4) { <button mat-flat-button
                                        class="rounded-md font-semibold text-[15px] primary-text primary-border border border-solid"
                                        (click)="addCity(i)">
                                        <div class="pt-0.5">+ Add Another City</div>
                                        </button>
                                        }
                                </div>
                                }
                            </div>
                            }
                        </div>
                        }
                        @if (formGroup.get('type').value != 'mc') {
                        <div class="flex flex-col flex-grow p-3 pt-[13px] rounded-xl gray-border border h-[74px]"
                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-[220px]' : 'w-[200px]'">
                            <span class="max-w-max text-secondary text-[15px] font-normal">Travellers
                                | Class</span>
                            <span class="truncate font-semibold text-black text-lg max-w-full cursor-pointer"
                                (click)="travellersClass()"
                                [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">
                                {{formGroup.get("adult").value + formGroup.get("child").value +
                                formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value }}</span>
                        </div>
                        }
                        <div class="flex flex-row justify-center items-center">
                            <button mat-flat-button class="w-[130px] min-h-18 rounded-xl primary-bg" (click)="detail()">
                                <span class="white-text font-medium text-2xl">Search</span>
                            </button>
                        </div>
                    </div>
                    @if (formGroup.get('type').value != 'ab') {
                    <div class="flex items-center gap-[16px] mb-4">
                        <span class="font-medium text-gray">Special Fare:</span>
                        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" class="h-[30px] gap-1"
                            formControlName="fareType" aria-label="Special Fare Selection">
                            @for (fare of fareType; track fare) {
                            <mat-button-toggle (click)="CheckFareTypeValidation()" #tooglebtn [matTooltip]="fare.value"
                                class="rounded-[6px] h-[30px] text-[13px]"
                                [ngClass]="formGroup.get('fareType').value === fare.key ? 'secondary-bg' :''"
                                [value]="fare.key">
                                {{fare.key}}
                            </mat-button-toggle>
                            }
                        </mat-button-toggle-group>
                    </div>
                    }
                </form>
            </div>
        </div>
    </div>
</div>
}
<!--Theme 16 -->
@if (flightData?.is_active == true && wlSettingsDetails?.theme?.wl_theme === themes.theme16) {
<div class="flex relative flex-col justify-center w-full items-center mobile:hidden tablet:hidden">
    <div class="bg-cover relative flex flex-col bg-center bg-no-repeat primary-bg w-full gray-text"
        style="background-image: url('{{flightData?.background_image}}');background-blend-mode: color !important; background-color: #0000007a !important;"
        [ngClass]="formGroup.get('type').value != 'mc' ? 'h-[650px]' : formDataList?.length == 2 ? 'h-[750px]' : formDataList?.length == 3 ? 'h-[850px]' : formDataList?.length == 4 ? 'h-[950px]' : formDataList?.length == 5 ? 'h-[1050px]' : 'h-[1150px]'">
        <div class="flex flex-col h-full items-center justify-center max-h-[17rem] pt-[70px]">
            <div class="flex flex-col justify-start min-w-[1260px] max-w-[1260px]">
                <h1 class="text-[48px] font-semibold white-text w-full z-[99] uppercase"
                    style="font-family: 'Mina'; text-shadow: 2px 2px 4px rgba(0,0,0,0.4);">
                    {{flightData?.title}}
                </h1>
                <div class="w-[900px] z-[99] text-[20px] white-text font-light textNote2"
                    style="text-shadow: 1px 1px 3px rgba(0,0,0,0.3);">
                    {{flightData?.description}}
                </div>
            </div>
        </div>
    </div>
    <div class="absolute top-[335px] left-0 right-0 min-h-fit flex w-full justify-center ">
        <div class="min-w-[1260px] max-w-[1260px] z-[99] flex">
            <div class="absolute min-w-[1260px] max-w-[1260px] mx-auto font-['Poppins']">
                <div
                    class="bg-white/40 p-6 w-full backdrop-blur-md rounded-[20px] flex flex-col custom-flight-header-curve z-[98]">
                    <div class="flex items-center pt-1 gap-3 font-bold">
                        @for (ft of flightType; track ft) {
                        <button (click)="optionChange(ft.id); selectedField = ''"
                            [ngClass]="formGroup.get('type')?.value === ft.id ? 'primary-bg text-white' : 'bg-white text-gray-500'"
                            class="py-2 px-4 rounded-full text-lg font-semibold cursor-pointer">
                            {{ ft.name }}
                        </button>
                        }
                    </div>
                    <form [formGroup]="formGroup" class="flex pt-7 flex-col ">
                        <div class="flex flex-row space-x-3">
                            @if (formGroup.get('type').value != 'mc') {
                            <div class="flex flex-row items-center gap-[39px] w-[45%] relative"
                                [ngClass]="(formGroup.get('fromCity')?.value === 'All Cities' && formGroup.get('toCity')?.value === 'All Cities') ? 'me-3' : ''">
                                <div class="flex flex-col min-w-[270px] max-w-[49%] h-[74px] py-3 px-2 white-bg rounded-2xl -mr-4 cursor-pointer custom-right-circle"
                                    (click)="openFromCityDropdown()">
                                    <span class="text-[15px] px-[10px] max-w-max font-normal text-secondary">From</span>
                                    <mat-select #fromCitySelect class="mt-1 pl-2 font-semibold text-lg"
                                        (selectionChange)="onFromCitySelectionChange($event.value)" [matTooltip]="formGroup.get('fromCity')?.value === 'All Cities' ? '' : 
                                              formGroup.get('fromCity').value.display_name +
                                              ', ' +
                                              formGroup.get('fromCity').value.country +
                                              ', ' +
                                              formGroup.get('fromCity').value.airport_name
                                          " [compareWith]="compareWith" formControlName="fromCity">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="fromCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @if (formGroup.get('type')?.value === 'ab') {
                                        <mat-option [value]="'All Cities'">
                                            <div class="flex flex-col h-15 justify-center w-[380px]">
                                                <span class="font-medium">All Cities</span>
                                                <span class="text-sm text-gray -mt-1"></span>
                                            </div>
                                        </mat-option>
                                        }
                                        @for (ct of fromCityList | async; track ct) {
                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('toCity')?.value?.airport_code }" [value]="ct">
                                            <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                <span class="font-medium truncate">{{ ct.display_name }},
                                                    {{ct.country}}</span>
                                                <span
                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                                <div (click)="switch()" [matTooltip]="'Switch'"
                                    class="absolute left-[255px] bottom-[19px] flex flex-row justify-center items-center w-9 h-9 bg-white gray-border border rounded-full z-20 cursor-pointer">
                                    <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                        class="icon-size-4 primary-text"></mat-icon>
                                </div>
                                <div class="flex flex-col min-w-[270px] h-[74px] max-w-[49%] py-3 px-2 white-bg rounded-2xl -mr-3 ml-[-16px] cursor-pointer custom-left-circle"
                                    (click)="openToCityDropdown()">
                                    <span class="px-[10px] max-w-max text-[15px] font-normal text-secondary">To</span>
                                    <mat-select #toCitySelect class="pl-2 font-semibold text-lg mt-1"
                                        (selectionChange)="onToCitySelectionChange($event.value)" [matTooltip]="formGroup.get('toCity')?.value === 'All Cities' ? '' : 
                                              formGroup.get('toCity').value.display_name + ', ' +
                                              formGroup.get('toCity').value.country + ', ' +
                                              formGroup.get('toCity').value.airport_name" [compareWith]="compareWith"
                                        formControlName="toCity">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City"
                                                noEntriesFoundLabel="'no matching city found'"
                                                formControlName="toCityfilter">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        @if (formGroup.get('type')?.value === 'ab') {
                                        <mat-option [value]="'All Cities'">
                                            <div class="flex flex-col h-15 justify-center w-[380px]">
                                                <span class="font-medium">All Cities</span>
                                                <span class="text-sm text-gray -mt-1"></span>
                                            </div>
                                        </mat-option>
                                        }
                                        @for (ct of toCityList | async; track ct) {
                                        <mat-option [ngClass]="{ hidden: ct?.airport_code === formGroup?.get('fromCity')?.value?.airport_code }" [value]="ct">
                                            <div class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                <span class="font-medium truncate">{{ ct.display_name }},
                                                    {{ct.country}}</span>
                                                <span
                                                    class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                            </div>
                                        </mat-option>
                                        }
                                    </mat-select>
                                </div>
                            </div>
                            }
                            @if (formGroup.get('type').value != 'mc') {
                            <div class="flex flex-row items-center space-x-3"
                                [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : 'max-w-72 min-w-72'">
                                @if (formGroup.get('type').value != 'ow' && formGroup.get('type').value != 'rt') {
                                <div class="flex flex-col w-[48%] h-[74px] bg-white rounded-2xl p-3"
                                    [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full' : ''">
                                    <div class="flex flex-row justify-between">
                                        <span class="max-w-max text-[15px] font-normal text-secondary">Departure</span>
                                        @if (formGroup.get('type').value === 'ab') {
                                        <mat-icon class="icon-size-4" (click)="cancelDepartureDate()">cancel</mat-icon>
                                        }
                                    </div>
                                    <div class="flex flex-row">
                                        <input class="font-semibold text-black text-lg mt-1 max-w-[120px]"
                                            [ngClass]="(formGroup.get('type').value == 'ab') ? 'w-full custom-placeholder' : ''"
                                            [placeholder]="formGroup.get('type')?.value === 'ab' ? 'All Dates' : ''"
                                            [min]="minDate" (click)="picker.open()" [readonly]="true"
                                            [matDatepicker]="picker" formControlName="departureDate" />
                                    </div>
                                    <mat-datepicker #picker></mat-datepicker>
                                </div>
                                }
                                @if (formGroup.get('type').value === 'ow' || formGroup.get('type').value === 'rt') {
                                <div class="w-[48%] h-[74px] bg-white rounded-2xl p-3 relative z-[99]">
                                    <span class="text-[15px] font-normal text-secondary">Departure</span>
                                    <p-calendar appendTo="document.body" class="fare_cal theam_1 theam_15"
                                        [readonlyInput]="true" formControlName="departureDate" [showOtherMonths]="false"
                                        [selectOtherMonths]="false" [minDate]="minDate" [dateFormat]="'dd M yy'">
                                        <ng-template pTemplate="date" let-date>
                                            <span>
                                                {{ date.day }}
                                            </span>
                                            @if (fareMap[getFormattedDateNew(date)]) {
                                            <span
                                                [ngClass]="{ 'text-orange-500': fareMap[getFormattedDateNew(date)].is_orange }">{{
                                                fareMap[getFormattedDateNew(date)].price }}</span>
                                            }
                                        </ng-template>
                                    </p-calendar>
                                </div>
                                }
                                @if (formGroup.get('type').value != 'ab') {
                                <div class="flex flex-col w-[48%] h-[74px] bg-white rounded-2xl p-3">
                                    <div class="flex flex-row justify-between">
                                        <span class="max-w-max text-secondary text-[15px] font-normal">Return</span>
                                        @if (formGroup.get('type').value === 'rt') {
                                        <mat-icon class="icon-size-4 pt-[2px] mr-[-4px] cursor-pointer"
                                            (click)="cancelReturnDate();flightTypeChange( { id: 'ow'})">cancel</mat-icon>
                                        }
                                    </div>
                                    <div class="relative">
                                        @if (formGroup.get('type').value === 'ow') {
                                        <div class="absolute z-10 left-0 top-2 font-bold">-</div>
                                        }
                                        <p-calendar appendTo="document.body" class="fare_cal theam_1 theam_15"
                                            [readonlyInput]="true" formControlName="returnDate"
                                            [showOtherMonths]="false" [selectOtherMonths]="false"
                                            [minDate]="formGroup.get('departureDate').value" [dateFormat]="'dd M yy'"
                                            (click)="formGroup.get('type').value == 'ow' ? formGroup.get('type').patchValue('rt') : null;fetchReturnDateFares()">
                                            <ng-template pTemplate="date" let-date>
                                                <span>
                                                    {{ date.day }}
                                                </span>
                                                @if (returnFareMap[getFormattedDateNew(date)]) {
                                                <span
                                                    [ngClass]="{ 'text-orange-500': returnFareMap[getFormattedDateNew(date)].is_orange }">{{
                                                    returnFareMap[getFormattedDateNew(date)].price }}</span>
                                                }
                                            </ng-template>
                                        </p-calendar>
                                    </div>
                                </div>
                                }
                            </div>
                            }
                            @if (formGroup.get('type').value === 'mc' && formDataList) {
                            <div class="w-full space-y-3 flex flex-col gap-3">
                                @for (formData of formDataList; track formData; let i = $index) {
                                <div class="w-full flex">
                                    <div class="flex pr-3">
                                        <div class="flex flex-row items-center gap-[39px] relative">
                                            <div class="flex flex-col w-[300px] h-[74px] py-3 px-2 white-bg rounded-2xl -mr-4 cursor-pointer custom-ml-right-circle"
                                                (click)="openFromMultiCityDropdown(i)">
                                                <span
                                                    class="px-[10px] max-w-max text-[15px] font-normal text-secondary">From</span>
                                                <mat-select #fromMultiCitySelect class="mt-1 pl-2 font-semibold text-lg"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.fromCity" [compareWith]="compareWith"
                                                    [matTooltip]="
                                                                  formData?.fromCity?.display_name + ', ' +
                                                                  formData?.fromCity?.country + ', ' +
                                                                  formData?.fromCity?.airport_name">
                                                    <mat-option>
                                                        <ngx-mat-select-search placeholderLabel="Search City"
                                                            noEntriesFoundLabel="'no matching city found'"
                                                            [(ngModel)]="formData.filterfrom"
                                                            [ngModelOptions]="{standalone: true}"
                                                            (input)="filterfrom($event.target.value, formData, 'from')">
                                                        </ngx-mat-select-search>
                                                    </mat-option>
                                                    @for (ct of formData.fromListData; track ct) {
                                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.toCity?.airport_code }" [value]="ct">
                                                        <div
                                                            class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                            <span class="font-medium truncate">{{ ct.display_name
                                                                }},
                                                                {{ct.country}}</span>
                                                            <span
                                                                class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                        </div>
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </div>
                                            <div (click)="switch(i)" [matTooltip]="'Switch'"
                                                class="absolute left-[285px] bottom-[19px] flex flex-row justify-center items-center w-9 h-9 bg-white gray-border border rounded-full z-20 cursor-pointer">
                                                <mat-icon svgIcon="heroicons_outline:arrows-right-left"
                                                    class="icon-size-4 primary-text"></mat-icon>
                                            </div>
                                            <div class="flex flex-col w-[300px] h-[74px] py-3 px-2 rounded-2xl white-bg -mr-3 ml-[-16px] cursor-pointer custom-ml-left-circle"
                                                (click)="openToMultiCityDropdown(i)">
                                                <span
                                                    class="text-[15px] px-[10px] max-w-max font-normal text-secondary">To</span>
                                                <mat-select #toMultiCitySelect class="pl-2 font-semibold text-lg mt-1"
                                                    [ngModelOptions]="{ standalone: true }"
                                                    [(ngModel)]="formData.toCity" [compareWith]="compareWith"
                                                    (ngModelChange)="changeValue($event, i, 'to')" [matTooltip]="!formData?.toCity ? '' :
                                                                  formData?.toCity?.display_name + ', ' +
                                                                  formData?.toCity?.country + ', ' +
                                                                  formData?.toCity?.airport_name">
                                                    <mat-option>
                                                        <ngx-mat-select-search placeholderLabel="Search City"
                                                            noEntriesFoundLabel="'no matching city found'"
                                                            [(ngModel)]="formData.filterto"
                                                            [ngModelOptions]="{ standalone: true }"
                                                            (input)=" filterfrom($event.target.value, formData, 'to')">
                                                        </ngx-mat-select-search>
                                                    </mat-option>
                                                    @for (ct of formData.toListData; track ct) {
                                                    <mat-option [ngClass]="{ hidden: ct?.airport_code === formData?.fromCity?.airport_code }" [value]="ct">
                                                        <div
                                                            class="flex flex-col h-15 justify-center truncate max-w-[370px]">
                                                            <span class="font-medium truncate">{{ ct.display_name
                                                                }},
                                                                {{ct.country}}</span>
                                                            <span
                                                                class="text-sm text-gray -mt-1 truncate">{{ct.airport_name}}</span>
                                                        </div>
                                                    </mat-option>
                                                    }
                                                </mat-select>
                                            </div>
                                        </div>
                                        <div class="flex flex-row items-center space-x-0 w-[150px] ml-6">
                                            <div
                                                class="flex flex-col w-[170px] h-[74px] white-bg rounded-2xl px-3 py-2.5">
                                                <span
                                                    class="max-w-max text-secondary text-[15px] font-normal">Departure</span>
                                                <div class="flex flex-row" (click)="picker.open()">
                                                    <input class="font-semibold text-black text-lg mt-1 max-w-[120px]"
                                                        [ngModelOptions]="{ standalone: true }"
                                                        [min]="
                                                                  i == 0 ? minDate : formDataList[i - 1] ?.departureDate" [readonly]="true"
                                                        [matDatepicker]="picker" [(ngModel)]="formData.departureDate"
                                                        (ngModelChange)="changeDate($event, i)" />
                                                </div>
                                                <mat-datepicker #picker></mat-datepicker>
                                            </div>
                                        </div>
                                    </div>
                                    @if (i === 0) {
                                    <div class="flex flex-col flex-grow p-3 pt-[13px] h-[74px] white-bg rounded-2xl ">
                                        <span class="max-w-max text-secondary text-[15px] font-normal">Travellers
                                            | Class</span>
                                        <span
                                            class="truncate font-semibold text-black text-lg cursor-pointer max-w-[260px]"
                                            (click)="travellersClass()"
                                            [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">{{
                                            formGroup.get("adult").value +
                                            formGroup.get("child").value +
                                            formGroup.get("infant").value}} Pax, {{
                                            formGroup.get("cabinClass").value
                                            }}</span>
                                    </div>
                                    }
                                    @if (i != 0 && i === formDataList.length - 1) {
                                    <div class="flex items-center gap-1 space-x-1 ">
                                        @if (i > 1) {
                                        <button mat-flat-button class="rounded-md primary-border border border-solid"
                                            (click)="removeCity(i)">
                                            <mat-icon class="material-symbols-outlined"><span
                                                    class="text-3xl primary-text">close</span></mat-icon>
                                        </button>
                                        }
                                        @if (i < 4) { <button mat-flat-button
                                            class="rounded-md font-semibold text-[15px] primary-text primary-border border border-solid"
                                            (click)="addCity(i)">
                                            + Add Another City
                                            </button>
                                            }
                                    </div>
                                    }
                                </div>
                                }
                            </div>
                            }
                            @if (formGroup.get('type').value != 'mc') {
                            <div class="flex flex-col flex-grow p-3 pt-[13px] rounded-2xl bg-white h-[74px] w-full">
                                <span class="max-w-max text-secondary text-[15px] font-normal">Travellers
                                    | Class</span>
                                <span class="truncate font-semibold text-black text-lg max-w-full cursor-pointer"
                                    (click)="travellersClass()"
                                    [matTooltip]="formGroup.get('adult').value + formGroup.get('child').value + formGroup.get('infant').value + 'Pax, ' +  formGroup.get('cabinClass').value">
                                    {{formGroup.get("adult").value + formGroup.get("child").value +
                                    formGroup.get("infant").value}} Pax, {{ formGroup.get("cabinClass").value
                                    }}</span>
                            </div>
                            }
                            <div class="flex flex-row justify-end items-start">
                                <button mat-flat-button class="rounded-xl min-h-[74px] primary-bg" (click)="detail()">
                                    <mat-icon class="text-white invert w-8 h-8" svgIcon="feather:search"></mat-icon>
                                </button>
                            </div>
                        </div>
                        @if (formGroup.get('type').value != 'ab') {
                        <div class="flex items-center gap-[16px] my-4">
                            <span class="font-medium text-white">Special Fare:</span>
                            <div class="flex flex-row items-center space-x-3">
                                <mat-radio-group class="h-[30px] gap-1" formControlName="fareType"
                                    (change)="CheckFareTypeValidation()" aria-label="Special Fare Selection">
                                    <div class="flex flex-row space-x-6">
                                        @for (fare of fareType; track fare) {
                                        <mat-radio-button class="radio-white" [value]="fare.key">
                                            <div class="cursor-pointer font-normal text-lg pl-1 pt-[3px]"
                                                [ngClass]="fare.key == this.formGroup.get('fareType').value ? 'primary-text font-medium' :'text-white'">
                                                {{fare.key}}
                                            </div>
                                        </mat-radio-button>
                                        }
                                    </div>
                                </mat-radio-group>
                            </div>
                        </div>
                        }
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
}
}